const localizations = {
  'button.cancel': 'キャンセル',
  'button.delete': '削除',
  'button.close': '閉じる',
  'button.select': '選択',
  'button.selected': '選択された',
  'button.save-changes': '変更内容を保存する',
  'button.yes-delete': 'はい、削除',
  'button.reset': 'リセット',
  'button.reload': 'リロード',
  'button.to-dashboard': 'ダッシュボードページに戻る',
  'button.to-navigation': 'ナビゲーションページに戻る',
  'button.back': '戻る',
  'button.login': 'ログインページへ',
  'code-preview.copied': 'コピーした',
  'code-preview.copy': 'コードをコピーする',
  'app.contact-integrator.notification': 'これらの機能を使用する必要がある場合は、統合管理者にお問い合わせください。',
  'app.multi-select.countries.selected': '{total}カ国中{number}カ国を選択しました',
  'app.multi-select.unselect': 'すべて選択解除',
  'app.multi-select.search': '検索',
  'app.multi-select.empty': '何も見つかりません',

  'app.success.title': '成功',

  'app.error.title': 'エラー',
  'app.error.submit-form': 'フォームを提出する際にエラーが発生しました。',
  'app.error.page.label': '全ページを読み込むことができません',
  'app.error.page.text': 'プロジェクトページの部分の読み込みに失敗しました。<br></br>ナビゲーションページに戻ります。',
  'app.error.page.footer': '<doc>ドキュメンテーション</doc> • <help>ヘルプ</help> • <chat>お問い合わせ</chat>',
  'app.error.statistic.tooltip': 'このデータを取得する際に何か問題が発生しました。後でもう一度試してください。',
  'app.error.user-groups.tooltip': 'ユーザーグループを取得する際に何か問題が発生しました。後でもう一度試してください。',
  'app.error.000-000': '問題が発生しました。',
  /* Checklist errors */
  'app.error.011-001': 'チェックリストの取得に失敗した。',
  'app.error.011-002': 'チェックポイントの作成に失敗しました。',
  'app.error.011-003': 'チェックポイントの削除に失敗しました。',
  'app.error.011-004': 'チェックポイントをチェック済みとする誤ったリクエスト。',
  'app.error.011-005': 'プロジェクトチェックリストの進行状況の誤ったリクエスト。',
  /* User storage errors */
  'app.error.008-001': 'パスワードレスログインURLが構成されていません。',
  'app.error.008-002': 'ユーザー認証URLが構成されていません。',
  'app.error.008-003': '新規ユーザーURLが構成されていません。',
  'app.error.008-004': 'パスワードリセットURLが構成されていません。',
  'app.error.008-005': 'PlayFabタイトルIDが無効です。',
  'app.error.008-006': 'PlayFabのAPIキーが無効です。',
  'app.error.008-007': 'メールによる外部アカウントIDの取得URLが無効です。',
  'app.error.008-008': 'APIからの無効応答。「accountID 」応答本文パラメータにユーザーIDが含まれている必要があります。',
  'app.error.008-009': 'カスタムストレージの設定の無効URL。',
  'app.error.008-010': 'アスクページのURLが構成されていません。',
  'app.error.008-011': '新しいパスワードの設定ページのURLが構成されていません。',
  'app.error.008-012': '選択可能な値の形式が無効です。',
  'app.error.008-013': '同意ページのURLが構成されていませんか、無効です。',
  'app.error.008-014': 'Oktaの統合が完了しません。',
  'app.error.008-015': 'SAML統合が完了していません。',
  'app.error.008-016': 'Firebase APIキーが設定されていません。',
  /* Custom SMS provider */
  'app.error.012-001': '誤ったカスタムSMSプロバイダー管理リクエスト。',
  'app.error.012-002': 'この名前のプロバイダーはすでに存在しています。',
  'app.error.012-003': 'カスタムプロバイダーが見つかりません。',
  'app.error.012-004': '指定されたパラメータを持つプロバイダーを作成できません。',
  /* MFA*/
  'app.error.003-055': 'MFA URL の値が正しくありません。別の URL を入力してください。',
  /* Custom email template */
  'app.error.003-070': 'カスタムメールテンプレートのカスタム変数は、メール用のデフォルトのエクソーラ変数と同じです。',
  'app.error.003-071': 'カスタムメールテンプレートが見つかりません。',
  'app.error.003-072': 'カスタムメールテンプレートの不正なリクエスト。',
  'app.error.003-073': 'カスタムメールテンプレートで不明なエラーが発生しました。もう一度試してください。',
  'app.error.003-074': 'このtemplate_idを持つテンプレートは、このログインプロジェクトに既に存在しています。',
  'app.error.003-075': 'まず、英語ロケール用のメールテンプレートを作成する必要があります。',
  'app.error.003-076': '他のロケール用のテンプレートがある場合、英語ロケール用のカスタムメールテンプレートを削除することはできません。',
  'app.error.003-077': 'このロケールのカスタムテンプレートは、このログインプロジェクトにすでに存在しています。',
  'app.error.003-078': 'このロケール用のカスタムテンプレートは、このログインプロジェクトには存在しません。',
  'app.error.003-079': 'このタイプは、SMSテンプレートでは禁止されています。',
  'app.error.003-080': 'カスタムテンプレートが見つかりません。',
  'app.error.003-081': 'テンプレートにコードのタグが含まれません。',
  'app.error.003-082': 'テンプレートのサイズが大きすぎます。短いテキストを試してください。',
  'app.error.003-083': 'ロケールが無効です。',
  /* Webhooks */
  'app.error.004-001': 'イベント動作が見つかりません。',
  'app.error.004-002': 'イベント用ウェブフックは既に最大数（3）に構成されています。',
  'app.error.004-003': '指定されたURLのウェブフックは既に指定されたタイプのイベントに構成されています。',
  'app.error.004-004': '指定されたURLは禁止されています。',
  /* Project errors */
  'app.error.003-019': 'プロジェクトが見つかりません。',
  'app.error.003-024': 'このログインプロジェクトでは、パスワードのリセットが無効になっています。',
  'app.error.003-022': 'このログインプロジェクトの構成が間違っています。',
  'app.error.003-021': 'このログインプロジェクトでは、認証が無効になっています。',
  'app.error.003-102': 'パスキーを唯一のログイン方法にすることはできません。少なくとも別のログイン方法を一つ以上有効にしておいてください。',
  'app.error.003-023': 'このログインプロジェクトは登録不可です。',
  'app.error.003-064': "複数のシャドウログインプロジェクトを持つことはできません。",
  'app.error.002-071': 'ログインプロジェクト数の上限を超えました。',
  /* Server errors */
  'app.error.000-001': '内部サーバーエラーです。',
  'app.error.003-061': 'オブジェクトが見つかりません。',
  'app.error.010-004': 'サービスは一時的に利用できません。',
  'app.error.010-050': '期限超過。',
  /* Social errors */
  'app.error.002-065': 'この操作は、デフォルトのソーシャルプロバイダーアプリではできません。',
  'app.error.010-037': 'ソーシャルプロバイダーが見つかりません。',
  'app.error.010-043': 'ソーシャルネットワークの認証情報が無効です。',
  'app.error.010-044': 'ソーシャルプロフィールが見つかりません。',
  'app.error.010-006': "連携解除失敗：これがユーザーの唯一のログイン方法です。",
  /* User errors */
  'app.error.002-054': '許容される検索試行回数を超えました。次のリクエストまで1秒お待ちください。',
  'app.error.002-056': '無効な電話番号。',
  'app.error.003-007': 'ユーザーアカウントが確認されていません。',
  'app.error.003-004': '指定されたメールアドレスを持つユーザーはすでに存在しています。',
  'app.error.003-012': '指定された電話番号のユーザーがすでに存在しています。',
  'app.error.003-008': 'ユーザーアカウントが確認されていません。',
  'app.error.003-009': 'ユーザー検索のリクエストが間違っています。',
  'app.error.003-010': 'このメールアドレスは、ユーザーが既に確認済みです。',
  'app.error.009-005': "ユーザーエクスポートの制限に達しました。後で再試行してください。",
  /* Validation errors */
  'app.error.002-038': '設定状態は、有効なJSON文字列である必要があります。',
  'app.error.002-039': 'バリデーション設定を保存できませんでした。後でもう一度試してください。',
  'app.error.002-041': '指定されたパラメータを持つフィールドの作成に失敗しました。',
  'app.error.002-042': 'このAPIメソッドで指定された名前のフィールドを変更することはできません。',
  'app.error.002-047': '下の「接続を解除」ボタンをクリックしてください。その後、Mailchimp IDを使用し、オーディエンスを選択して、再度お試しください。',
  'app.error.002-048': '下の「接続を解除」ボタンをクリックしてください。その後、Mailchimp IDを使用し、オーディエンスを選択して、再度お試しください。',
  /* Attributes errors */
  'app.error.060-001': 'ユーザー属性が現在のJSONスキーマに対応していません。',
  'app.error.060-002': '属性が重複しています。',
  'app.error.060-003': '渡された属性の形式が無効です。',
  'app.error.060-004': 'JSONスキーマが無効で、または、定義された属性のネスティングレベルが1より高くなっています。',
  /* Role errors */
  'app.error.010-049': "このページへのアクセス権がありません。あなた側のプロジェクト管理者に連絡してください。",
  /* Token errors */
  'app.error.999-999': "もう一度ログインしてみてください。",
  /* Custom OAuth 2.0 error */
  'app.error.013-003': "この名前のカスタムIDプロバイダは、別のプロジェクトにすでに存在しています。別の名前を使用してください。",

  'app.error-title.mailchimp-not-found': 'Mailchimpオーディエンスが見つかりません',

  'app.validation.required': 'このフィールドは必須です。',
  'app.validation.characters': '最大文字数：{number}文字。',
  'app.validation.characters.min': '最小文字数：{minNumber}文字。',
  'app.validation.characters-only-hyphen-underscore': '英数字が使用できます。ハイフンとアンダースコアも使えますが、先頭や末尾に使用すること、および2つ以上連続させることはできません。',
  'app.validation.url-invalid': '無効URL',
  'app.validation.url-duplicate': "重複したURLは追加できません",
  'app.validation.value-invalid': '無効な値です',
  'app.validation.value-less': '価値は{number}以上である必要があります',
  'app.validation.value-more': '価値は{number}以下である必要があります',
  'app.validation.phone-invalid': '無効な電話番号のフォーマット',
  'app.validation.not-project-name': '無効なプロジェクト名',
  'app.validation.mailchimp-key-length': '36文字または37文字の API キーを入力してください。',
  'app.validation.old-widget-version-incorrect': 'CSSのバージョン（{cssVersion}）は、ウィジェットのバージョン（{widgetVersion}）に対応している必要があります。CSSのバージョンを{widgetVersion}に変更してください。',
  'app.validation.json-schema': 'スキーマは有効なJSONオブジェクトではありません。',
  "app.validation.color.hex": "色は有効なHEX値でなければなりません",
  "app.validation.logo_url.required": "ロゴ画像は必須です",
  "app.validation.logo_url.upload-error": "画像をアップロードできません。もう一度試してください",
  "app.validation.logo_url.size-error": "300KB以下の画像をアップロードしてください",
  "app.validation.custom_style.upload-error": "CSSファイルをアップロードできません。もう一度試してください",
  "app.validation.duplicate.valid-url": "URLがすでに存在しています。同じURLを2回追加しないでください。",
  "app.validation.cors-origin-only": "CORSオリジンにURLパスを含めることはできません。",

  'form.select.country-name.AD': 'アンドラ',
  'form.select.country-name.AE': 'アラブ首長国連邦',
  'form.select.country-name.AF': 'アフガニスタン',
  'form.select.country-name.AG': 'アンティグア・バーブーダ',
  'form.select.country-name.AI': 'アンギラ',
  'form.select.country-name.AL': 'アルバニア',
  'form.select.country-name.AM': 'アルメニア',
  'form.select.country-name.AO': 'アンゴラ',
  'form.select.country-name.AQ': '南極大陸',
  'form.select.country-name.AR': 'アルゼンチン',
  'form.select.country-name.AS': 'アメリカ領サモア',
  'form.select.country-name.AT': 'オーストリア',
  'form.select.country-name.AU': 'オーストラリア',
  'form.select.country-name.AW': 'アルバ',
  'form.select.country-name.AX': 'オーランド諸島',
  'form.select.country-name.AZ': 'アゼルバイジャン',
  'form.select.country-name.BA': 'ボスニア・ヘルツェゴビナ',
  'form.select.country-name.BB': 'バルバドス',
  'form.select.country-name.BD': 'バングラディシュ',
  'form.select.country-name.BE': 'ベルギー',
  'form.select.country-name.BF': 'ブルキナファソ',
  'form.select.country-name.BG': 'ブルガリア',
  'form.select.country-name.BH': 'バーレーン',
  'form.select.country-name.BI': 'ブルンジ',
  'form.select.country-name.BJ': 'ベナン',
  'form.select.country-name.BL': 'サン・バルテルミー島',
  'form.select.country-name.BM': 'バミューダ諸島',
  'form.select.country-name.BN': 'ブルネイ',
  'form.select.country-name.BO': 'ボリビア',
  'form.select.country-name.BQ': 'ボネール、シント・ユースタティウスおよびサバ',
  'form.select.country-name.BR': 'ブラジル',
  'form.select.country-name.BS': 'バハマ',
  'form.select.country-name.BT': 'ブータン',
  'form.select.country-name.BV': 'ブーべ島',
  'form.select.country-name.BW': 'ボツワナ',
  'form.select.country-name.BY': 'ベルラーシ',
  'form.select.country-name.BZ': 'ベリーズ',
  'form.select.country-name.CA': 'カナダ',
  'form.select.country-name.CC': 'ココス（キーリング）島',
  'form.select.country-name.CD': 'コンゴ民主共和国',
  'form.select.country-name.CF': '中央アフリカ共和国',
  'form.select.country-name.CG': 'コンゴ',
  'form.select.country-name.CH': 'スイス',
  'form.select.country-name.CI': "コートジボワール",
  'form.select.country-name.CK': 'クック諸島',
  'form.select.country-name.CL': 'チリ',
  'form.select.country-name.CM': 'カメルーン',
  'form.select.country-name.CN': '中国',
  'form.select.country-name.CO': 'コロンビア',
  'form.select.country-name.CR': 'コスタリカ',
  'form.select.country-name.CU': 'キューバ',
  'form.select.country-name.CV': 'カーボベルデ',
  'form.select.country-name.CW': 'キュラソー島',
  'form.select.country-name.CX': 'クリスマス島',
  'form.select.country-name.CY': 'キプロス',
  'form.select.country-name.CZ': 'チェコ共和国',
  'form.select.country-name.DE': 'ドイツ',
  'form.select.country-name.DJ': 'ジブチ',
  'form.select.country-name.DK': 'デンマーク',
  'form.select.country-name.DM': 'ドミニカ',
  'form.select.country-name.DO': 'ドミニカ共和国',
  'form.select.country-name.DZ': 'アルジェリア',
  'form.select.country-name.EC': 'エクアドル',
  'form.select.country-name.EE': 'エストニア',
  'form.select.country-name.EG': 'エジプト',
  'form.select.country-name.EH': '西サハラ',
  'form.select.country-name.ER': 'エリトリア',
  'form.select.country-name.ES': 'スペイン',
  'form.select.country-name.ET': 'エチオピア',
  'form.select.country-name.FI': 'フィンランド',
  'form.select.country-name.FJ': 'フィジー',
  'form.select.country-name.FK': 'フォークランド諸島',
  'form.select.country-name.FM': 'ミクロネシア連邦',
  'form.select.country-name.FO': 'フェロー諸島',
  'form.select.country-name.FR': 'フランス',
  'form.select.country-name.GA': 'ガボン',
  'form.select.country-name.GB': 'イギリス',
  'form.select.country-name.GD': 'グレナダ',
  'form.select.country-name.GE': 'ジョージア',
  'form.select.country-name.GF': 'フランス領ギアナ',
  'form.select.country-name.GG': 'ガーンジー',
  'form.select.country-name.GH': 'ガーナ',
  'form.select.country-name.GI': 'ジブラルタル',
  'form.select.country-name.GL': 'グリーンランド',
  'form.select.country-name.GM': 'ガンビア',
  'form.select.country-name.GN': 'ギニア',
  'form.select.country-name.GP': 'グアドループ',
  'form.select.country-name.GQ': '赤道ギニア',
  'form.select.country-name.GR': 'ギリシャ',
  'form.select.country-name.GS': 'サウスジョージア・サウスサンドウィッチ諸島',
  'form.select.country-name.GT': 'ガテマラ',
  'form.select.country-name.GU': 'グアム',
  'form.select.country-name.GW': 'ギニアビサウ',
  'form.select.country-name.GY': 'ガイアナ',
  'form.select.country-name.HK': '香港',
  'form.select.country-name.HM': 'ハード島・マクドナルド諸島',
  'form.select.country-name.HN': 'ホンジュラス',
  'form.select.country-name.HR': 'クロアチア',
  'form.select.country-name.HT': 'ハイチ',
  'form.select.country-name.HU': 'ハンガリー',
  'form.select.country-name.ID': 'インドネシア',
  'form.select.country-name.IE': 'アイルランド',
  'form.select.country-name.IL': 'イスラエル',
  'form.select.country-name.IM': 'マン島',
  'form.select.country-name.IN': 'インド',
  'form.select.country-name.IO': 'イギリス領インド洋地域',
  'form.select.country-name.IQ': 'イラク',
  'form.select.country-name.IR': 'イラン',
  'form.select.country-name.IS': 'アイスランド',
  'form.select.country-name.IT': 'イタリア',
  'form.select.country-name.JE': 'ジャージー島',
  'form.select.country-name.JM': 'ジャマイカ',
  'form.select.country-name.JO': 'ヨルダン',
  'form.select.country-name.JP': '日本',
  'form.select.country-name.KE': 'ケニア',
  'form.select.country-name.KG': 'キルギスタン',
  'form.select.country-name.KH': 'カンボジア',
  'form.select.country-name.KI': 'キリバス',
  'form.select.country-name.KM': 'コモロ',
  'form.select.country-name.KN': 'セントクリストファー・ネイビス',
  'form.select.country-name.KP': '北朝鮮',
  'form.select.country-name.KR': '韓国',
  'form.select.country-name.KW': 'クウェート',
  'form.select.country-name.KY': 'ケイマン諸島',
  'form.select.country-name.KZ': 'カザフスタン',
  'form.select.country-name.LA': 'ラオス',
  'form.select.country-name.LB': 'レバノン',
  'form.select.country-name.LC': 'セントルシア',
  'form.select.country-name.LI': 'リヒテンシュタイン',
  'form.select.country-name.LK': 'スリランカ',
  'form.select.country-name.LR': 'リベリア',
  'form.select.country-name.LS': 'レソト',
  'form.select.country-name.LT': 'リトアニア',
  'form.select.country-name.LU': 'ルクセンブルク',
  'form.select.country-name.LV': 'ラトビア',
  'form.select.country-name.LY': 'リビア',
  'form.select.country-name.MA': 'モロッコ',
  'form.select.country-name.MC': 'モナコ',
  'form.select.country-name.MD': 'モルドバ',
  'form.select.country-name.ME': 'モンテネグロ',
  'form.select.country-name.MF': 'サンマルタン',
  'form.select.country-name.MG': 'マダガスカル',
  'form.select.country-name.MH': 'マーシャル諸島',
  'form.select.country-name.MK': 'マケドニア',
  'form.select.country-name.ML': 'マリ',
  'form.select.country-name.MM': 'ミャンマー',
  'form.select.country-name.MN': 'モンゴル',
  'form.select.country-name.MO': 'マカオ',
  'form.select.country-name.MP': '北マリアナ諸島',
  'form.select.country-name.MQ': 'マルティニーク',
  'form.select.country-name.MR': 'モーリタニア',
  'form.select.country-name.MS': 'モントセラト',
  'form.select.country-name.MT': 'マルタ',
  'form.select.country-name.MU': 'モーリシャス',
  'form.select.country-name.MV': 'モルディブ',
  'form.select.country-name.MW': 'マラウイ',
  'form.select.country-name.MX': 'メキシコ',
  'form.select.country-name.MY': 'マレーシア',
  'form.select.country-name.MZ': 'モザンビーク',
  'form.select.country-name.NA': 'ナミビア',
  'form.select.country-name.NC': 'ニューカレドニア',
  'form.select.country-name.NE': 'ニジェール',
  'form.select.country-name.NF': 'ノーフォーク島',
  'form.select.country-name.NG': 'ナイジェリア',
  'form.select.country-name.NI': 'ニカラグア',
  'form.select.country-name.NL': 'オランダ',
  'form.select.country-name.NO': 'ノルウェー',
  'form.select.country-name.NP': 'ネパール',
  'form.select.country-name.NR': 'ナウル',
  'form.select.country-name.NU': 'ニウエ',
  'form.select.country-name.NZ': 'ニュージーランド',
  'form.select.country-name.OM': 'オマーン',
  'form.select.country-name.PA': 'パナマ',
  'form.select.country-name.PE': 'ペルー',
  'form.select.country-name.PF': 'フランス領ポリネシア',
  'form.select.country-name.PG': 'パプアニューギニア',
  'form.select.country-name.PH': 'フィリピン',
  'form.select.country-name.PK': 'パキスタン',
  'form.select.country-name.PL': 'ポーランド',
  'form.select.country-name.PM': 'サンピエール島・ミクロン島',
  'form.select.country-name.PN': 'ピトケアン諸島',
  'form.select.country-name.PR': 'プエルトリコ',
  'form.select.country-name.PS': 'パレスチナ',
  'form.select.country-name.PT': 'ポルトガル',
  'form.select.country-name.PW': 'パラオ',
  'form.select.country-name.PY': 'パラグアイ',
  'form.select.country-name.QA': 'カタール',
  'form.select.country-name.RE': 'レユニオン',
  'form.select.country-name.RO': 'ルーマニア',
  'form.select.country-name.RS': 'セルビア',
  'form.select.country-name.RU': 'ロシア',
  'form.select.country-name.RW': 'ルワンダ',
  'form.select.country-name.SA': 'サウジアラビア',
  'form.select.country-name.SB': 'ソロモン諸島',
  'form.select.country-name.SC': 'セイシェル',
  'form.select.country-name.SD': 'スーダン',
  'form.select.country-name.SE': 'スウェーデン',
  'form.select.country-name.SG': 'シンガポール',
  'form.select.country-name.SH': 'セントヘレナ・アセンションおよびトリスタンダクーニャ',
  'form.select.country-name.SI': 'スロベニア',
  'form.select.country-name.SJ': 'スヴァールバル諸島およびヤンマイエン島',
  'form.select.country-name.SK': 'スロバキア',
  'form.select.country-name.SL': 'シエラレオネ',
  'form.select.country-name.SM': 'サンマリノ',
  'form.select.country-name.SN': 'セネガル',
  'form.select.country-name.SO': 'ソマリア',
  'form.select.country-name.SR': 'スリナム',
  'form.select.country-name.SS': '南スーダン',
  'form.select.country-name.ST': 'サントメ・プリンシペ',
  'form.select.country-name.SV': 'エルサルバドル',
  'form.select.country-name.SX': 'シント・マールテン',
  'form.select.country-name.SY': 'シリア',
  'form.select.country-name.SZ': 'エスワティニ',
  'form.select.country-name.TC': 'タークス・カイコス諸島',
  'form.select.country-name.TD': 'チャド',
  'form.select.country-name.TF': 'フランス領南方・南極地域',
  'form.select.country-name.TG': 'トーゴ',
  'form.select.country-name.TH': 'タイ',
  'form.select.country-name.TJ': 'タジキスタン',
  'form.select.country-name.TK': 'トケラウ諸島',
  'form.select.country-name.TL': '東ティモール',
  'form.select.country-name.TM': 'トルクメニスタン',
  'form.select.country-name.TN': 'チュニジア',
  'form.select.country-name.TO': 'トンガ',
  'form.select.country-name.TR': 'トルコ',
  'form.select.country-name.TT': 'トリニダード・トバゴ',
  'form.select.country-name.TV': 'ツバル',
  'form.select.country-name.TW': '台湾',
  'form.select.country-name.TZ': 'タンザニア',
  'form.select.country-name.UA': 'ウクライナ',
  'form.select.country-name.UG': 'ウガンダ',
  'form.select.country-name.UM': '合衆国領有小離島',
  'form.select.country-name.US': 'アメリカ合衆国',
  'form.select.country-name.UY': 'ウルグアイ',
  'form.select.country-name.UZ': 'ウズベキスタン',
  'form.select.country-name.VA': 'バチカン市国',
  'form.select.country-name.VC': 'セントビンセント・グレナディーン',
  'form.select.country-name.VE': 'ベネズエラ',
  'form.select.country-name.VG': 'イギリス領ヴァージン諸島',
  'form.select.country-name.VI': 'アメリカ領ヴァージン諸島',
  'form.select.country-name.VN': 'ベトナム',
  'form.select.country-name.VU': 'バヌアツ',
  'form.select.country-name.WF': 'ウォリス・フツナ',
  'form.select.country-name.WS': 'サモア',
  'form.select.country-name.YE': 'イエメン',
  'form.select.country-name.YT': 'マヨット',
  'form.select.country-name.ZA': '南アフリカ',
  'form.select.country-name.ZM': 'ザンビア',
  'form.select.country-name.ZW': 'ジンバブエ',
  'form.select.country-name.AN': 'アンティル諸島',
  'form.select.country-name.XK': 'コソボ',
  'form.select.country-name.XX': '自動判別',

  'form.language.ar': 'アラビア語',
  'form.language.bg': 'ブルガリア語',
  'form.language.cn': '中国語（簡体字）',
  'form.language.cs': 'チェコ語',
  'form.language.de': 'ドイツ語',
  'form.language.en': '英語',
  'form.language.es': 'スペイン語',
  'form.language.fr': 'フランス語',
  'form.language.he': 'ヘブライ語',
  'form.language.hu': 'ハンガリー語',
  'form.language.it': 'イタリア語',
  'form.language.ja': '日本語',
  'form.language.ko': '韓国語',
  'form.language.pl': 'ポーランド語',
  'form.language.pt': 'ポルトガル語',
  'form.language.ro': 'ルーマニア語',
  'form.language.ru': 'ロシア語',
  'form.language.th': 'タイ語',
  'form.language.tr': 'トルコ語',
  'form.language.zh_TW': '中国語（繁体字）',
  'form.language.vi': 'ベトナム語',
  'form.language.zh_CN': '中国語（簡体字）',

  'agreement.not-signed.notification': 'カスタマイゼーションは、製品使用許諾契約を締結した場合のみ可能です。サインをするには、<a>契約</a>に移動します。',

  'statistics.label': '統計',

  'analytics.selectors.date.placeholder': '日付の選択',
  'analytics.selectors.all-logins.title': 'ログインネーム',
  'analytics.selectors.all-logins.placeholder': '全てのログインプロジェクト',
  'analytics.selectors.all-countries.title': '国',
  'analytics.selectors.all-countries.placeholder': 'すべての国',
  'analytics.charts.empty.title': '十分なデータがありません',
  'analytics.charts.empty.description': 'このグラフを生成するには、より多くのデータが必要です。',
  'analytics.charts.loading': '読み込み中...',
  'analytics.charts.failed.title': '読み込みに失敗しました',
  'analytics.charts.failed.description': '現在の接続状況を確認して、再度実行してください。',
  'analytics.charts.failed.refresh': 'グラフを更新する',
  'analytics.charts.active-users': 'アクティブユーザー',
  'analytics.charts.active-users.legend': 'デイリーアクティブユーザー',
  'analytics.charts.active-users.plot': 'デイリーアクティブユーザー',
  'analytics.charts.active-users.total': '合計数',
  'analytics.charts.active-users.label': '選択期間以前の {days, number}{days, plural, other {日間}} と比較',
  'analytics.charts.auth-methods': '認証方法',
  'analytics.charts.auth-methods.legend': '認証件数',
  'analytics.charts.countries': '国で認証',
  'analytics.charts.countries.title': 'アクティブユーザー',

  'welcome-modal.title': '新しいログイン体験へようこそ',
  'welcome-modal.subtitle': '一新されたインターフェイスで、最高のログイン体験を提供します。',
  'welcome-modal.update-list.login-method': 'ログイン方法を選択し、対応する設定を行います',
  'welcome-modal.update-list.checklist': 'チェックリストとコンテンツ依存のブロックによる指示でログイン構成を加速します',
  'welcome-modal.update-list.try-login': '起動する前に、ログインプロジェクトとすべての接続をテストしてください',
  'welcome-modal.footer.try-new': '新しいログインに移動する',
  'welcome-modal.help-research.title': 'ログインの改善にご協力ください',
  'welcome-modal.help-research.description': 'ユーザビリティテストへの参加や、新しいログインに関するフィードバックは、<a>login@xsolla.com</a>までお問い合わせください。',

  'change-version.notification.back-old': '旧バージョンのログインは2022年3月に新バージョンに更新される予定です。新しいものをチェックするか{link}',
  'change-version.notification.back-old.link': '必要に応じて旧バージョンに戻します。',
  'change-version.notification.check-new': '旧バージョンのログインは、2022年3月に新バージョンに更新される予定です。 {link}',
  'change-version.notification.check-new.link': '新バージョンをチェックしてください。',

  'dashboard.label': 'ダッシュボード',
  'dashboard.new-login': '新規ログインプロジェクト',
  'dashboard.new-login.master': '標準のログインプロジェクトを作成する',
  'dashboard.new-login.shadow': 'シャドウログインプロジェクトを作成する',
  'dashboard.new-login.shadow.description': 'プラットフォームアカウントの保存に使用されるログインプロジェクト',
  'dashboard.new-login.babka-login': '新しいOAuth 2.0クライアント',
  'dashboard.login-card.loginId': 'ログインID',
  'dashboard.login-card.publishertId': 'プロジェクトID',
  'dashboard.login-card.date': '変更された {date}',
  'dashboard.login-card.copy': 'IDをコピーする',
  'dashboard.login-card.copied': 'コピーした',
  'dashboard.login-card.statistics.users': '合計ユーザー数',
  'dashboard.login-card.statistics.mau': 'MAU',
  'dashboard.login-card.statistics.mau.help': 'このログインプロジェクトの過去30日間の一意のアクティブユーザー数。',
  'dashboard.login-card.statistics.new-users': '新規ユーザー',
  'dashboard.login-card.statistics.new-users.help': '過去30日間のこのログインプロジェクトの新規ユーザー数。',
  'dashboard.login-card.button': '構成',
  'dashboard.login-card.steps.button': '次のステップ',
  'dashboard.login-card.steps.label': '次のログイン統合ステップ',
  'dashboard.login-card.steps.completed': '完了したステップ',
  'dashboard.help.label': 'すべてのステップでサポートを受ける',
  'dashboard.help.faq.label': 'よくある質問',
  'dashboard.help.faq.text': 'エクソーラログインに関する一般的な質問への回答を見つけてください。',
  'dashboard.help.documentation.label': '開発者説明書',
  'dashboard.help.documentation.text': 'ログイン統合ガイドと例をご覧ください。',
  'dashboard.help.ask.label': 'お問い合わせ',
  'dashboard.help.ask.text-contact': 'ヘルプが必要ですか？<a>統合チームに連絡してください。</a>',
  'dashboard.help.ask.text-feedback': 'コメント？<a>フィードバックを残す</a>',
  'dashboard.connections.label': '接続',
  'dashboard.connections.website': 'ウェブサイト',
  'dashboard.connections.launcher': 'ランチャー',
  'dashboard.connections.show-all': 'すべて表示する',
  'dashboard.connections.hide-all': 'すべて非表示する',
  'dashboard.connections.add': 'ウェブサイトを追加する',
  'dashboard.connections.save': '保存',
  'dashboard.connections.info': 'ランチャーをこのログインプロジェクトに接続するには、<a>アカウント内のランチャーセクションへ移動してください</a>。',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=9121%3A38854
  'try-login.modal.title': 'ウィジェットを確認する？',
  'try-login.modal.text': 'ウィジェットが正しく動作することを確認するために、このログインプロジェクトの最初のユーザーとしてログインしてテストする必要があります。メインアカウントを使用するか、テストユーザーアカウントを作成することができます。',
  'try-login.modal.button.later': '後で確認する',
  'try-login.modal.button.now': 'はい、確認する',
  'try-login.checklist.title': 'ウィジェットを確認する',
  'try-login.checklist.text': 'メインアカウントまたはテストアカウントでログインして、ウィジェットが正しく動作することを確認できます。',
  'try-login.checklist.button': '今すぐ確認する',
  'try-login.success.title': 'このログインプロジェクトは正常に動作します',
  'try-login.success.features.label': '以下の機能を確認します：',
  'try-login.success.support.label': 'サポートを受ける',
  'try-login.success.support.integration': '簡易統合についてはこちら',
  'try-login.success.support.help': 'ヘルプセンターを探す',
  'try-login.error.title': '何らかのエラーが起きました',
  'try-login.error.text': 'エラーコード：{code}',
  'try-login.error.social': '現在、ログインウィジェットは、テストモードではソーシャルログインに対応していません。<a>製品モードでソーシャルログインを試してください</a>。',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=2224%3A58397 */
  'users.settings.all-users': 'すべてのユーザー', // TODO для задаче по добавлению выборки забаниных/активных пользователей
  'users.settings.back': '<b>ユーザーデータベース</b>へ戻る',
  'users.settings.general-info.label': '基本情報',
  'users.settings.general-info.external': 'External ID',
  'users.settings.general-info.server-customer': 'Server Customer ID',
  'users.settings.general-info.nickname': 'ニックネーム {nickname}',
  'users.settings.general-info.reset-pass': 'パスワードのリセット',
  'users.settings.general-info.ban-user': '禁止ユーザー',
  'users.settings.general-info.unban-user': 'ユーザーのアクセス禁止を解除する',
  'users.settings.general-info.registred': '登録日',
  'users.settings.general-info.show-login-history': 'ログイン履歴を表示',
  'users.settings.general-info.hide-login-history': 'ログイン履歴を非表示',
  'users.settings.general-info.data-fetching-error': 'ログイン履歴データの取得中にエラーが発生しました',
  'users.settings.general-info.no-login-history': 'ログイン履歴はありません',
  'users.settings.general-info.table.date': '日付',
  'users.settings.general-info.table.country': '国',
  'users.settings.general-info.table.city': '都市',
  'users.settings.general-info.table.ip-address': 'IPアドレス',
  'users.settings.group.label': 'グループ',
  'users.settings.group.input-label': 'グループ',
  'users.settings.group.select.add': 'グループを追加',
  'users.settings.contact-info.label': '連絡先情報',
  'users.settings.contact-info.primary-email.label': 'メインのメールアドレス',
  'users.settings.contact-info.primary-email.resend': '確認メールの再送信',
  'users.settings.contact-info.primary-email.resend.sucesss': '確認メールが送信されました。',
  'users.settings.contact-info.primary-phone.label': '電話番号',
  'users.settings.contact-info.primary-email.checkbox': '新しい主メールアドレスの確認メールをスキップする',
  'users.settings.additional-info.label': '追加情報',
  'users.settings.additional-info.country': '国',
  'users.settings.additional-info.age': '年齢',
  'users.settings.email.validation.invalid': 'メールアドレスが無効な形式です。',
  'users.settings.phone.validation.min': '最小文字数：8文字。',
  'users.settings.phone.validation.max': '最大文字数：14文字。',
  'users.settings.delete-user.button': 'ユーザーアカウントを削除する',
  'users.settings.delete-user.subtitle': '削除されたユーザーアカウントは復元できません。',
  'users.settings.delete-user.alert.title': 'ユーザーアカウントを削除しますか？',
  'users.settings.delete-user.alert.subtitle': '削除されたユーザーアカウントは復元できません。',
  'users.settings.delete-user.alert.checked-understand': 'はい、わかりました',
  'users.settings.update-email.modal.title': 'このメールアドレスのユーザーを変更しますか？',
  'users.settings.update-email.modal.subtitle': '{id} IDを持つユーザーがこのメールアドレスを使用しています。ユーザーを変更すると、以前のユーザーのアカウントはこのメールアドレスにリンクが解除されます。',
  'users.settings.update-email.modal.checkbox': '同意する',
  'users.settings.update-email.modal.submit': 'はい、変更する',
  'users.settings.general-info.login-type.device': 'デバイス',
  'users.settings.general-info.login-type.email': 'パスワードレスのメール',
  'users.settings.general-info.login-type.firebase': 'Firebase',
  'users.settings.general-info.login-type.import': '輸入',
  'users.settings.general-info.login-type.phone': 'パスワードレスの電話',
  'users.settings.general-info.login-type.playfab': 'Playfab',
  'users.settings.general-info.login-type.proxy': 'プロキシ',
  'users.settings.general-info.login-type.server_custom_id': 'サーバーのカスタムID',
  'users.settings.general-info.login-type.social': 'ソーシャル',
  'users.settings.general-info.login-type.xsolla_login': 'メール / パスワード',
  'users.settings.general-info.login-type': '認可タイプ',
  'users.settings.general-info.social-profile.provider_name': 'ソーシャルネットワーク',
  'users.settings.general-info.social-profile.social_id': 'ソーシャルID',
  'users.settings.general-info.social-profile.created_at': '作成日時',
  'users.settings.general-info.social-profile.remove': '削除',
  'users.settings.general-info.social-profile.remove.modal.title': 'ソーシャルプロバイダーの連携を解除しますか？',
  'users.settings.general-info.social-profile.remove.modal.subtitle': 'ユーザー{userId}から{provider}の連携を解除します。再度連携するまで、このプロバイダーでのサインインはできなくなります。',
  'users.settings.general-info.social-profile.remove.modal.submit': 'はい、連携を解除します',

  'users.header-block.mailchimp.pill.title': 'Mailchimp',
  'users.header-block.mailchimp.pill.dropdown.title': 'Mailchimpの統合',
  'users.header-block.mailchimp.pill.dropdown.subtitle': 'ログインのユーザーをMailchimp Audienceに送る自動エクスポート設定を行います。',
  'users.header-block.mailchimp.pill.dropdown.connect': '接続',

  'users.list-block.table.no-data.title': 'ユーザーが見つかりません',
  'users.list-block.table.no-data.subtitle': '登録されたすべてのユーザーがここに表示されます。',
  'users.list-block.table.error.title': '検索パラメータを変更する',
  'users.list-block.table.error.subtitle': "これらの検索パラメータでは検索結果を表示できません。ユーザーのリストを表示するには変更してください。",
  'users.list-block.table.id-username': 'ID/ユーザー名',
  'users.list-block.table.contacts': '連絡先の情報',
  'users.list-block.table.contacts.help': '確認待ち',
  'users.list-block.table.group': 'グループ',
  'users.list-block.table.activity': 'アクティビティ',
  'users.list-block.table.attributes': '属性',
  'users.list-block.navigation.manage-groups': 'ユーザーグループを管理',
  'users.list-block.navigation.export-users': 'ユーザーをエクスポート',
  'users.list-block.search-user.button': '検索',
  'users.list-block.search-user.input-placeholder': 'ユーザーを検索',
  'users.list-block.select-group.select.placeholder': 'グループを選択する',
  'users.list-block.number-user': '{number, plural, one {# ユーザーが見つかりました} other {# ユーザーが見つかりました}}',
  'users.list-block.table.settings.ban': '停止',
  'users.list-block.table.settings.view': 'プロフィールを見る',
  'users.list-block.table.last-activity': '最終ログイン：<br></br>{date}',
  'users.list-block.select-mode.all': 'すべてのユーザー',
  'users.list-block.select-mode.ban': 'アクセス禁止ユーザー',
  'users.list-block.select-mode.active': 'アクティブユーザー',
  'users.list-block.table.settings.unban': 'アクセス禁止リストから削除する',
  'users.list-block.table.settings.delete': '削除',
  'users.list-block.table.ban-date': 'アクセス禁止日付：<br></br> {date}',
  'users.list-block.table.ban-info-row.title': '詳細情報',
  'users.list-block.table.ban-info-row.date': 'アクセス禁止の締切日：',
  'users.list-block.table.ban-info-row.date.permanent': '永久アクセス禁止',
  'users.list-block.table.ban-info-row.reason': 'アクセス禁止の理由',
  'users.list-block.table.ban-modal.title': 'このユーザーをアクセス禁止にしますか？',
  'users.list-block.table.ban-modal.subtitle': 'アクセス禁止ユーザーは、指定された日付まで、またはアクセス禁止を解除するまでログインすることができません。',
  'users.list-block.table.ban-modal.profile.title': 'ユーザープロフィール',
  'users.list-block.table.ban-modal.profile.external-id': 'External ID {id}',
  'users.list-block.table.ban-modal.profile.register-date': '登録日は{date}です',
  'users.list-block.table.ban-modal.period.label': 'アクセス禁止の締切：',
  'users.list-block.table.ban-modal.period.separator': '時間',
  'users.list-block.table.ban-modal.permanent': '永久アクセス禁止',
  'users.list-block.table.ban-modal.reason.label': 'アクセス禁止の理由',
  'users.list-block.table.ban-modal.reason.description': '例：あなたのアカウントは、{{ban reason}}の理由で、{{unban date}}までアクセス禁止されます。アクセス禁止解除を希望する場合は、{{support contact}}までご連絡ください。',
  'users.list-block.table.ban-modal.reason.submit.ban': 'はい、ユーザーをアクセス禁止にする',
  'users.list-block.table.ban-modal.reason.submit.unban': 'ユーザーのアクセス禁止を解除する',
  'users.list-block.select-search-by': '検索する情報のタイプ',
  'users.list-block.select-search-by.email': 'メールアドレス',
  'users.list-block.select-search-by.phone': '電話番号',
  'users.list-block.select-search-by.id': 'ID',
  'users.list-block.select-search-by.socialId': 'ソーシャルネットワークID',
  'users.list-block.select-search-by.username': 'ユーザー名',
  'users.list-block.select-search-by.nickname': 'ニックネーム',
  'users.list-block.select-search-by.customId': 'サーバーカスタムID',

  'users.export.title': 'ユーザーをエクスポート',
  'users.export.subtitle': 'ログインユーザーのエクスポート用メールアドレスを指定します。',
  'users.export.subtitle-archive': 'Windowsでは、7-Zipでアーカイブを解凍することをお勧めします。',
  'users.export.notification': '<a>JWT署名ページ</a>を確認すると、秘密鍵であるアーカイブパスワードが見つかります。',
  'users.export.email': 'メールアドレス',
  'users.export.button': 'エクスポート',
  'users.export.success.label': 'エクスポートリクエスト送信済み',
  'users.export.success.sublabel': '数分後、指定されたメールアドレスに、ユーザーを含むアーカイブを送信します。',

  'users.attributes.table.description.title': '属性名',
  'users.attributes.table.description.tooltip': 'JSONスキーマファイルの<b>description</b>フィールド。',
  'users.attributes.table.key.title': 'キー名',
  'users.attributes.table.key.tooltip': 'JSONスキーマファイル内の<b>properties</b>オブジェクトのキーフィールド。',
  'users.attributes.table.type.title': 'タイプ',
  'users.attributes.table.type.tooltip': 'JSONスキーマファイルの<b>type</b>フィールド。',
  'users.attributes.table.access.title': 'アクセス権',
  'users.attributes.table.access.tooltip': '属性の<b>アクセスタイプ</b>を表示します。',
  'users.attributes.table.readonly.title': '読み取り専用',
  'users.attributes.table.readonly.tooltip': 'ユーザーは<b>読み取り専用</b>の属性を更新することはできません。',
  'users.attributes.table.value.title': '数値',
  'users.attributes.table.value.tooltip': '属性の値。',
  'users.attributes.table.permission.title': '許可',
  'users.attributes.table.permission.tooltip': '<b>第三者</b>による属性へのアクセス状況',
  'users.attributes.table.access.private': 'プライベート',
  'users.attributes.table.access.public': '公開',
  'users.attributes.table.schema-link': '<a>ユーザー属性設定</a>で属性スキーマを変更することができます。',
  'users.attributes.table.empty.title': '属性が見つかりません',
  'users.attributes.table.empty.subtitle': 'ユーザーにJSONスキーマをアップロードしたり、属性を追加したりしていません',
  'users.attributes.table.search.placeholder': '属性を検索する',
  'users.attributes.table.search.empty.title': '属性が見つかりません',
  'users.attributes.table.search.empty.subtitle': '検索フィールドをクリアすると、利用可能なすべての属性が表示されます',
  'users.attributes.table.save-value': '保存',
  'users.attributes.table.type-error': '{type}タイプの値を入手します。',
  'users.attributes.table.publisher-project-id.title': 'パブリッシャープロジェクト ID',
  'users.attributes.table.publisher-project-id.description': 'パブリッシャープロジェクト ID は、選択したパブリッシャープロジェクトの ID です。',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=6203%3A100097 */
  'check-list.main-links.title': 'ログインガイドを見る',
  'check-list.main-links.subtitle': '主要なログイン設定を構成',
  'check-list.main-links.documentation': 'ドキュメンテーション',
  'check-list.main-links.faq': 'よくある質問',

  'check-list.head-element.title': 'ログイン設定のチェックリスト',
  'check-list.login-method.title': 'ログイン方法',
  'check-list.login-method.subtitle': '主要なログイン方法設定',
  'check-list.selected_login_method.title': 'ログイン方法を選択',
  'check-list.selected_login_method.tooltip': '必要なログインやサインアップの機能を提供するための認証方法を選択します。',
  'check-list.set_callback_url.title': 'コールバックURLをセットアップ',
  'check-list.set_callback_url.tooltip': '必要なページへのリダイレクトを許可するURLをセットアップします。',
  'check-list.rest-steps.not-required': '以下のステップは必須ではありませんが、ログインを正常にセットアップするために完了することをお勧めします：',
  'check-list.secure.title': 'セキュリティ',
  'check-list.secure.subtitle': '主要なセキュリティ設定',
  'check-list.set_up_oauth.title': 'OAuth 2.0 をセットアップ',
  'check-list.set_up_oauth.tooltip': 'ユーザーが保護されたデータへのアクセスを、第三者のウェブサイトやアプリケーションに許可することができます。',
  'check-list.copy_secret_key.title': '秘密鍵の保存と安全確保',
  'check-list.copy_secret_key.tooltip': '秘密鍵をコピーして、自分側のコードに実装します。',
  'check-list.authentication.title': '認証',
  'check-list.authentication.subtitle': '主要な認証設定',
  'check-list.connected_social.title': 'ソーシャルネットワークを追加',
  'check-list.connected_social.tooltip': 'ソーシャルネットワークでユーザーがログインできるように構成します。',
  'check-list.miscellaneous_data.title': 'その他のデータフォームをセットアップ',
  'check-list.miscellaneous_data.tooltip': '追加フォームでユーザーデータを収集します。',
  'check-list.user-data-base.title': 'ユーザーデータベース',
  'check-list.user-data-base.subtitle': '主要なデータベース設定',
  'check-list.set_up_storage.title': 'ユーザーデータストレージをセットアップ',
  'check-list.set_up_storage.tooltip': 'ユーザーデータストレージをセットアップし、ユーザー認証資格情報を管理します。',
  'check-list.supplementary_info.title': 'ユーザーの補足情報フォームをセットアップ',
  'check-list.supplementary_info.tooltip': 'ユーザーに関する補足情報を取得するようにデータフォームを追加します。',
  'check-list.customization.title': 'カスタマイゼーション',
  'check-list.customization.subtitle': '主要なカスタマイゼーション設定',
  'check-list.widget_customization.title': 'ウィジェットをカスタマイズ',
  'check-list.widget_customization.tooltip': 'ログインウィジェットを認識できるようにウィジェットUIをカスタマイズします。',

  /* Navigation page */
  'navigation.main-alert': '「編集」アイコンをクリックして、ログインプロジェクトの名前を変更します。ログインプロジェクト名は、ユーザーに送信される電子メールやメッセージで使用されます。',
  'navigation.delete-project': 'プロジェクトを削除する',
  'navigation.save.project-name': '保存',
  'navigation.authentication-method.label': 'ログイン方法',
  'navigation.authentication-method.configure.button': '構成',
  'navigation.authentication-method.alert': 'ログイン方法をクリックして、コールバックURLを設定し、ログインメソッドの設定を開きます。保存した設定でログイン方法を変更できます。',
  'navigation.authentication-method.classic-widget.title': 'クラシックログイン',
  'navigation.authentication-method.classic-widget.subtitle': 'ソーシャルログインを含むエンドユーザー体験を強化するための視覚、フロー、および機能の改善。<a>詳細については、ログイン説明書を参照してください。</a>',
  'navigation.authentication-method.passwordless-widget.title': 'パスワードレスログイン',
  'navigation.authentication-method.passwordless-widget.subtitle': 'ユーザーがパスワードを使用せずに、電子メールアドレス、電話番号、またはソーシャルネットワーク経由でログインできるようにします。<a>詳細については、ログイン説明書を参照してください。</a>',
  'navigation.authentication-method.social-widget.title': 'ソーシャルログイン',
  'navigation.authentication-method.social-widget.subtitle': 'ユーザーがソーシャルネットワーク経由でログインできるようにします。<a>詳細については、ログイン説明書を参照してください。</a>',
  'navigation.authentication-method.example-project.modal': 'これは単なるプレビューなので、クリックを保存してください！',
  'navigation.settings.secure.label': 'セキュリティ',
  'navigation.settings.secure.oauth2.title': 'OAuth 2.0',
  'navigation.settings.secure.oauth2.subtitle': 'ユーザーが自分の資格情報を公開することなく、ウェブサイト経由で自分のデータへの制限付きアクセスを許可できるようにします。',
  'navigation.settings.secure.signature.title': 'JWT署名',
  'navigation.settings.secure.signature.subtitle': 'JSON ウェブトークン（JWT）署名の検証に使用されるキーを選択します。',
  'navigation.settings.secure.multi-factor.title': '多要素認証ポリシー',
  'navigation.settings.secure.multi-factor.subtitle': '不正なアクセスを防止するために、ユーザーにログイン時の追加手順を要求します。',
  'navigation.settings.user-db.label': 'ユーザーデータベース',
  'navigation.settings.user-db.storage.title': 'ストレージ',
  'navigation.settings.user-db.storage.subtitle': 'データベース接続を許可して、電子メールアドレスまたはユーザー名とパスワードでユーザーを認証します。',
  'navigation.settings.user-db.user-info.title': 'ユーザー補足情報',
  'navigation.settings.user-db.user-info.subtitle': 'ユーザーデータを収集するための追加のフォームを提示します。これを使用して、データベースにユーザーデータを追加します。',
  'navigation.settings.user-db.user-attributes.title': 'ユーザー属性スキーマ',
  'navigation.settings.user-db.user-attributes.subtitle': 'ユーザー属性のスキーマをダウンロードして取得します。',
  'navigation.settings.user-db.users.title': 'ユーザー',
  'navigation.settings.user-db.users.subtitle': 'ユーザーのメールアドレス変更、パスワードリセット、禁止リスト管理、ユーザー削除、ユーザー属性管理、全ユーザーデータベースのコピーダウンロード。',
  'navigation.settings.authentication.label': '認証',
  'navigation.settings.classic-login.label': 'クラシックログイン',
  'navigation.settings.classic-login.alert': '保存した設定を失うことなく、クラシック、パスワードレス、ソーシャルログインの切り替えが簡単にできます。<a>ログイン方法を変更する</a>。',
  'navigation.settings.settings.title': '設定',
  'navigation.settings.settings.subtitle': 'ユーザーがパスワードなしでログインできるように、パスワードなしの方法を構成します。',
  'navigation.settings.sign-up.title': '設定をサインアップする',
  'navigation.settings.sign-up.subtitle': 'メインのサインアップ設定をセットアップします。',
  'navigation.settings.username.title': 'ユーザ名設定',
  'navigation.settings.username.subtitle': '電子メールアドレスに加えてユーザー名を提供するようにユーザーに要求します。',
  'navigation.settings.email-validation.title': 'メール検証',
  'navigation.settings.email-validation.subtitle': '電子メール検証の検証方法を選択します。',
  'navigation.settings.callback.title': 'コールバックURL',
  'navigation.settings.callback.subtitle': '認証が成功した後にユーザーがリダイレクトされる複数の有効なURLを指定します。',
  'navigation.settings.email.title': 'メール設定',
  'navigation.settings.email.subtitle': 'ユーザーの電子メールアドレスを確認するためのリンクと検証方法を設定します。',
  'navigation.settings.classic-login.password.title': 'パスワード設定',
  'navigation.settings.classic-login.password.subtitle': '安全なパスワードを手動で作成するか、自動的に生成します。',
  'navigation.settings.passwordless.label': 'パスワードレスログイン',
  'navigation.settings.social.label': 'ソーシャルログイン',
  'navigation.settings.authentication.social-connections.title': 'ソーシャルログイン',
  'navigation.settings.authentication.social-connections.subtitle': 'ユーザーが選択したソーシャルネットワーク経由でログインできるようにします。',
  'navigation.settings.authentication.enterprise-connections.title': 'OAuth 2.0 ログイン接続',
  'navigation.settings.authentication.enterprise-connections.subtitle': 'OAuth 2.0を介してエクソーラにリンクされた認証インターフェイス経由でユーザーがログインできるようにします。',
  'navigation.settings.authentication.passkey.title': 'パスキー',
  'navigation.settings.authentication.passkey.subtitle': 'パスワードの代わりに、指紋、顔、またはデバイスのPINでユーザーにサインインさせることができます。',
  'navigation.settings.authentication.miscellaneous-data.title': 'その他のデータフォーム',
  'navigation.settings.authentication.miscellaneous-data.subtitle': "ユーザーデータを収集するための追加フォームを表示します。登録時に必要なデータが提供されなかった場合に使用します。",
  'navigation.settings.authentication.publisher-platforms.title': 'パブリッシングプラットフォーム',
  'navigation.settings.authentication.api-settings.title': 'Login API統合',
  'navigation.settings.authentication.api-settings.subtitle': 'Login APIとの統合を構成します。',
  'navigation.settings.custom-providers.label': '通信プロバイダー',
  'navigation.settings.custom-providers.email.title': 'メールプロバイダー',
  'navigation.settings.custom-providers.email.subtitle': '大量のメールサービスを介してすべてのメールを送信します。',
  'navigation.settings.custom-providers.sms.title': 'SMSプロバイダー',
  'navigation.settings.custom-providers.sms.subtitle': '大量のメッセージングサービスを介してすべてのSMSメッセージを送信します。',
  'navigation.settings.customization.label': 'カスタマイゼーション',
  'navigation.settings.customization.widget-customization.title': 'ウィジェットカスタマイゼーション',
  'navigation.settings.customization.widget-customization.subtitle': 'ウィジェットの言語と視覚をセットアップします。',
  'navigation.settings.customization.email-customization.title': 'メールのカスタマゼーション',
  'navigation.settings.customization.email-customization.subtitle': 'ユーザーに送信される電子メールの視覚をカスタマイズします。',
  'navigation.settings.customization.sms-customization.title': 'SMSのカスタマイズ',
  'navigation.settings.customization.sms-customization.subtitle': 'ユーザーに送信されるSMSメッセージをカスタマイズします。',
  'navigation.settings.legal.label': '法的設定',
  'navigation.settings.legal.terms-and-policies.title': '規約と方針',
  'navigation.settings.legal.terms-and-policies.subtitle': '規制を遵守し、ユーザーとの法的関係を定義するために、規約とポリシーへのリンクを提供します。ユーザーは、ログインウィジェット画面にこれらのリンクを見ることができます。',
  'navigation.settings.legal.age-restrictions.title': '年齢制限',
  'navigation.settings.legal.age-restrictions.subtitle': 'ゲームにアクセスするために必要な最低年齢を指定します。',

  'change-method.main-title': '認証方法',
  'change-method.main-subtitle': 'エクソーラデータベースまたは独自のストレージのいずれかにユーザー資格情報を安全に保存および管理します。',
  'change-method.main-notification': '認証方法を変更しても、設定が失われることはありません。',
  'change-method.button.cancel': 'キャンセル',
  'change-method.button.save': '保存してセットアップする',
  'change-method.methods.classic.title': 'クラシックログイン',
  'change-method.methods.classic.subtitle': 'ユーザーがサインアップして、ユーザー名とパスワードを使用してログインできるようにします。',
  'change-method.methods.passwordless.title': 'パスワードレスログイン',
  'change-method.methods.passwordless.subtitle': 'ユーザーがパスワードを使用せずに、メールアドレスまたは電話番号でログインできるようにします。',
  'change-method.methods.social.title': 'ソーシャルログイン',
  'change-method.methods.social.subtitle': 'ユーザーがソーシャルネットワークにサインアップしてログインできるようにします。',

  'delete-project-form.description': '削除されたログインプロジェクトの復元は、削除後30日以内に限ります。',
  'delete-project-form.title': '「{projectName}」プロジェクトを削除しますか？',
  'delete-project-form.input.title': '削除したい場合は、ログインプロジェクト名を入力してください',
  'delete-project-launchers.title': '「{projectName}」は削除できません',
  'delete-project-launchers.description': 'この{projectName}プロジェクトは、既存のランチャーに接続されています。最初に切断する必要があります。',
  'delete-project-launchers.notification': 'ランチャー設定でログインを切断できます。',
  'delete-project-launchers.link': '「{launcherName}」ランチャー設定に移動します',
  'delete-project-success.title': 'ログインプロジェクトが削除されました',
  'delete-project-success.description': '<a>このログインプロジェクトを復元するには、サポートチーム</a>に連絡してください。',

  'welcome-page.header.title': 'エクソーラログインへようこそ',
  'welcome-page.header.description': 'ユーザーのデータを安全に保ち、あなたの支配下に置きながら、シームレスでローカライズされたワンクリック認証を有効にします。',
  'welcome-page.header.create-login-button': 'ログインプロジェクトを作成する',
  'welcome-page.header.annotation-integration': '統合は<span>20分以内に完了します</span>',
  'welcome-page.header.guide-link': 'ログイン統合ガイドを参照してください',
  'welcome-page.features-list.title': '主な機能',
  'welcome-page.features-list.make-game.title': 'ゲーム認証を簡単にする',
  'welcome-page.features-list.make-game.description': 'プレーヤーが30を超える信頼できるソーシャルネットワークからのプロファイルを使用して、ゲームに簡単にログインできるようにします。',
  'welcome-page.features-list.data-laws.title': 'グローバルデータ法を遵守する',
  'welcome-page.features-list.data-laws.description': '情報保護法、ゲームプレイへのアクセスの時間制限、オンラインIDシステムなどに準拠しています。',
  'welcome-page.features-list.brand-identity.title': 'ブランドアイデンティティを追加する',
  'welcome-page.features-list.brand-identity.description': 'アドミンページから直接ログインウィジェットの外観をカスタマイズしたり、CSSやHTMLでメールの視覚デザインを変更して、ブランドに合わせたデザインにすることもできます。',
  'welcome-page.features-list.own-your-database.title': 'データベースを所有する',
  'welcome-page.features-list.own-your-database.description': 'ユーザーデータベースのアクセス権を管理して、メールアドレスの更新、認証メールの再送、ユーザーの禁止、解除、削除、CSVファイルへの出力などを行うことができます。',
  'welcome-page.features-list.relevant-login-methods.title': '関連するログイン方法を強調表示する',
  'welcome-page.features-list.relevant-login-methods.description': "各プレイヤーの履歴と場所に基づいて、最も関連性の高いログイン方法を一番上にプッシュします。",
  'welcome-page.features-list.earn-layout-security.title': 'セキュリティによるロイヤルティを獲得する',
  'welcome-page.features-list.earn-layout-security.description': '強力な顧客認証（SCA）要件を満たし、データへの不正アクセスのリスクを最小限に抑えるパラメータを使用してプレーヤーIDを確認します。',
  'welcome-page.features-list.dock-link': 'その他の機能',

  'create-login-page.title': 'ログインプロジェクトを作成する',
  'create-login-page.description': '以下の手順に従って、ログインプロジェクトを簡単に作成し、セットアップしてカスタマイズします。',
  'create-login-page.notification': '作成するログインプロジェクトのタイプを選択します。すべてのオプションには、異なるセットアップ手順があります。ログインプロジェクトの作成後に、選択したタイプのログインプロジェクトを変更することはできません。別のタイプの新しいログインプロジェクトをいつでも作成できます。',
  'create-login-page.documentation': 'ドキュメンテーション',
  'create-login-page.create': '作成してセットアップする',
  'create-login-page.back': '<b>ダッシュボードに戻る</b>',
  'create-login-page.master.label': '標準ログインプロジェクト',
  'create-login-page.master.description': 'プレーヤーのデータを安全に保ち、あなたの支配下に置きながら、ログインにより、シームレスでローカライズされたワンクリック認証が有効になります。',
  'create-login-page.shadow.label': 'シャドウログインプロジェクト',
  'create-login-page.shadow.description': 'シャドウログインを使用すると、公開プラットフォームを介してユーザーを認証できます。',
  'create-login-page.settings.label': '追加設定',
  'create-login-page.master.settings.text': 'ソーシャルの接続',
  'create-login-page.shadow.settings.text': 'プラットフォームの接続',
  'create-login-page.time.label': '作成する時間',
  'create-login-page.master.time.text': '30分',
  'create-login-page.shadow.time.text': '15分',

  'settings.crumbs.login-type.classic-login': 'クラシックログイン',
  'settings.tabs.try-login.button': 'ログインしてみる',

  "users.mailchimp": "Mailchimp",
  "users.mailchimp.head": "Mailchimpに接続する",
  "users.mailchimp.notification.title": "手順を表示する",
  "users.mailchimp.notification.description.mailchimp-api-key": '1. <b>Mailchimp APIキーを入力します。</b><a1>Mailchimpアカウント</a1>で見つけることができます。<br></br> 2. ログインユーザーを同期させるMailchimp Audienceを<b>選択</b>します。<a2>Mailchimpアカウント</a2>でAudienceを管理することができます。<br></br> 3. <b>接続</b>をクリックすると、変更が保存され、Mailchimpアカウントへのログインユーザーのエクスポートが開始されます。<br></br>4. <a3>補足ユーザー情報ページ</a3>に移動し、ログインウィジェットのニュースレターの同意ボックスにチェックを入れます。<br></br><br></br>新しいログインユーザーを追加するたびに、自動的にMailchimpにエクスポートされます。',
  "users.mailchimp.notification.description.mailchimp-merge-tags": "そのタグがすでに Mailchimp ダッシュボードに存在するかをご確認ください。すでに設定済みの場合、当社のインターフェースでは再度追加できず、再試行すると予期しないエラーが発生する可能性があります。",
  "users.mailchimp.key.label": "Mailchimp APIキー",
  "users.mailchimp.key.placeholder": "36文字または37文字の API キーを入力してください",
  "users.mailchimp.audience.label": "Mailchimp Audience",
  "users.mailchimp.audience.empty.title": "まだAudienceはいません",
  "users.mailchimp.audience.empty.text": "<a>Mailchimpアカウント</a>で最初のAudienceを作成し、もう一度試してみてください。",
  "users.mailchimp.confirm.label": "私は、<a>Importance of Permission</a>に従い、私のAudienceのユーザーがメールを受信することに同意することを確認します。",
  "users.mailchimp.connect-form.button": "接続",
  "users.mailchimp.confirm-form.button": "確認",
  "users.mailchimp.export.alert.title": "Mailchimpへのエクスポートを実行する",
  "users.mailchimp.export.alert.message": "エクスポートは時間がかかります。今はウィンドウを閉じても問題ありません。",
  "users.mailchimp.export.alert.button": "OK、閉じる",
  "users.mailchimp.disconnect.title": "Mailchimpとの接続を解除しますか？",
  "users.mailchimp.disconnect.description": "これからログインのユーザーがMailchimpにエクスポートされることはありません。再度接続する場合は、もう1度項目をご入力ください。",
  "users.mailchimp.button-dropdown.integration.title": "Mailchimpの統合",
  "users.mailchimp.button-dropdown.integration.description": "ログインのユーザーをMailchimp Audienceに送る自動エクスポート設定を行います。",
  "users.mailchimp.button-dropdown.integration.button": "接続",
  "users.mailchimp.button-dropdown.fetching.title": "Mailchimpへのエクスポートを実行する",
  "users.mailchimp.button-dropdown.fetching.description": "エクスポートにかかる時間は、ログインリストのユーザー数で決まります。",
  "users.mailchimp.button-dropdown.export-completed.title": "エクスポート完了",
  "users.mailchimp.button-dropdown.export-completed.description": "ログインのユーザーをMailchimp Audienceへエクスポートします。",
  "users.mailchimp.button-dropdown.export-completed.button": "接続解除",
  "users.mailchimp.merge-tags-form.button.skip": "スキップ",
  "users.mailchimp.merge-tags-form.head": "Mailchimp のマージタグを使用する",
  "users.mailchimp.merge-tags-form.add-tag": "マージタグを追加",
  "users.mailchimp.merge-tags-form.edit-tag": "マージタグを編集",
  "users.mailchimp.merge-tags-form.field-label.placeholder": "フィールドラベル",
  "users.mailchimp.merge-tags-form.merge-tag.placeholder": "マージタグ",
  "users.mailchimp.merge-tags-form.field-label.error": "フィールドラベルは1文字以上10文字以内である必要があります",
  "users.mailchimp.merge-tags-form.merge-tag.error": "マージタグは1文字以上50文字以内である必要があります",

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A76750 */
  'configuration-page.menu.item.callback-url': 'コールバックURL',
  'configuration-page.menu.item.signup-settings': 'サインアップ',
  'configuration-page.menu.item.username-settings': 'ユーザー名',
  'configuration-page.menu.item.password-settings': 'パスワード',
  'configuration-page.menu.item.email-validation': 'メール検証',

  'configuration-page.callback-urls.page-title': 'URL',
  'configuration-page.callback-urls.page-description': 'ユーザーがアプリケーションに正常にログインすると、認証サーバーはURLに認証コードまたはアクセストークンを指定して、ユーザーをアプリケーションにリダイレクトします。',

  'configuration-page.urls.callback-urls.title': 'コールバックURL',
  'configuration-page.urls.callback-urls.description': '認証、メールアドレスの確認、またはパスワードのリセットが成功した後にユーザーがリダイレクトされるコールバックURL。ユーザーの認証後、これらのURLにのみコールバックします。',
  'configuration-page.urls.callback-urls.notification': 'プロトコルを必ず指定してください — <u>https://</u>または<u>http://</u>。そうしないと、コールバックが失敗する場合があります。',
  'configuration-page.urls.callback-urls.input.title': 'コールバックURL',
  'configuration-page.urls.callback-urls.input.placeholder': 'https://',
  'configuration-page.urls.callback-urls.input.add-button': 'URLを追加する',
  "configuration-page.urls.callback-urls.notification": "OAuth認可中にリダイレクトとして使用される可能性のあるすべてのURLをリストアップしてください。<br></br><br></br>1. フル形式を使用してください：スキーム + ドメイン + パス。例：https://domain.com/auth<br></br>2. すべてのサブドメインのバリエーションを含めてください（例：https://domain.com/authおよび https://www.domain.com/auth<br></br>3. アプリが https:// と http:// の両方を使用する可能性がある場合は、両方のバージョンを明示的に追加してください。<br></br>4. 最後のスラッシュに注意してください。/auth と /auth/ の両方を使用する場合は、両方を含めてください。<br></br>5. クエリパラメータやフラグメントは含めないでください。たとえば ?code=... や #sectionは追加しないでください。<br></br><br></br>リダイレクトURLがリストにない場合、ユーザーはログインフローを完了できません。",

  'configuration-page.urls.allowed-origin.title': '許可されたオリジン（CORS）',
  'configuration-page.urls.allowed-origin.description': 'エクソーラAPIへのオリジン間HTTPリクエスト（通常CORSで使用）を許可するURLのセット。これにより、ウェブブラウザからエクソーラのサービスや製品を使用する際の、同一オリジンポリシーエラーを防ぐことができます。',
  'configuration-page.urls.allowed-origin.notification': 'このフィールドでは、必要であればオリジンを指定することができます。有効なURLを複数指定することができます。',
  'configuration-page.urls.allowed-origin.input.title': '許可されたオリジン（CORS）',
  'configuration-page.urls.allowed-origin.input.placeholder': 'https://',
  'configuration-page.urls.allowed-origin.input.add-button': 'URLを追加する',

  'configuration-page.urls.error-callback.title': 'エラーコールバックURL',
  'configuration-page.urls.error-callback.description': 'ログインエラーの場合にユーザーがリダイレクトされるエラーコールバックURL。',
  'configuration-page.urls.error-callback.notification': '値を指定しない場合、コールバックURLが使用されます。',
  'configuration-page.urls.error-callback.input.title': 'エラーコールバックURL',
  'configuration-page.urls.error-callback.input.placeholder': 'https://',
  'configuration-page.urls.error-callback.input.add-button': 'URLを追加する',
  'configuration-page.urls.default-callback.title': 'デフォルトのコールバックURL',
  'configuration-page.urls.default-callback.description': 'ユーザーがリダイレクトされるデフォルトのコールバックURL',
  'configuration-page.urls.default-callback.notification': '下のリストにあるコールバックURLを入力してください。',

  'configuration-page.urls.allow-logout.title': '許可されたログアウトURL',
  'configuration-page.urls.allow-logout.description': 'ユーザーがログインからログアウトした後のリダイレクトに有効なURL。（returnTo）クエリパラメータでリダイレクトできます。',
  'configuration-page.urls.allow-logout.notification': '値を指定しない場合、コールバックURLが使用されます。',
  'configuration-page.urls.allow-logout.input.title': '許可されたログアウトURL',
  'configuration-page.urls.allow-logout.input.placeholder': 'https://',
  'configuration-page.urls.allow-logout.input.add-button': 'URLを追加する',

  'configuration-page.sign-up.page-title': 'サインアップ設定',
  'configuration-page.sign-up.page-description': 'これらの設定により、ユーザー登録を管理できます。',
  'configuration-page.sign-up.page-notification': 'このオプションは、ユーザー名とパスワード、またはメールアドレスとパスワードの組み合わせでユーザーの登録を管理することができます。ソーシャルネットワークを使用したサインアップを管理するには、<a>ソーシャルネットワーク設定</a>に移動してください。',
  'configuration-page.sign-up.disable-sign-up.title': 'ユーザー登録',
  'configuration-page.sign-up.disable-sign-up.description': 'このトグルがオンに設定されている場合、ユーザーは登録することができます。',
  'configuration-page.sign-up.welcome-email.title': 'サインアップ時のウェルカムメールを有効化',
  'configuration-page.sign-up.welcome-email.description': 'このトグルがオンに設定されている場合、ユーザーはサインアップ時にウェルカムメールを受信できます。',


  'configuration-page.password.page-title': 'パスワード設定',
  'configuration-page.password.page-description': 'パスワードの強度は、認証にパスワードを使用する場合に重要な考慮事項です。',
  'configuration-page.password.page-notification': '強力なパスワードポリシーがあると、不可能ではないにしても、手動または自動の手段でパスワードを推測することが困難になります。',
  'configuration-page.password.miscellaneous.title': 'その他のパスワード設定',
  'configuration-page.password.miscellaneous.description': '次のセキュリティ条件で動作するパスワードを許可します。',
  'configuration-page.password.miscellaneous.notification': 'これは、互いに補完し合うことで、より堅牢なソリューションに貢献するのに役立つ推奨事項の集まりです。',
  'configuration-page.password.miscellaneous.recover-pass.title': 'パスワードリカバリー',
  'configuration-page.password.miscellaneous.recover-pass.description': 'ユーザーが紛失したパスワードを回復できるようにします。',
  'configuration-page.password.miscellaneous.pass-history.title': 'パスワード履歴',
  'configuration-page.password.miscellaneous.pass-history.description': '各ユーザーのパスワード履歴を保持し、以前のパスワードが使用されないようにします。',
  'configuration-page.password.miscellaneous.pass-check.title': 'パスワードチェック',
  'configuration-page.password.miscellaneous.pass-check.description': '登録時にパスワードをもう一度入力するようユーザーに依頼します。',
  'configuration-page.password.password-reset-cb-url.title': 'パスワードリセットのコールバックURLを選択してください',
  'configuration-page.password.password-reset-cb-url.description': 'パスワードリセット後にユーザーがリダイレクトされるURLアドレスを選択します。',
  'configuration-page.password.password-reset-cb-url.placeholder': 'URLを選択',
  'configuration-page.password.password-validation.toggle-box.title': 'パスワード検証',
  'configuration-page.password.password-validation.toggle-box.description': 'パスワード検証に適用するルールを選択します。',
  'configuration-page.password.password-validation.tests.title': 'テストパスワード',
  'configuration-page.password.password-validation.tests.description': 'パスワードを入力して確認します。',
  'configuration-page.password.password-validation.tests.input-title': 'パスワード',
  'configuration-page.password.status.absent': '保護なし',
  'configuration-page.password.status.weak': '弱いパスワード',
  'configuration-page.password.status.good': '良いパスワード',
  'configuration-page.password.status.strong': '強いパスワード',
  'configuration-page.username.page-title': 'ユーザ名設定',
  'configuration-page.username.page-description': 'これらの設定により、メインログインフローを設定できます。',
  'configuration-page.username.page-notification': 'この設定を使用するには、次のオプションを有効にします：<ul><li>ユーザー名とパスワードによる登録する</li><li>ユーザー名とパスワードによるログインする</li></ul>',
  'configuration-page.username.requires.title': 'ユーザー名を要求する',
  'configuration-page.username.requires.description': 'ユーザーは、電子メールアドレスに加えてユーザ名も入力する必要があります。',
  'configuration-page.username.username-validation.title': 'ユーザー名検証',
  'configuration-page.username.username-validation.description': 'カスタムフィールド検証は、[ユーザー名]フィールドに対してのみ構成できます。',
  'configuration-page.username.username-validation.notification': 'ユーザ名の検証には最大4つのルールを設定することも、検証ルールをまったく設定しないこともできます。',
  'configuration-page.username.username-validation.toggle-box.title': 'ユーザー名検証',
  'configuration-page.username.username-validation.toggle-box.description': 'ユーザー名検証に適用するルールを選択します。',
  'configuration-page.username.username-validation.tests.title': 'テストユーザー名',
  'configuration-page.username.username-validation.tests.description': 'ユーザー名を入力して確認します：',
  'configuration-page.username.username-validation.tests.input-title': 'ユーザー名',
  'configuration-page.username.username-validation.tests.username-email': 'ユーザー名をメールとして使用',

  'configuration-page.validation-rule.min_characters': '{number}文字以上の長さが必要です',
  'configuration-page.validation-rule.max_characters': '{number}文字以下の長さが必要です',
  'configuration-page.validation-rule.user_numerals_spec_symbol': '数字、ダッシュまたはアンダースコアを含める必要があります',
  'configuration-page.validation-rule.letter_case': '少なくとも大文字と小文字を1つずつ含む必要があります',
  'configuration-page.validation-rule.numerals': '少なくとも1つの数字（0-9）を含める必要があります',
  'configuration-page.validation-rule.spec_characters': '特殊文字を少なくとも1つ含める必要があります',
  'configuration-page.validation-rule.allow_ascii_characters': 'ASCII 文字のみを含む必要があります',
  'configuration-page.validation-rule.exclude_personal_data': '個人データを除外する必要があります',
  'configuration-page.validation-rule.password_dictionary': 'パスワード<a>辞書</a>に登録されている単語を除外する必要があります',

  /* settings.email-validation встречается при классической авторизации и passwordless.
    На двух макетах: https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A79600
    https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A76750
  */
  'settings.email-validation.title': 'メール検証',
  'settings.email-validation.subtitle': 'メール検証では、ユーザーのメールアドレスの信頼性をチェックできます。',
  'settings.email-validation.notification.label': 'メールアドレス検証について、1つまたは複数の条件を有効にすることができます。',
  'settings.email-validation.smtp.switch.title': 'SMTP検証',
  'settings.email-validation.smtp.switch.caption': "受信者のメールアドレスが実際に存在するかどうかを示す、受信者のサーバーとの接続。",
  'settings.email-validation.rfc.switch.title': 'RFC検証',
  'settings.email-validation.rfc.switch.caption': 'メールアドレスに使用できる文字を決定する仕様。',
  'settings.email-validation.gray-list.switch.title': 'ブロックリスト検証',
  'settings.email-validation.gray-list.switch.caption': 'スパムメールアドレスドメインを永久にブロックし、この発信元からのメールを拒否します。このリストにメールアドレスドメインを含める、または除外したい場合は、お問い合わせください。',
  'settings.email-validation.confirmation.switch.title': '確認メールを送信する',
  'settings.email-validation.confirmation.switch.caption': "ユーザーを検証するために確認メールを送信します。",

  'settings.email-settings.title': 'メール設定',
  'settings.email-settings.subtitle': 'これらの設定により、メインログインフローを設定できます。',
  'settings.email-settings.magic-link.title': 'マジックリンク',
  'settings.email-settings.magic-link.subtitle': 'ユーザーには、ログインするためにクリックすべきリンクが記載された電子メールが送信されます。',
  'settings.email-settings.magic-link.switch.title': 'マジックリンクからログインする',
  'settings.email-settings.magic-link.switch.caption': 'リンクをクリックした後、ユーザーはログインできます。',

  'settings.crumbs.login-type.passwordless-login': 'パスワードレスログイン',
  'settings.tabs.email-settings': 'メール設定',
  'settings.tabs.passwordless-settings': '設定',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A79600 */
  'settings.passwordless.change-method.description': 'ユーザーがパスワードを使用せずに、メールアドレスまたは電話番号でログインできるようにします。',
  'settings.passwordless.change-method.notification': '使用するパスワードレス認証方式のタイプを選択してください：',
  'settings.passwordless.change-method.phone.label': '電話番号によるパスワードレスログイン',
  'settings.passwordless.change-method.phone.description': 'ユーザーは自分の電話番号と確認コードを使用してログインできます。',
  'settings.passwordless.change-method.email.label': 'メールアドレスによるパスワードレスログイン',
  'settings.passwordless.change-method.email.description': 'ユーザーは、メールアドレスと確認コードを使用してサインアップおよびログインできます。',
  'settings.passwordless.change-method.phoneEmail.label': '電話番号とメールアドレスによるパスワードレスログイン',
  'settings.passwordless.change-method.phoneEmail.description': 'ユーザは、電話番号と確認コード付きのメールアドレスを使用してサインアップおよびログインできます。',

  'secure.oauth2.tab': 'OAuth 2.0',
  'secure.signature.tab': 'JWT署名',
  'secure.mfa.tab': 'MFAポリシー',
  'authorization.settings.oauth2.client.title': 'OAuth 2.0クライアント',
  'authorization.settings.oauth2.client.subtitle': 'OAuth 2.0は認証レイヤーとして機能し、クライアントロールとリソース所有者を分離します。',
  'authorization.settings.oauth2.notification': '<b>クライアントIDとクライアント秘密鍵の取得方法</b><br></br>1. OAuth 2.0 認証を追加します。<br></br>2. クライアント名と OAuth 2.0リダイレクトURIを指定します。<br></br>3. 認証タイプとして [公開] または [機密] を指定します。<br></br><br></br>OAuth 2.0 の詳細については、<a>説明書を参照してください</a>。',
  'authorization.settings.oauth2.add': 'OAuth 2.0クライアントを追加する',
  'authorization.settings.oauth2.server.title': 'OAuth 2.0 サーバー',
  'authorization.settings.oauth2.server.name.title': 'クライアント名',
  'authorization.settings.oauth2.server.name.placeholder': 'OAuth 2.0認証',
  'authorization.settings.oauth2.server.secret-key.title': '秘密鍵',
  'authorization.settings.oauth2.server.secret-key.extra': '秘密鍵をリセット',
  'authorization.settings.oauth2.server.subtitle': 'OAuth 2.0は認証レイヤーとして機能し、クライアントロールとリソース所有者を分離します。',
  'authorization.settings.oauth2.table.client-name': 'クライアント名',
  'authorization.settings.oauth2.table.client-id': 'クライアントID',
  'authorization.settings.oauth2.table.client-secret': '秘密鍵',
  'authorization.settings.oauth2.table.auth-type': '認証タイプ',
  'authorization.settings.oauth2.table.copy': 'キーをコピー',
  'authorization.settings.oauth2.table.empty.title': 'OAuth 2.0クライアントはまだありません',
  'authorization.settings.oauth2.table.empty.text': '追加されたOAuth 2.0クライアントはすべてここに表示されます。',
  'authorization.settings.oauth2.modal.connect.button': '接続',
  'authorization.settings.oauth2.modal.connect.title': 'OAuth 2.0認証',
  'authorization.settings.oauth2.modal.connect.instruction.title': 'OAuth 2.0認証の設定方法',
  'authorization.settings.oauth2.modal.connect.instruction': '1. クライアントIDと秘密鍵をコピーします。<br></br>2. <a>ウィジェット</a>または<c>APIメソッド</c>を使用してプロジェクト統合を更新します',
  'authorization.settings.oauth2.modal.connect.redirect-uri.title': 'OAuth 2.0リダイレクトURI',
  'authorization.settings.oauth2.modal.connect.redirect-uri.placeholder': 'https://example.com',
  'authorization.settings.oauth2.validation.invalid-url': '無効URL',
  'authorization.settings.oauth2.validation.duplicate-url': '重複URL',
  'authorization.settings.oauth2.modal.connect.type.public': '公開<span>（アプリの場合推奨）</span>',
  'authorization.settings.oauth2.modal.connect.type.private': '機密<span>（サーバー間接続の場合推奨）</span>',
  'authorization.settings.oauth2.modal.connect.success.title': 'OAuth 2.0認証が正常に接続されました',
  'authorization.settings.oauth2.modal.connect.success.subtitle': 'プロジェクト統合のために、このクライアントIDとシークレットキーをコピーします。',
  'authorization.settings.oauth2.modal.connect.success.client-id': 'クライアントID',
  'authorization.settings.oauth2.modal.connect.success.more-title.title': '次のステップ',
  'authorization.settings.oauth2.modal.connect.success.more-title': 'OAuth 2.0 認証を統合する方法',
  'authorization.settings.oauth2.modal.connect.success.dismiss': '閉じる',
  'authorization.settings.oauth2.modal.connect.update.remove': 'OAuth 2.0 クライアントを削除する',
  'authorization.settings.oauth2.modal.connect.update.remove.subtitle': '削除したOAuth 2.0クライアントは復元できません。',
  'authorization.settings.oauth2.modal.remove.title': '{name}OAuth 2.0クライアントを削除しますか？',
  'authorization.settings.oauth2.modal.remove.subtitle': '接続されたすべてのURIは、別の認証方法を構成するまでユーザーを認証できません。',
  'authorization.settings.oauth2.modal.remove.checkbox': 'はい、わかりました',
  'authorization.settings.oauth2.modal.remove.submit': 'はい、削除',
  'authorization.settings.oauth2.table.client-key': 'クライアントキー',
  'authorization.settings.oauth2.table.server-key': 'サーバーキー',
  'authorization.settings.oauth2.modal.connect.type.server': 'サーバー<span>（サーバー・トゥ・サーバー接続）</span>',
  'authorization.settings.oauth2.modal.connect.merchant-project.label': 'プロジェクトID',
  'authorization.settings.oauth2.modal.connect.type.server.description': '認証レイヤーとして機能し、クライアントロールとリソース所有者を分離します。',
  'authorization.settings.oauth2.modal.connect.type.confidential.description': 'クライアントは、ログインを開始するためにシークレットを必要とします。',
  'authorization.settings.oauth2.modal.connect.type.public.description': 'クライアントはシークレットを必要としません。',

  'authorization.settings.babkaLogin.modal.connect.title': '新しいOAuth 2.0クライアント',
  'authorization.settings.babkaLogin.modal.connect.scope.title': 'Scope',
  'authorization.settings.babkaLogin.modal.connect.scope.placeholder': '新しいスコープ',
  'authorization.settings.babkaLogin.modal.connect.audience.title': 'Audience',
  'authorization.settings.babkaLogin.client.name': 'エクソーラOAuth 2.0クライアント',
  'authorization.settings.babkaLogin.field.logo-url.title': 'アプリケーションアイコン',
  'authorization.settings.babkaLogin.field.logo-url.tooltip': '推奨画像解像度：{sizePx}x{sizePx}{br}サポートされている形式：JPG および PNG{br}最大サイズ：{sizeKb} KB',
  "authorization.settings.babkaLogin.field.logo-url.upload-error": "画像をアップロードできません。もう一度試してください",
  "authorization.settings.babkaLogin.field.logo-url.size-error": "画像のサイズは{size} KB未満である必要があります",
  "authorization.settings.babkaLogin.info.displayed-details": "プレイヤーがエクソーラIDであなたのアプリまたはゲームにログインすると、アプリのアイコン、名前、説明がプレイヤーのエクソーラウォレットアカウントに表示されます",
  'authorization.settings.babkaLogin.field.name.label': 'アプリケーション名',
  'authorization.settings.babkaLogin.field.description.label': '簡単な説明',
  'authorization.settings.babkaLogin.scopes.add-button': '新しいスコープ',
  'authorization.settings.babkaLogin.field.scope.regex-error': 'ラテン文字、ドット、またはアンダースコアのみを使用してください。ただし、先頭または末尾にドットまたはアンダースコアを使用しないでください',

  'social-connection.title': 'ソーシャルネットワーク',
  'social-connection.subtitle': 'ユーザーがワンクリックで、選択したIDプロバイダーを経由してアプリケーションにログインできるようにします。',
  'social-connection.tabs.social-connection-path': 'ソーシャルネットワーク',
  'social-connection.tabs.enterprise-connection-path': 'OAuth 2.0 ログイン接続',
  'social-connection.tabs.passkey': 'パスキー',
  'social-connection.tabs.miscellaneous': 'ミシレイニアスフォーム',
  'social-connection.tabs.api-settings': 'Login API統合',
  'social-connection.select.deselect': '選択解除する',
  'social-connection.select.select': 'すべて選択する',
  'social-connection.select.all': 'すべてのソーシャルネットワーク',
  'social-connection.select.connected': '接続済み',
  'social-connection.select.disconnected': '接続解除済み',
  'social-connection.search.placeholder': '検索...',
  'social-connection.mode.title': '管理',
  'social-connection.mode.connect': '接続',
  'social-connection.mode.disconnect': '接続解除',
  'social-connection.card.tooltip': 'エクソーラキーを有効にする',
  'social-connection.card.subscription.subtitle': 'ユーザーがアプリにサインアップしてログインできるようにする',
  'social-connection.card.settings.connect': '接続',
  'social-connection.card.settings.disconnect': '接続解除',
  'social-connection.card.settings.settings': '設定',
  'social-connection.card.settings.try': '接続を試す',
  'social-connection.babka-disconnect.title': 'エクソーラアカウントの連携解除',
  'social-connection.babka-disconnect.description': '連携解除後、ユーザーは自動的にエクソーラIDへ移行されます。エクソーラアカウントの選択オプションは表示されなくなります。この操作を元に戻すには、サポートへのリクエストが必要です。',
  'social-connection.card.status.connected': '接続済み',
  'social-connection.card.status.disconnected': '接続解除済み',
  'social-connection.card.button.show-more': 'すべて表示する',
  'social-connection.card.button.show-less': '表示を減らす',
  'social-connection.jwt.title': 'ソーシャルネットワークJWTトークンを埋め込む',
  'social-connection.jwt.subtitle': 'エクソーラログインJWTトークンにソーシャルネットワークJWTトークンを自動的に埋め込みます。',
  'social-connection.jwt.notification': 'ソーシャルネットワークJWTトークンは、ソーシャルネットワークAPIに直接アクセスするために使用されるかもしれません。',

  'social-connection.settings.subtitle': 'このソーシャルネットワークに接続するには、次の手順に従います。',
  'social-connection.settings.notification': "独自のアプリケーションを使用する場合：<br></br>1. ソーシャルネットワークの開発アカウントに移動します。<br></br>2. 許可されたリダイレクトURIとして{link}を追加します。<br></br><br></br>注：エクソーラのアプリケーションをソーシャルネットワークの認証に使用する場合、上記の設定を完了する必要はありません。",
  'social-connection.settings.sync.notification': 'デフォルトでは、ログインは各ユーザーのログイン時に自動的にユーザープロファイルのデータを同期します。',
  'social-connection.settings.back-button': '<b>ソーシャルネットワーク</b>へ戻る',
  'social-connection.settings.sync.switch.title': 'ログイン毎にユーザープロファイルの属性を同期させる',
  'social-connection.settings.sync.switch.subtitle': 'オプションとして、ユーザープロファイルのデータ同期を無効にして、アプリケーションからプロファイルの属性を更新できるようにすることができます。',
  'social-connection.settings.app-id.notification': 'アプリケーションIDの取得方法',
  'social-connection.settings.one-tap.title': '{name}ワンタップログイン',
  'social-connection.settings.one-tap.subtitle': 'ユーザーが個別のログイン画面を表示せずに{name}アカウントでログインできるようにします。',
  'social-connection.settings.field.client_id.label': 'アプリケーションID',
  'social-connection.settings.field.client_id.placeholder': 'エクソーラIDを使用する場合は空白にする',
  'social-connection.settings.field.client_secret.label': 'アプリケーション秘密鍵',
  'social-connection.settings.field.client_secret.placeholder': 'エクソーラキーを使用する場合は空白にする',
  'social-connection.settings.field.client_secret.footer': 'セキュリティの観点から、既存のアプリケーションの秘密鍵は表示しません。',
  'social-connection.settings.field.client_secret.file': 'アップロードしたファイル',
  'social-connection.settings.field.custom_return_url.label': 'カスタムReturn URL',
  'social-connection.settings.field.custom_return_url.placeholder': 'エクソーラReturn URLを使用する場合は空白にする',
  'social-connection.settings.field.team_id.label': 'Team ID',
  'social-connection.settings.field.team_id.placeholder': 'エクソーラTeam IDを使用する場合は空白にする',
  'social-connection.settings.field.key_id.label': 'Key ID',
  'social-connection.settings.field.key_id.placeholder': 'エクソーラKey IDを使用する場合は空白にする',
  'social-connection.settings.scopes-disabled.notification': 'ソーシャルネットワークからチェック済みユーザーデータを収集したり、チェック済みパーミッションを適用したりするためには、独自のソーシャルアプリケーションを使用する必要があります。そのためには、上記のアプリケーションIDおよびアプリケーションシークレットキーのフィールドに入力してください。',
  'social-connection.settings.user-data.title': 'ユーザーデータ',
  'social-connection.settings.user-data.subtitle': '以下にチェックされているユーザーのプロファイルデータへのアクセスを提供します。{name}は、対応する同意メッセージを表示します。',
  'social-connection.settings.permission.title': '許可',
  'social-connection.settings.permission.subtitle': 'チェックされた各許可について、ログインは{name}にその許可を要求するので、access_tokenを使用してアプリケーションから{name} APIを呼び出すことができるようになります。',
  'social-connection.settings.permission.notification': '<a>詳細については{name}説明書</a>を見てください。',
  'social-connection.settings.field.url_authorize.label': '認証URL',
  'social-connection.settings.field.url_access_token.label': 'アクセストークンURL',
  'social-connection.subtitle.custom-social': "カスタムOAuth 2.0ログイン接続を有効にしました。<a>OAuth 2.0ログイン接続ページを開きます。</a>",

  /* Custom social fields */
  'social-connection.settings.apple.app-id.notification': 'Service IDを取得する方法',
  'social-connection.settings.apple.app-id.notification': 'Service IDを取得する方法',
  'social-connection.settings.babka.app-id.notification': 'エクソーラアカウントが非アクティブな場合は、<a>以下のガイドラインに従ってください</a>。',
  'social-connection.settings.field.apple.client_id.label': 'Service ID',
  'social-connection.settings.field.apple.client_id.placeholder': 'エクソーラService IDを使用する場合は空白にする',
  'social-connection.settings.field.apple.client_secret.label': 'Auth Key',
  'social-connection.settings.field.apple.client_secret.placeholder': 'エクソーラキーを使用する場合は空白にする',
  'social-connection.settings.field.apple.client_secret.file': 'キーファイル',
  'social-connection.settings.field.babka.audience.label': 'ウェブサイトリンク',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=2454%3A77981 */
  'settings.tabs.platform-settings': 'パブリッシングプラットフォーム',
  'settings.platform-settings.connect': '接続',
  'settings.platform-settings.update': '申し込む',
  'settings.platform-settings.select.all': '全てのパブリッシングプラットフォーム',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=745%3A38333 */
  'custom-providers.settings.email.title': 'メールサービスプロバイダー',
  'custom-providers.settings.email.subtitle': 'メールプロバイダーを構成し、メール通信の管理、監視、トラブルシューティングを独自に行うことができます。',
  'custom-providers.settings.email.notification': '<a>メールカスタマイズのページで、メールをカスタマイズします。</a>また、エクソーラのメールテンプレートをデフォルトで使用することも可能です。',
  'custom-providers.settings.email.settings.label': 'メール送信者設定',
  'custom-providers.settings.email.settings.description': '送信者の名前と送信者メールアドレスは、自分で指定することができます。指定しない場合、受信者には、ログインプロジェクトのデフォルトの送信者名と送信者メールアドレスが表示されます。',
  'custom-providers.settings.email.from_email.label': '送信者メールアドレス',
  'custom-providers.settings.email.from_email.placeholder': 'noreply@login.xsolla.com',
  'custom-providers.settings.email.from_email.footer': 'このメールアドレスは、受信者があなたからのメールを受信したときに表示されます。',
  'custom-providers.settings.email.from_name.label': '送信者の名前',
  'custom-providers.settings.email.from_name.footer': 'この名前は、受信者があなたからのメールを受信したときに表示されます。',
  'custom-providers.settings.email.provider.notification': 'デフォルトプロバイダーとしてSendGridを使用します。SendGrid APIキーは常にエクソーラのデータベースで暗号化されて保持されます。',
  'custom-providers.settings.email.provider.send-grid': 'SendGrid',
  'custom-providers.settings.email.provider.send-grid.label': 'プロバイダー設定',
  'custom-providers.settings.email.provider.send-grid.description': 'SendGridアカウントにサインアップし、<a>APIキー</a>を取得します。',
  'custom-providers.settings.email.provider.send-grid.api-key.label': 'APIキー',
  'custom-providers.settings.email.provider.send-grid.api-key.placeholder': 'SendGrid APIキー',
  'custom-providers.settings.email.provider.smtp': 'カスタム（近日公開）',
  'custom-providers.settings.email.provider.smtp.label': 'プロバイダー設定',
  'custom-providers.settings.email.provider.smtp.description': 'SMTP認証情報は常に暗号化され、弊社のデータベースに保存されます。設定を保存し、「テストメールを送信する」ボタンを使って接続をテストしてください。<a>詳しくは説明をご覧ください。</a>',
  'custom-providers.settings.email.provider.smtp.notification': 'SMTPサーバーへの要件：<ul><li>ユーザー名とパスワードによる認証に対応する</li><li>TLS 1.0以上に対応する</li></ul>',
  'custom-providers.settings.email.provider.smtp.host.label': 'ホスト',
  'custom-providers.settings.email.provider.smtp.host.placeholder': 'your.smtp.host.com',
  'custom-providers.settings.email.provider.smtp.host.sublabel': 'SMTPサーバーのホスト名またはIPアドレス',
  'custom-providers.settings.email.provider.smtp.port.label': 'ポート',
  'custom-providers.settings.email.provider.smtp.port.placeholder': '587',
  'custom-providers.settings.email.provider.smtp.port.sublabel': 'SMTPサーバーが使用するポート。一般的なポートは25、465、587です。<br></br>ポート25の使用は、多くのプロバイダーが制限しているため、できるだけ避けてください',
  'custom-providers.settings.email.provider.smtp.username.label': 'ユーザー名',
  'custom-providers.settings.email.provider.smtp.username.placeholder': 'カスタムプロバイダーのユーザー名',
  'custom-providers.settings.email.provider.smtp.password.label': 'パスワード',
  'custom-providers.settings.email.provider.smtp.password.placeholder': 'カスタムプロバイダーのパスワード',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A87099 */
  'miscellaneous.settings.title': 'その他のデータフォーム',
  'miscellaneous.settings.subtitle': '登録時に必要なデータが提供されていない場合は、追加のフォームを使用してください。追加の検証としてデータフォームを使用すると、ユーザーの認証が正常に行われます。これらのフォームは、収集されたメールアドレスや電話番号を確認します。',
  'miscellaneous.settings.email.title': 'メールアドレスフォーム',
  'miscellaneous.settings.email.subtitle': 'メールアドレスは、登録時に必要なデータが提供されていない場合や、認証方法としてソーシャルネットワークが利用できる場合には、追加フォームとなります。',
  'miscellaneous.settings.email.collect-data.title': 'ユーザーメールアドレスを収集する',
  'miscellaneous.settings.email.collect-data.subtitle': '収集された電子メールアドレスを、ユーザーに電子メールで送信される確認コードまたはリンクで確認します。',
  'miscellaneous.settings.email.required.title': 'メールフォームへの記入をユーザーに要求する',
  'miscellaneous.settings.email.required.subtitle': 'このトグルがオンに設定されている場合、ユーザーは追加データ収集フォームへの記入を求められます。オフに設定されている場合は、ユーザーはフォームの記入を省略することができます。',
  'miscellaneous.settings.email.confirmation.title': 'メールアドレスの確認方法',
  'miscellaneous.settings.email.confirmation.code.title': 'コードによる',
  'miscellaneous.settings.email.confirmation.code.description': 'ユーザーに送信されるコードによる確認。',
  'miscellaneous.settings.email.confirmation.link.title': 'コードとリンクによる',
  'miscellaneous.settings.email.confirmation.link.description': 'ユーザーにメールされたコードとリンクによる確認。',
  'miscellaneous.settings.email.confirmation.link-only.title': 'リンク経由',
  'miscellaneous.settings.email.confirmation.link-only.description': 'ユーザーにメールで送信されたリンク経由の確認。',
  'miscellaneous.settings.phone_number.title': '電話番号フォーム',
  'miscellaneous.settings.phone_number.subtitle': '電話番号は、登録時に必要なデータが提供されていない場合や、認証方法としてソーシャルネットワークが利用できる場合には、追加フォームとなります。',
  'miscellaneous.settings.phone_number.collect-data.title': 'ユーザーの電話番号を収集する',
  'miscellaneous.settings.phone_number.collect-data.subtitle': '収集した電話番号をSMSで送信される確認コードで確認します。',
  'miscellaneous.settings.phone_number.required.title': '電話番号への記入をユーザーに要求する',
  'miscellaneous.settings.phone_number.required.subtitle': 'このトグルがオンに設定されている場合、ユーザーは追加データ収集フォームへの記入を求められます。オフに設定されている場合は、ユーザーはフォームの記入を省略することができます。',
  'miscellaneous.settings.order.title': 'フォーム順序',
  'miscellaneous.settings.order.subtitle': '確認画面は、選択した順番でユーザーに表示されます。',
  'miscellaneous.settings.order.notification': 'このオプションを使用するには、メールアドレスと電話番号の両方のフォームを有効にする必要があります。',
  'miscellaneous.settings.order.email': 'メールフォーム優先',
  'miscellaneous.settings.order.phone': '電話番号フォーム優先',

  'api-settings.title': 'Login API統合',
  'api-settings.subtitle': 'Login APIとの統合を構成します。',
  'api-settings.device-id.title': 'デバイスIDでログインする',
  'api-settings.device-id.subtitle': '<a>APIコール</a>により、ユーザーのデバイスIDを使ったログインを可能にします。',

  'auth-methods.login_pass_auth': 'メールアドレス/パスワード',
  'auth-methods.email_auth': 'メール経由でパスワードレス',
  'auth-methods.phone_auth': '電話経由でパスワードレス',
  'auth-methods.telegram': 'Telegram',
  'auth-methods.other': '他',
  'auth-methods.google': 'Google',
  'auth-methods.abyss': 'The Abyss',
  'auth-methods.apple': 'Apple',
  'auth-methods.epicgames': 'Epic Games',
  'auth-methods.amazon': 'Amazon',
  'auth-methods.babka': 'エクソーラ',
  'auth-methods.baidu': '百度',
  'auth-methods.battlenet': 'Battle.net',
  'auth-methods.china_telecom': '中国電信',
  'auth-methods.discord': 'Discord',
  'auth-methods.facebook': 'Facebook',
  'auth-methods.github': 'GitHub',
  'auth-methods.google-plus': 'Google+',
  'auth-methods.instagram': 'Instagram',
  'auth-methods.kabam': 'Kabam',
  'auth-methods.kakao': 'KakaoTalk',
  'auth-methods.linkedin': 'LinkedIn',
  'auth-methods.mailru': 'Mail.Ru',
  'auth-methods.microsoft': 'Microsoft アカウント',
  'auth-methods.msn': 'MSN',
  'auth-methods.naver': 'ネイバー（NAVER）',
  'auth-methods.ok': 'OK',
  'auth-methods.paradox': 'Paradox',
  'auth-methods.paypal': 'PayPal',
  'auth-methods.pinterest': 'Pinterest',
  'auth-methods.playfab': 'PlayFab',
  'auth-methods.wbgames': 'Player Network',
  'auth-methods.qq': 'QQ',
  'auth-methods.reddit': 'Reddit',
  'auth-methods.steam': 'Steam',
  'auth-methods.stone': 'Stone',
  'auth-methods.twitch': 'Twitch',
  'auth-methods.twitter': 'X',
  'auth-methods.vimeo': 'Vimeo',
  'auth-methods.vk': 'VK',
  'auth-methods.wechat': 'WeChat',
  'auth-methods.weibo': '微博（ウェイボー）',
  'auth-methods.xbox': 'Xbox Live',
  'auth-methods.xsolla-id': 'Xsolla',
  'auth-methods.yahoo': 'Yahoo',
  'auth-methods.yandex': 'ヤンデックス',
  'auth-methods.youtube': 'YouTube',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A86451 */
  'enterprise-connection.settings.title': 'OAuth 2.0 ログイン接続',
  'enterprise-connection.settings.subtitle': 'OAuth 2.0を介してエクソーラにリンクされた認証インターフェイス経由でユーザーがログインできるようにします。',
  'enterprise-connection.settings.notification': 'OAuthログイン接続を使用するには、以下のフィールドに入力してください。サポートが必要な場合は、<a>カスタマーサクセスマネージャーにお問い合わせください</a>。',
  'enterprise-connection.settings.integration-name.label': '認証名',
  'enterprise-connection.settings.integration-name.tooltip': 'エクソーラログインでのOAuth 2.0統合を識別するために使用されます',
  'enterprise-connection.settings.integration-name.placeholder': 'xsolla-oauth2',
  'enterprise-connection.settings.authorization-endpoint.label': '認証URL',
  'enterprise-connection.settings.authorization-endpoint.placeholder': 'https://example.com',
  'enterprise-connection.settings.authorization-endpoint.tooltip': '認証とアクセスのためにユーザーがリダイレクトされる認証サーバーのエンドポイントのURL',
  'enterprise-connection.settings.token-endpoint.label': 'トークンURL',
  'enterprise-connection.settings.token-endpoint.placeholder': 'https://example.com',
  'enterprise-connection.settings.token-endpoint.tooltip': '認証に成功した後、アクセストークンを取得する認証サーバートークンエンドポイントのURL',
  'enterprise-connection.settings.url_resource_owner_details.label': '情報URL',
  'enterprise-connection.settings.url_resource_owner_details.placeholder': 'https://example.com',
  'enterprise-connection.settings.url_resource_owner_details.tooltip': '認証サーバーのユーザー情報エンドポイントのURL',
  'enterprise-connection.settings.client-id.label': 'クライアントID',
  'enterprise-connection.settings.client-id.placeholder': '1234',
  'enterprise-connection.settings.client-id.tooltip': '認証システムで作成された一意のID\n',
  'enterprise-connection.settings.client-secret.label': 'クライアント秘密鍵',
  'enterprise-connection.settings.client-secret.placeholder': '123a12b1234ab1234a1ab1234abc1234',
  'enterprise-connection.settings.client-secret.tooltip': '認可サーバーによって提供されます',
  'enterprise-connection.settings.scope.label': '許可範囲',
  'enterprise-connection.settings.scope.placeholder': '例: メールアドレス、オフラインなど。',
  'enterprise-connection.settings.map.title': 'キー名のマップ',
  'enterprise-connection.settings.map.description': 'トークンのユーザー属性のキー名を入力して、Xsolla Loginと同期するデータを入力します。',
  'enterprise-connection.settings.map.notification': '右側のフィールドにキー名を入力します。これらは左側の対応するフィールドにマップされます。',
  'enterprise-connection.settings.delete': 'ログイン接続を削除する',
  'enterprise-connection.settings.map.email.placeholder': "トークンからのメールアドレスキー名",
  'enterprise-connection.settings.map.id.placeholder': "トークンからのIDキー名",
  "enterprise-connection.settings.customization.title": "カスタマイズ",
  "enterprise-connection.settings.customization.subtitle": "ログインウィジェットの認証ボタン表示を設定する",
  "enterprise-connection.settings.customization.display_name.label": "認証ボタン名",
  "enterprise-connection.settings.customization.display_name.tooltip": "この名前はユーザーに表示されます",
  "enterprise-connection.settings.customization.background_color.label": "認証ボタンの色",
  "enterprise-connection.settings.customization.logo_url.label": "ロゴ",
  "enterprise-connection.settings.customization.logo_url.footer": "推奨サイズ：24px × 24px{newLine}対応する形式：JPG、PNG、SVG",

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=6751%3A97166 */
  'custom-providers.bread-crumbs.label': '通信プロバイダー',
  'custom-providers.tabs.email': 'メールプロバイダー',
  'custom-providers.tabs.sms': 'SMSプロバイダー',
  'custom-providers.tabs.send-sms.button': 'テストSMSを送信',
  'custom-providers.tabs.send-email.button': 'テストメールを送信',

  'custom-providers.settings.sms.title': 'SMSサービスプロバイダー',
  'custom-providers.settings.sms.fields-group.active': '有効',
  'custom-providers.settings.sms.fields-group.inactive': '無効',
  'custom-providers.settings.sms.fields-group.list-item.activate': 'プロバイダーを有効化する',
  'custom-providers.settings.sms.fields-group.list-item.deactivate': 'プロバイダーを無効化する',
  'custom-providers.settings.sms.subtitle': 'SMSプロバイダーが認証方法としてコード付きSMSを使用するように設定することができます。',
  'custom-providers.settings.sms.notification': 'デフォルトでは、Amazon SNS、Twilio、Sinch、Telnyx、Telnyx、SMSCENTER及びAlibaba CloudをSMSプロバイダーとして使用することができます。複数のプロバイダーを利用することも可能で、個別に有効化または無効化することもできます。複数のプロバイダーを有効化した場合、各国ごとに最適なプロバイダーを使用します。',
  'custom-providers.settings.sms.msp.read-more': '<a>メッセージングサービスの価格について詳しくはこちら。</a>',
  'custom-providers.settings.sms.provider.sender-id.label': '送信者ID',
  'custom-providers.settings.sms.provider.sender-id.placeholder': 'your.smtp.host.com',
  'custom-providers.settings.sms.provider.sender-id.sublabel': '<a>SMSメッセージの送信者を特定するためのアルファベット名</a>',
  'custom-providers.settings.sms.provider.amazon': 'Amazon SNS',
  'custom-providers.settings.sms.provider.amazon.label': 'Amazon SNS設定',
  'custom-providers.settings.sms.provider.amazon.description': 'Amazonアカウントにサインアップし、ドメインの認証とプロダクションへのアクセスをリクエストすることで、<a>Amazon SNSを構成</a>します。',
  'custom-providers.settings.sms.provider.amazon.phone.label': 'Amazon SNS電話番号',
  'custom-providers.settings.sms.provider.amazon.key-id.label': 'アクセスキーID',
  'custom-providers.settings.sms.provider.amazon.access-key.label': '秘密アクセスキー',
  'custom-providers.settings.sms.provider.amazon.region.label': '地域',
  'custom-providers.settings.sms.provider.amazon.region.sublabel': '<a>あなたのAWS SNS地域</a>',
  'custom-providers.settings.sms.provider.twilio': 'Twilio',
  'custom-providers.settings.sms.provider.twilio.label': 'Twilio 設定',
  'custom-providers.settings.sms.provider.twilio.description': 'Twilioアカウントをセットアップし、<a>Programmable Messaging APIを構成</a>します。',
  'custom-providers.settings.sms.provider.twilio.sid.label': 'Twilio SID',
  'custom-providers.settings.sms.provider.twilio.sid.sublabel': '<a>Twilio SIDについて詳しくはこちら</a>',
  'custom-providers.settings.sms.provider.twilio.auth-token.label': 'Twilio Authトークン',
  'custom-providers.settings.sms.provider.twilio.auth-token.sublabel': '<a>Twilio Authトークンについて詳しくはこちら</a>。',
  'custom-providers.settings.sms.provider.twilio.phone.label': 'Twilio電話番号',
  'custom-providers.settings.sms.provider.sinch': 'Sinch',
  'custom-providers.settings.sms.provider.sinch.label': 'Sinch設定',
  'custom-providers.settings.sms.provider.sinch.description': 'Sinchアカウントをセットアップし、<a>SMS messaging APIを構成</a>します。',
  'custom-providers.settings.sms.provider.sinch.plan-id.label': 'SinchサービスプランID',
  'custom-providers.settings.sms.provider.sinch.plan-id.sublabel': '<a>SinchサービスプランIDについて詳しくはこちら</a>。',
  'custom-providers.settings.sms.provider.sinch.auth-token.label': 'Sinch API トークン',
  'custom-providers.settings.sms.provider.sinch.phone.label': 'Sinch 電話番号',
  'custom-providers.settings.sms.provider.telnyx': 'Telnyx',
  'custom-providers.settings.sms.provider.telnyx.label': 'Telnyx設定',
  'custom-providers.settings.sms.provider.telnyx.description': 'Telnyxアカウントをセットアップし、<a>SMS APIを構成</a>します。',
  'custom-providers.settings.sms.provider.telnyx.app-id.label': 'Telnyx Messaging Profile ID',
  'custom-providers.settings.sms.provider.telnyx.api-key.label': 'Telnyx  APIキー',
  'custom-providers.settings.sms.provider.telnyx.phone.label': 'Telnyx 電話番号',
  'custom-providers.settings.sms.provider.smscenter': 'SMSCENTER',
  'custom-providers.settings.sms.provider.smscenter.label': 'SMSCENTER設定',
  'custom-providers.settings.sms.provider.smscenter.description': 'SMSCENTERをセットアップし、<a>SMS APIを構成</a>します。',
  'custom-providers.settings.sms.provider.smscenter.app-id.label': 'SMSCENTERのログイン',
  'custom-providers.settings.sms.provider.smscenter.app-secret.label': 'SMSCENTERのパスワード',
  'custom-providers.settings.sms.provider.smscenter.sender-id.label': '送信者の名前',
  'custom-providers.settings.sms.provider.alibaba': 'Alibaba Cloud',
  'custom-providers.settings.sms.provider.alibaba.label': 'Alibaba Cloud設定',
  'custom-providers.settings.sms.provider.alibaba.description': 'Alibaba Cloudをセットアップし、<a>SMS APIを構成</a>します。',
  'custom-providers.settings.sms.provider.alibaba.app-id.label': 'アクセスキーID',
  'custom-providers.settings.sms.provider.alibaba.app-secret.label': '秘密アクセスキー',
  'custom-providers.settings.sms.provider.alibaba.sender-id.label': '送信者ID',

  'user-data-base.breadcrumb.label': 'ユーザーデータベース',
  'user-data-base.settings.tabs.users': 'ユーザー',
  'user-data-base.settings.tabs.data-storage': 'データストレージ',
  'user-data-base.settings.tabs.user-supplementary-info': 'ユーザー補足情報',

  /* User storage https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=1943%3A66839 */
  'user-data-base.settings.title': 'ユーザーデータストレージ',
  'user-data-base.settings.subtitle': '製品の機能は、選択されたユーザーデータの保存方法に依存します。',
  'user-data-base.settings.user-storage.xsolla.label': 'エクソーラストレージ',
  'user-data-base.settings.user-storage.xsolla.description': 'デフォルトメソッド。ユーザーデータはエクソーラ側で保存されます。',
  'user-data-base.settings.user-storage.custom.label': 'カスタムストレージ',
  'user-data-base.settings.user-storage.custom.description': 'ユーザーデータはエクソーラ側で保存されますが、パスワードはカスタムストレージを介して検証されます。',
  'user-data-base.settings.user-storage.custom.notification.title': 'カスタムストレージで以下のことを実現できます：',
  'user-data-base.settings.user-storage.custom.notification.description': '<ul><li>ユーザー登録</li><li>ユーザー名とパスワードによるユーザー認証</li><li>ソーシャルネットワークによるユーザー認証</li><li>ユーザーパスワードのリセット</li><li>ユーザーをブロックする</li></ul>',
  'user-data-base.settings.user-storage.custom.login_url.label': 'ユーザー確認URL',
  'user-data-base.settings.user-storage.custom.login_url.link': 'ユーザー認証のリクエスト例',
  'user-data-base.settings.user-storage.custom.registration_url.label': '新規ユーザーURL',
  'user-data-base.settings.user-storage.custom.registration_url.link': '新規ユーザーのリクエスト例',
  'user-data-base.settings.user-storage.custom.password_reset_url.label': 'パスワードリセットURL',
  'user-data-base.settings.user-storage.custom.password_reset_url.link': 'パスワードリセットのリクエスト例',
  'user-data-base.settings.user-storage.custom.email_change_url.label': 'メールアドレス変更URL',
  'user-data-base.settings.user-storage.custom.email_change_url.link': 'メールアドレス変のリクエスト例',
  'user-data-base.settings.user-storage.custom.passwordless_registration_url.label': 'パスワードレスログインURL',
  'user-data-base.settings.user-storage.custom.passwordless_registration_url.link': 'パスワードレスログインのリクエスト例',
  'user-data-base.settings.user-storage.custom.social_url.label': 'ソーシャルログインURL',
  'user-data-base.settings.user-storage.custom.social_url.link': 'ソーシャルログインのリクエスト例',
  'user-data-base.settings.user-storage.custom.refresh_token_url.label': 'トークン更新URL',
  'user-data-base.settings.user-storage.custom.refresh_token_url.link': 'トークン更新リクエストの例',
  'user-data-base.settings.user-storage.custom.add_social_access_token.label': 'ソーシャルネットワークにトークンへのアクセスを許可する',
  'user-data-base.settings.user-storage.custom.add_user_account_linking.label': 'ユーザーアカウントリンクを有効にする',
  'user-data-base.settings.user-storage.custom.add_user_account_linking.description': 'このオプションを有効にすると、同じserver_custom_idを共有するすべてのアカウントを単一のユーザーとして扱うことができます。',
  'user-data-base.settings.user-storage.playfab.label': 'PlayFab',
  'user-data-base.settings.user-storage.playfab.description': 'ユーザーデータはエクソーラ側に保存されますが、パスワードはPlayFab経由で検証されます。',
  'user-data-base.settings.user-storage.playfab.notification.title': 'PlayFabでは、以下のことができます：',
  'user-data-base.settings.user-storage.playfab.notification.description': '<ul><li>ユーザー登録</li><li>メールアドレスとパスワードによるユーザー認証</li><li>Twitchによるユーザー認証</li><li>ユーザーパスワードのリセット</li><li>ユーザーをブロックする</li></ul>',
  'user-data-base.settings.user-storage.playfab.title-id.notification': 'タイトルIDのフィールドには、PlayFabアカウントの同フィールドの値を入力します。',
  'user-data-base.settings.user-storage.playfab.playfab_title_id.label': 'タイトル ID',
  'user-data-base.settings.user-storage.playfab.playfab_title_id.link': 'タイトルIDの取得方法',
  'user-data-base.settings.user-storage.firebase.label': 'Firebase',
  'user-data-base.settings.user-storage.firebase.description': 'ユーザーデータはJSON形式で保存され、接続されたクライアントごとにリアルタイムに更新されます。',
  'user-data-base.settings.user-storage.firebase.notification': 'タイトルIDのフィールドには、PlayFabアカウントの同フィールドの値を入力します。',
  'user-data-base.settings.user-storage.firebase.firebase_apikey.label': 'APIキー',
  'user-data-base.settings.user-storage.firebase.firebase_apikey.link': 'APIキーの取得方法',

  'user-data-base.settings.supplementary-info.main.title': 'ユーザー補足情報',
  'user-data-base.settings.supplementary-info.main.subtitle': 'ユーザーから必要な情報を収集するために、追加のフォームを使用します。ユーザーは登録後、このフォームに記入することができます。',
  'user-data-base.settings.supplementary-info.main.notification': 'データを収集するために、標準のフィールドを使用するか、カスタムフィールドを追加することができます。このデータは、ユーザーデータベースのユーザープロファイルに保存されます。星印のアイコンをクリックすると、そのフィールドを必須項目にすることができます。',
  'user-data-base.settings.supplementary-info.fields-additional': 'ユーザー情報を追加するためのフィールド',
  'user-data-base.settings.supplementary-info.field.email': 'メール',
  'user-data-base.settings.supplementary-info.field.username': 'ユーザー名',
  'user-data-base.settings.supplementary-info.field.password': 'パスワード',
  'user-data-base.settings.supplementary-info.field.given-name': '苗字',
  'user-data-base.settings.supplementary-info.field.family-name': '名前',
  'user-data-base.settings.supplementary-info.field.bday': '生年月日',
  'user-data-base.settings.supplementary-info.field.gender': '性別',
  'user-data-base.settings.supplementary-info.field.country-name': '国',
  'user-data-base.settings.supplementary-info.field.phone_number': '電話番号',
  'user-data-base.settings.supplementary-info.field.promo_email_agreement': 'ニュースレター',
  'user-data-base.settings.supplementary-info.field.additional_agreement': '追加契約',
  'user-data-base.settings.supplementary-info.field.standart-field': '標準のフィールドの名前とタイプを変更することはできません。',
  'user-data-base.settings.supplementary-info.field.required': '星印のアイコンをクリックすると、そのフィールドは必須となります。',
  'user-data-base.settings.supplementary-info.field-type.str': '短いテキストによる回答',
  'user-data-base.settings.supplementary-info.field-type.pass': 'パスワード',
  'user-data-base.settings.supplementary-info.field-type.date': '日付ピッカー',
  'user-data-base.settings.supplementary-info.field-type.bool': 'チェックボックス',
  'user-data-base.settings.supplementary-info.field-type.email': 'メール',
  'user-data-base.settings.supplementary-info.field-type.select': '選択',
  'user-data-base.settings.supplementary-info.field-type.phone': '電話番号',
  'user-data-base.settings.supplementary-info.default-language.notification': 'カスタムフィールド名を英語で入力して、正しくローカライズできるようにします。',
  'user-data-base.settings.supplementary-info.age-restrict': '年齢制限が必要ですか？<a>年齢制限の設定に移動してください。</a>',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=7945%3A99727 */
  'user-data-base.settings.tabs.user-attributes': 'ユーザー属性スキーマ',
  'user-data-base.settings.attributes.title': 'ユーザー属性スキーマ',
  'user-data-base.settings.attributes.subtitle': 'ユーザー属性とは、ユーザーのメタデータであり、データアクセスの管理やユーザーごとにカスタマイズされたエクスペリエンスを提供するために利用することができます。<br></br>JSONスキーマを追加し、属性設定処理を改善します。',
  'user-data-base.settings.attributes.notification': 'JSONスキーマでは、以下のようなことが可能です：<ul><li>既存のデータフォーマットについて説明します。</li><li>人間や機械が読みやすい明らかなドキュメンテーションを持つ。</li><li>クライアントから提出されたデータの自動テストと品質保証のためのデータ検証を行う。</li></ul>',
  'user-data-base.settings.attributes.notification-link': '詳細については、<a>JSONスキーマの仕様を参照してください。</a>',
  'user-data-base.settings.attributes.field.title': 'ユーザー属性の仕様',
  'user-data-base.settings.attributes.error.title': '無効なスキーマ',
  'user-data-base.settings.attributes.error.default': 'JSONスキーマが無効で、または、定義された属性のネスティングレベルが1より高くなっています。',
  'user-data-base.settings.attributes.error.characters': "JSONスキーマに無効な文字 \'{characters}\' が1つまたは複数含まれています。",
  'user-data-base.settings.attributes.error.type': "\'{name}\'属性は、文字列、数値、整数、またはブール値のいずれかのタイプである必要があります。",
  'user-data-base.settings.attributes.error.properties-required': "属性フィールドは必須です。",

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=5898%3A102126
  'mfa.settings.title': '多要素認証ポリシー',
  'mfa.settings.subtitle': '多要素認証は、不正なアクセスを防ぐために、ユーザーがログインの過程で追加のステップを完了させるものです。',
  'mfa.settings.usage.title': '多要素認証の利用',
  'mfa.settings.usage.subtitle': '多要素認証が適用される時点を選択してください。',
  'mfa.settings.never.title': 'なし',
  'mfa.settings.never.description': 'ユーザーはログインのための追加手続きをする必要がありません。',
  'mfa.settings.adaptive.title': '多要素認証の適応的な利用',
  'mfa.settings.adaptive.description': 'ユーザーは、ログインの試行が危険であると考えられる場合にのみ、追加のステップを完了する必要があります。',
  'mfa.settings.always.title': '常に',
  'mfa.settings.always.description': 'ログインするためには、必ず追加の手続きが必要です。',
  'mfa.settings.risk.title': '多要素認証を有効にする',
  'mfa.settings.risk.description': 'このスイッチをオンにすると、すべてのユーザーがメールを通じてMFAでログインすることが必須になります。',
  'mfa.settings.url.title': '多要素認証URL',
  'mfa.settings.url.description': 'ユーザーはこのURLにリダイレクトされ、多要素認証プロセスを完了します。',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3944%3A84284
  'settings.signature.title': 'JWT署名',
  'settings.signature.subtitle': 'JWT署名の暗号化方式は、以下のいずれかを選択してください。',
  'settings.signature.notification': 'デフォルトでは、秘密鍵は非表示になっており、機密情報へのアクセスを提供することができるため、秘密を保持する必要があります。',
  'settings.signature.copy': 'キーをコピー',
  'settings.signature.hmac.label': '秘密鍵',
  'settings.signature.hmac.new.label': '新しい秘密鍵',
  'settings.signature.rsa.label': 'JSONウェブ公開鍵',
  'settings.signature.rsa.new.label': '新しいJSONウェブ公開鍵',
  'settings.signature.hmac.switch.title': 'HS256（SHA-256を使用するHMAC）',
  'settings.signature.hmac.switch.caption': 'HS256は、JWTの署名と検証のために1つの秘密鍵を使用します。この秘密鍵は、JWTの検証のためにあなた側で保存しておく必要があります。',
  'settings.signature.rsa.switch.title': 'RS256（SHA-256を使用するRSA署名）',
  'settings.signature.rsa.switch.caption': 'RS256は、JWTの署名に使用される秘密鍵とJWTの検証に使用される公開鍵による非対称アルゴリズムである。',
  'settings.signature.reset.title': '新しいキーを適用しますか？',
  'settings.signature.reset.hmac.title': '秘密鍵をリセット',
  'settings.signature.reset.rsa.title': 'JSONウェブキーをリセット',
  'settings.signature.reset.hmac.description': '新しいキーを適用すると、現在の秘密鍵を回復することはできません。',
  'settings.signature.reset.rsa.description': '新しいキーを適用した後、現在のJSONウェブ公開鍵を復元することはできません。',
  'settings.signature.reset.description': 'すべてのアプリケーションが新しいキーで更新されていることを確認してください。<br></br>すべての新しいJWTは、新しい鍵によって署名されます。',
  'settings.signature.reset.checkbox': '同意する',
  'settings.signature.reset.submit': 'はい、適用する',
  'settings.signature.token-lifetime.title': 'トークンの有効期限',
  'settings.signature.token-lifetime.description': 'トークンは有効期限が切れると失効します。<br></br>デフォルトの有効期限は1日（86400秒）です。',
  'settings.signature.token-lifetime.description-oauth': 'OAuth 2.0トークンは有効期限が切れると失効します。<br></br>デフォルトの有効期限は1時間（3600秒）です。',
  'settings.signature.token-lifetime.seconds': '秒',
  'settings.signature.notification.title': '新しいキーが生成されました',
  'settings.signature.notification.caption': '新しいキーをコピーして、依存するすべてのアプリケーションに適用します。すべてのアプリケーションに適用した後、「変更を保存」をクリックしてください。',
  'settings.signature.long-token-checkbox': 'トークンの有効期限が5日を超えています。確認するにはチェックボックスをクリックしてください。',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=5647%3A93743 */
  'sms-customization.settings.title': 'SMSのカスタマイズ',
  'sms-customization.settings.subtitle': 'ユーザーに送信するコードでSMSメッセージをカスタマイズします。',
  'sms-customization.settings.main.notification': 'SMSメッセージに独自のテキストを使用するには、必須なテキストを追加してください。それ以外の場合は、エクソーラの標準的な確認メッセージが表示されます。<p>Liquid Syntaxを利用してメッセージをカスタマイズする方法について説明します。</p>',
  'sms-customization.settings.input.title': '登録とログインのメッセージ',
  'sms-customization.settings.phone_auth_code.title': '登録とログインのメッセージ',
  'sms-customization.settings.phone_auth_code.description': 'このメッセージは、ユーザーがログインまたはサインアップするたびに送信されます。',
  'sms-customization.settings.phone_auth_code.placeholder': '例：{{code}}は{{Game}}の確認コードです。{{link}}でログインすることも可能です。',
  'sms-customization.settings.phone_auth_code.post-description': '{{code}}、{{Game}}および{{link}}のタグは、自動的に実際の値に置き換えられます。このフィールドに実際のコード、リンク、名前を入力しないでください。',
  'sms-customization.settings.mfa_code.title': '多要素認証のメッセージ',
  'sms-customization.settings.mfa_code.description': 'このメッセージは、ユーザーが新しいデバイスで初めてログインするときに送信されます。<a>MFAメソッドを設定します。</a>',
  'sms-customization.settings.mfa_code.placeholder': '例：{{code}}は{{Game}}の確認コードです。',
  'sms-customization.settings.mfa_code.post-description': '{{code}}と{{Game}}のタグは、自動的に実際の値に置き換えられます。このフィールドに実際のコード、名前を入力しないでください。',
  'sms-customization.settings.limit-symbol.error': 'SMSのテキストは{number}文字以下でなければなりません。',
  'sms-customization.settings.not-code.error': 'テンプレートには、コード用のタグが必要です。',

  /* Custom scopes https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A81985 */
  'social-connection.settings.user-data.profile': 'プロファイル',
  'social-connection.settings.user-data.public-profile': 'パブリックプロファイル',
  'social-connection.settings.user-data.other-profile': 'すべてのユーザーのプロファイル',
  'social-connection.settings.user-data.id': 'ユーザーID',
  'social-connection.settings.user-data.email': 'ユーザーメールアドレス',
  'social-connection.settings.user-data.phone': '電話番号',
  'social-connection.settings.user-data.image': 'プロファイルイメージ',
  'social-connection.settings.user-data.name': '名前',
  'social-connection.settings.user-data.nickname': 'ニックネーム',
  'social-connection.settings.user-data.age-range': '年齢範囲',
  'social-connection.settings.user-data.birthday': '生年月日',
  'social-connection.settings.user-data.birthyear': '生年',
  'social-connection.settings.user-data.location': '場所',
  'social-connection.settings.user-data.gender': '性別',
  'social-connection.settings.user-data.hometown': '出身地',
  'social-connection.settings.user-data.address': '住所',
  'social-connection.settings.user-data.likes': 'いいね',
  'social-connection.settings.user-data.link': 'プロファイルURL',
  'social-connection.settings.user-data.postal-code': '郵便番号',
  'social-connection.settings.user-data.connections': 'SNSへ接続',
  'social-connection.settings.user-data.profile-instagram': 'Instagramプロファイル',
  'social-connection.settings.user-data.openid': 'OpenIDユーザー詳細',
  'social-connection.settings.user-data.guilds': 'ユーザーのギルドプロフィール',
  'social-connection.settings.user-data.long-token': '有効期限の長いトークン',
  'social-connection.settings.user-data.profile-d3': 'Diablo III プロフィール',
  'social-connection.settings.user-data.profile-sc2': 'StarCraft IIプロフィール',
  'social-connection.settings.user-data.profile-wow': 'World of Warcraft のキャラクター',
  'social-connection.settings.user-data.offline': 'オフラインアクセス',

  'social-connection.settings.permission.all': 'すべてのScopeをリクエストする',
  'social-connection.settings.permission.user': 'ユーザーのプロファイルを読み取る/更新する',
  'social-connection.settings.permission.user-subscriptions:read': 'ユーザーのサブスクリプションを読み取る',
  'social-connection.settings.permission.user-block:read': 'ブロックリストを表示する',
  'social-connection.settings.permission.user-block:write': 'ブロックリストを管理する',
  'social-connection.settings.permission.messenger-contact': 'メッセンジャー経由で連絡する',
  'social-connection.settings.permission.photos': '写真',
  'social-connection.settings.permission.posts': '記事',
  'social-connection.settings.permission.videos': '動画',
  'social-connection.settings.permission.groups': 'グループ',
  'social-connection.settings.permission.groups:read': 'グループ情報を読み取る',
  'social-connection.settings.permission.groups:write': 'グループ内容を管理する',
  'social-connection.settings.permission.groups:stats': 'グループ統計へのアクセス権',
  'social-connection.settings.permission.friends': 'フレンド',
  'social-connection.settings.permission.plusfriends': 'フレンド',
  'social-connection.settings.permission.stories': 'ストーリーへのアクセス権',
  'social-connection.settings.permission.status': 'ユーザーステータスへのアクセス権',
  'social-connection.settings.permission.notes': 'ユーザーノートへのアクセス権',
  'social-connection.settings.permission.wall': 'プロファイルフィード技術へのアクセス権',
  'social-connection.settings.permission.offline': 'APIへのオフラインアクセス権',
  'social-connection.settings.permission.notify': 'ユーザーに通知を送信する',
  'social-connection.settings.permission.market': '商品へのアクセス権',
  'social-connection.settings.permission.users': 'すべてのユーザーの完全なプロファイルの読み取り/更新',
  'social-connection.settings.permission.users-follow:read': 'ユーザーのフォローリストを表示する',
  'social-connection.settings.permission.users-follow:write': '他のユーザーをフォロー/フォロー解除する',
  'social-connection.settings.permission.users:invite': 'ゲストユーザーを組織に招待する',
  'social-connection.settings.permission.users:export': 'ユーザーをエクスポートする',
  'social-connection.settings.permission.users:manage': 'ユーザーIDを管理する',
  'social-connection.settings.permission.files': 'ユーザーのファイルへのアクセス権を取得する',
  'social-connection.settings.permission.send-messages': 'ユーザーにメッセージを送信する',
  'social-connection.settings.permission.country': '国',
  'social-connection.settings.permission.presence:read': 'ユーザーのプレゼンス情報を読み取る',
  'social-connection.settings.permission.presence:write': 'ユーザーのプレゼンス情報を読み取るまたは書き込む',
  'social-connection.settings.permission.activities:read': 'ユーザーアクティビティを読み取る',
  'social-connection.settings.permission.activities:write': 'ユーザーアクティビティを更新する',
  'social-connection.settings.permission.application:invite': 'ユーザーをアプリケーションに招待する',
  'social-connection.settings.permission.applications-builds:read': 'ビルドデータを読み取る',
  'social-connection.settings.permission.applications-builds:upload': 'ビルドデータをアップロードする',
  'social-connection.settings.permission.applications-commands': 'コマンドを使用する',
  'social-connection.settings.permission.applications-commands:update': 'コマンドを更新する',
  'social-connection.settings.permission.applications-entitlements': '資格を読み取る',
  'social-connection.settings.permission.applications-store:update': 'ストアデータを読み取る/更新する',
  'social-connection.settings.permission.bot': 'ボット',
  'social-connection.settings.permission.gdm:join': 'ギルドへの加入',
  'social-connection.settings.permission.guilds:join': 'ユーザーをギルドに加入させる',
  'social-connection.settings.permission.messages:read': 'ユーザーのメッセージを読み取る',
  'social-connection.settings.permission.messages:write': 'ユーザーのメッセージを読み取る/送信する',
  'social-connection.settings.permission.relationships:read': 'ユーザーの友達を取得する',
  'social-connection.settings.permission.rpc': 'RPCサーバーアクセス',
  'social-connection.settings.permission.rpc-activities:write': 'ユーザーアクティビティを更新する（RPC）',
  'social-connection.settings.permission.rpc-notifications:read': '通知を受信する（RPC）',
  'social-connection.settings.permission.rpc-voice:read': '音声設定を読み取る',
  'social-connection.settings.permission.rpc-voice:write': '音声設定を更新する',
  'social-connection.settings.permission.webhook-incoming': 'ウェブフックを生成する',
  'social-connection.settings.permission.identify:premium': 'プレミアムの識別 （Nitro）',
  'social-connection.settings.permission.ads:read': '広告を読み取る',
  'social-connection.settings.permission.ads:write': '広告を管理する',
  'social-connection.settings.permission.ads-report:read': '広告レポートを読み取る',
  'social-connection.settings.permission.ads-leads:read': '広告リードレポートを読み取る',
  'social-connection.settings.permission.ads-publishers:read': 'パブリッシャー向けの広告を読み取る',
  'social-connection.settings.permission.attribution:read': 'Attribution APIを読み取る',
  'social-connection.settings.permission.business:write': 'Business Manager APIを管理する',
  'social-connection.settings.permission.catalog:write': '製品カタログを管理する',
  'social-connection.settings.permission.gaming-user_locale': 'ユーザーのロケールを取得する',
  'social-connection.settings.permission.instagram:publish': 'Instagram写真を公開する',
  'social-connection.settings.permission.instagram-comments:write': 'Instagramコメントを管理する',
  'social-connection.settings.permission.instagram-insights:write': 'Instagramインサイトを読み取る',
  'social-connection.settings.permission.leads:read': 'リード獲得広告を読み取る',
  'social-connection.settings.permission.pages-events': 'Facebookページを管理する',
  'social-connection.settings.permission.ads-pages:write': 'Facebookページ広告を管理する',
  'social-connection.settings.permission.cta:write': '行動喚起のアクションを管理する',
  'social-connection.settings.permission.pages-articles:write': 'インスタント記事を管理する',
  'social-connection.settings.permission.pages-engagement:write': 'ページコメントを管理する',
  'social-connection.settings.permission.pages-metadata:write': 'ページのウェブフックを受信する',
  'social-connection.settings.permission.pages-posts:write': '投稿を管理する',
  'social-connection.settings.permission.pages-messaging': 'ページメッセージを管理する',
  'social-connection.settings.permission.pages-engagement:read': 'ページの内容を読み取る',
  'social-connection.settings.permission.pages-content:read': 'ページコメントを読み取る',
  'social-connection.settings.permission.pages-list': 'ユーザーのページを読み取る',
  'social-connection.settings.permission.pages-gender': 'ユーザーのページの性別を読み取る',
  'social-connection.settings.permission.pages-locale': 'ユーザーのページロケールを読み取る',
  'social-connection.settings.permission.pages-timezone': 'ユーザーのページのタイムゾーンを読み取る',
  'social-connection.settings.permission.social-user:write': 'ユーザーを介して投稿を管理する',
  'social-connection.settings.permission.social-org:read': '組織の投稿を表示する',
  'social-connection.settings.permission.social-org:write': '組織を介して投稿を管理する',
  'social-connection.settings.permission.video:write': 'ビデオを発表する',
  'social-connection.settings.permission.insights:read': 'ページのインサイトデータを読み取る',
  'social-connection.settings.permission.research-apis': 'Research APIへのアクセス権',
  'social-connection.settings.permission.repo': 'リポジトリへのフルアクセス',
  'social-connection.settings.permission.repo:status': 'コミット状態への読み取り/書き込みアクセス権',
  'social-connection.settings.permission.repo_deployment': 'アクセスデプロイメントステータス',
  'social-connection.settings.permission.public_repo': '公開リポジトリへのアクセス',
  'social-connection.settings.permission.repo:invite': '招待を受け入れる/拒否する',
  'social-connection.settings.permission.security_events': 'セキュリティイベントへの読み取り/書き込みアクセス権',
  'social-connection.settings.permission.admin:repo_hook': 'リポジトリフックへの管理者権限',
  'social-connection.settings.permission.write:repo_hook': 'リポジトリフックへの書き込みアクセス権',
  'social-connection.settings.permission.read:repo_hook': 'リポジトリフックへの読み取りアクセス権',
  'social-connection.settings.permission.admin:org': '組織への管理者権限',
  'social-connection.settings.permission.write:org': '組織への書き込みアクセス権',
  'social-connection.settings.permission.read:org': '組織への読み取りアクセス権',
  'social-connection.settings.permission.admin:public_key': '公開鍵への管理者権限',
  'social-connection.settings.permission.write:public_key': '公開鍵への書き込みアクセス権',
  'social-connection.settings.permission.read:public_key': '公開鍵への読み取りアクセス権',
  'social-connection.settings.permission.admin:org_hook': '組織フックへの管理者権限',
  'social-connection.settings.permission.gist': '要旨への書き込みアクセス権',
  'social-connection.settings.permission.notifications': 'ユーザー通知へのアクセス権',
  'social-connection.settings.permission.delete_repo': 'リポジトリを削除する',
  'social-connection.settings.permission.write:discussion': 'チームディスカッションへの書き込みアクセス権',
  'social-connection.settings.permission.read:discussion': 'チームディスカッションへの読み取りアクセス権',
  'social-connection.settings.permission.write:packages': 'パッケージを公開する権限',
  'social-connection.settings.permission.read:packages': 'パッケージをダウンロードする権限',
  'social-connection.settings.permission.delete:packages': 'パッケージを削除する権限',
  'social-connection.settings.permission.admin:gpg_key': 'GPGキーへの管理者権限',
  'social-connection.settings.permission.write:gpg_key': 'GPGキーへの書き込みアクセス権',
  'social-connection.settings.permission.read:gpg_key': 'GPGキーへの読み取りアクセス権',
  'social-connection.settings.permission.codespace': 'ワークスペースを作成および管理する',
  'social-connection.settings.permission.workflow': 'GitHub Actionsワークフローファイルを更新する',
  'social-connection.settings.permission.cloud-platform': 'クラウドプラットフォーム',
  'social-connection.settings.permission.adsense': 'AdSense',
  'social-connection.settings.permission.analytics': '分析',
  'social-connection.settings.permission.analytics-extensions': 'Twitch拡張機能のアナリティクス',
  'social-connection.settings.permission.analytics-games': 'ゲームのアナリティクス',
  'social-connection.settings.permission.appengine:admin': 'アプリエンジン',
  'social-connection.settings.permission.mail:read': 'ユーザーメールを読み取る',
  'social-connection.settings.permission.mail:write': 'ユーザーメールへの読み取りアクセス権と書き込みアクセス権',
  'social-connection.settings.permission.mail:send': 'ユーザーとしてメールを送信',
  'social-connection.settings.permission.bigquery': 'BigQuery',
  'social-connection.settings.permission.blogger': 'Blogger',
  'social-connection.settings.permission.books': 'ブック',
  'social-connection.settings.permission.calendar:read': 'カレンダーを読み取る',
  'social-connection.settings.permission.calendar:write': 'カレンダーを管理する',
  'social-connection.settings.permission.ddmconversions': 'DoubleClick Digital Marketing',
  'social-connection.settings.permission.bigtable': 'Cloud Bigtable',
  'social-connection.settings.permission.content': 'ショッピング',
  'social-connection.settings.permission.display-video': 'ディスプレイ＆ビデオ 360',
  'social-connection.settings.permission.doubleclickbidmanager': 'DoubleClick Bid Manager',
  'social-connection.settings.permission.files:read': 'ユーザーファイルを読み取る',
  'social-connection.settings.permission.files:write': 'ユーザーファイルに完全にアクセスできる',
  'social-connection.settings.permission.firebase': 'Firebase',
  'social-connection.settings.permission.fitness': 'フィットネス',
  'social-connection.settings.permission.ediscovery': 'G Suite Vault',
  'social-connection.settings.permission.classroom': 'クラスルーム',
  'social-connection.settings.permission.documents': 'Docs',
  'social-connection.settings.permission.androidpublisher': 'Google Play',
  'social-connection.settings.permission.games': 'Google Playゲームのアクティビティ',
  'social-connection.settings.permission.webmasters': 'サーチコンソール',
  'social-connection.settings.permission.presentations': 'スライド',
  'social-connection.settings.permission.spreadsheets': 'シート',
  'social-connection.settings.permission.manufacturercenter': 'Manufacturer Center',
  'social-connection.settings.permission.contacts:read': 'ユーザーの連絡先を読み取る',
  'social-connection.settings.permission.contacts:write': 'ユーザーの連絡先を管理する',
  'social-connection.settings.permission.photoslibrary': 'フォトライブラリー',
  'social-connection.settings.permission.tagmanager': 'タグ マネージャー',
  'social-connection.settings.permission.tasks': 'Tasks',
  'social-connection.settings.permission.youtube': 'YouTube',
  'social-connection.settings.permission.story:read': 'KakaoStoryの記事を読み取る',
  'social-connection.settings.permission.story:publish': 'KakaoStoryで公開する',
  'social-connection.settings.permission.talk:message': 'KakaoTalk',
  'social-connection.settings.permission.connections-1st:view': '第1度の関係を表示する',
  'social-connection.settings.permission.audience:write': '一致したAudienceを管理する',
  'social-connection.settings.permission.guestbook': 'ゲストブックに書き込む',
  'social-connection.settings.permission.apps:read': 'すべてのアプリカタログを読み取る',
  'social-connection.settings.permission.apps:write': 'すべてのアプリカタログを読み取るまたは書き込む',
  'social-connection.settings.permission.logs:read': '監査ログデータを読み取る',
  'social-connection.settings.permission.bookings:read': 'Bookingsの予定を読み取る',
  'social-connection.settings.permission.bookings:write': 'Bookingsの予定を管理する',
  'social-connection.settings.permission.call': '1対1のコールを開始する',
  'social-connection.settings.permission.call-group': 'グループコールの発信を開始する',
  'social-connection.settings.permission.device:read': 'ユーザーデバイスを読み取る',
  'social-connection.settings.permission.notes:read': 'ユーザーOneNoteノートブックを読み取る',
  'social-connection.settings.permission.notes:write': 'ユーザーOneNoteノートブックを読み取るまたは書き込む',
  'social-connection.settings.permission.tasks:read': 'ユーザーのタスクとタスクリストを読み取る',
  'social-connection.settings.permission.tasks:write': 'ユーザーのタスクを作成および更新する',
  'social-connection.settings.permission.credits': 'ゴールドクレジットを使用する',
  'social-connection.settings.permission.flair': 'ユーザーのFlairを管理する',
  'social-connection.settings.permission.votes:read': '投票履歴を読み取る',
  'social-connection.settings.permission.live-threads:read': 'ライブスレッドを管理する',
  'social-connection.settings.permission.modconfig': 'Subreddit構成をモデレートする',
  'social-connection.settings.permission.modcontributors': 'ユーザーの承認と禁止',
  'social-connection.settings.permission.modflair': 'フレアをモデレートする',
  'social-connection.settings.permission.modlog': 'モデレーションログ',
  'social-connection.settings.permission.modmail': '新しいModmail',
  'social-connection.settings.permission.modothers': '他のモデレーターを招待または削除する',
  'social-connection.settings.permission.modposts': '投稿をモデレートする',
  'social-connection.settings.permission.modself': 'モデレーターステータスを管理する',
  'social-connection.settings.permission.modwiki': 'Wikiをモデレートする',
  'social-connection.settings.permission.mysubreddits': 'マイSubreddit',
  'social-connection.settings.permission.report': 'レポート内容',
  'social-connection.settings.permission.save': 'コンテンツを保存',
  'social-connection.settings.permission.structuredstyles': '構造化スタイルを編集する',
  'social-connection.settings.permission.submit': 'コンテンツを送信',
  'social-connection.settings.permission.subscribe': 'マイサブスクリプションを編集',
  'social-connection.settings.permission.vote': '投票',
  'social-connection.settings.permission.wiki:edit': 'Wiki編集',
  'social-connection.settings.permission.wiki:read': 'Wikiページを読み取る',
  'social-connection.settings.permission.bits:read': 'ビットの情報を表示する',
  'social-connection.settings.permission.channel:edit:commercial': 'チャンネルでコマーシャルを配信する',
  'social-connection.settings.permission.channel:manage:broadcast': 'チャネルのブロードキャスト構成を管理する',
  'social-connection.settings.permission.channel:manage:extensions': 'チャンネルの拡張機能設定を管理する',
  'social-connection.settings.permission.channel:manage:polls': 'チャネルの投票を管理する',
  'social-connection.settings.permission.channel:manage:predictions': 'チャンネルのチャンネルポイント予想の管理',
  'social-connection.settings.permission.channel:manage:redemptions': 'チャンネルポイントのカスタム特典を管理する',
  'social-connection.settings.permission.channel:manage:schedule': 'チャンネルのストリームスケジュールを管理する',
  'social-connection.settings.permission.channel:manage:videos': 'チャンネルのビデオを管理する',
  'social-connection.settings.permission.channel:read:editors': '編集者ロールを持つユーザーを表示する',
  'social-connection.settings.permission.channel:read:goals': 'チャンネルの作成者目標を表示する',
  'social-connection.settings.permission.channel:read:hype_train': 'チャンネルのハイプトレイン情報を表示する',
  'social-connection.settings.permission.channel:read:polls': 'チャンネルのアンケートを表示する',
  'social-connection.settings.permission.channel:read:predictions': 'チャンネルのチャンネルポイント予測を表示する',
  'social-connection.settings.permission.channel:read:redemptions': 'チャンネルポイントのカスタム報酬を表示する',
  'social-connection.settings.permission.channel:read:stream_key': '承認済みユーザーのストリームキーを表示する',
  'social-connection.settings.permission.channel:read:subscriptions': 'すべての購読者のリストを表示する',
  'social-connection.settings.permission.clips:edit': 'チャネルのクリップを管理する',
  'social-connection.settings.permission.moderation:read': 'チャンネルのモデレーションデータを表示する',
  'social-connection.settings.permission.moderator:manage:banned_users': 'ユーザーの禁止と禁止解除',
  'social-connection.settings.permission.moderator:read:blocked_terms': 'ブロードキャスターのブロックされた用語のリストを表示する',
  'social-connection.settings.permission.moderator:manage:blocked_terms': 'ブロードキャスターのブロックされた用語のリストを管理する',
  'social-connection.settings.permission.moderator:manage:automod': 'AutoModでのメッセージを管理する',
  'social-connection.settings.permission.moderator:read:automod_settings': 'ブロードキャスターのAutoMod設定を表示する',
  'social-connection.settings.permission.moderator:manage:automod_settings': 'ブロードキャスターのAutoMod設定を管理する',
  'social-connection.settings.permission.moderator:read:chat_settings': 'ブロードキャスターのチャットルーム設定を表示する',
  'social-connection.settings.permission.moderator:manage:chat_settings': 'ブロードキャスターのチャットルーム設定を管理する',
  'social-connection.settings.permission.promo-codes:vimeo': 'Vimeoプロモーション',
  'social-connection.settings.permission.upload:vimeo': '動画をアップロードする',
  'social-connection.settings.permission.interact:vimeo': 'Vimeoリソースと連動する',
  'social-connection.settings.permission.delete:vimeo': '既存のVimeoリソースを削除する',
  'social-connection.settings.permission.edit:vimeo': '既存のVimeoリソースを編集する',
  'social-connection.settings.permission.create:vimeo': '新しいVimeoリソースを作成する',
  'social-connection.settings.permission.purchased:vimeo': '購入履歴へのアクセス権',
  'social-connection.settings.permission.audio': '録音へのアクセス権',
  'social-connection.settings.permission.fantasy-sport:read': 'Fantasy Sportsを読み取る',
  'social-connection.settings.permission.fantasy-sport:write': 'Fantasy Sportsを読み取る/書き込む',
  'social-connection.settings.permission.finance:read': 'ファイナンスを読み取る',
  'social-connection.settings.permission.finance:write': 'ファイナンスを読み取る/書き込む',

  'social-connection.settings.user-data.amazon.profile.help': 'プロファイルの範囲には、ユーザーの名前、ユーザーID、メールアドレスが含まれます。',
  'social-connection.settings.user-data.amazon.id.help': 'ユーザーIDScopeには、プロファイルのuser_idフィールドのみが含まれます。これはユーザーを一意に識別しますが、名前、メールアドレス、郵便番号は提供しません。',
  'social-connection.settings.user-data.amazon.postal-code.help': '郵便番号の範囲には、ユーザーの主要配送先住所の郵便番号が含まれます。',
  'social-connection.settings.user-data.apple.name.help': 'ユーザーのフルネーム。',
  'social-connection.settings.user-data.apple.email.help': 'ユーザーのメールアドレス。',
  'social-connection.settings.user-data.baidu.profile.help': '基本的なユーザー権限では、基本的なユーザー情報を取得できます。',
  'social-connection.settings.user-data.battlenet.openid.help': 'OpenID Connect（OIDC）を使用して、現在ログインしているユーザーの詳細にアクセスします。',
  'social-connection.settings.user-data.battlenet.profile-d3.help': 'ユーザーのDiablo III プロファイルにアクセスします。',
  'social-connection.settings.user-data.battlenet.profile-sc2.help': 'ユーザーのStarCraft II プロファイルにアクセスします。',
  'social-connection.settings.user-data.battlenet.profile-wow.help': 'ユーザーのWorld of Warcraftのキャラクターにアクセスします。',
  'social-connection.settings.user-data.discord.profile.help': 'メールなしで/users/@meを許可します。',
  'social-connection.settings.user-data.discord.email.help': 'メール返信するために/users/@meを有効にします。',
  'social-connection.settings.user-data.discord.connections.help': 'リンクされたサードパーティアカウントを返すために/users/@me/connectionsを許可します。',
  'social-connection.settings.user-data.discord.guilds.help': '全てのユーザーのギルドに関する基本情報を返すために/users/@me/guildsを許可します。',
  'social-connection.settings.user-data.epicgames.profile.help': 'ユーザー表示名、言語設定、リンク先アカウント表示名への読み取りアクセス権を与えます。',
  'social-connection.settings.user-data.facebook.profile.help': 'ユーザーノードの「既定のパブリックプロファイルフィールド」を読み取るためにアプリを許可します。この権限はすべてのアプリに自動的に付与されます。',
  'social-connection.settings.user-data.facebook.email.help': 'メール権限により、アプリはユーザーのプライマリメールアドレスを読み取ることができます。',
  'social-connection.settings.user-data.facebook.age-range.help': 'user_age_range権限により、アプリがFacebookプロフィールに記載されているユーザーの年齢範囲にアクセスすることができます。',
  'social-connection.settings.user-data.facebook.birthday.help': 'user_birthday権限により、アプリがFacebookプロフィールに記載されているユーザーの誕生日を読み取ることができます。',
  'social-connection.settings.user-data.facebook.gender.help': 'user_gender権限により、アプリがFacebookプロフィールに記載されているユーザーの性別を読み取ることができます。',
  'social-connection.settings.user-data.facebook.hometown.help': 'user_hometown権限により、アプリがFacebookプロフィールからユーザーの出身地を読み取ることができます。',
  'social-connection.settings.user-data.facebook.likes.help': 'user_likes権限により、アプリがユーザーは「いいね！」したすべてのFacebookページのリストを読み取ることができます。',
  'social-connection.settings.user-data.facebook.link.help': 'user_link権限により、アプリがアプリを使用しているユーザーのFacebookプロフィールURLにアクセスできます。',
  'social-connection.settings.user-data.facebook.location.help': 'user_location権限により、アプリがユーザーのFacebookプロフィールの場所フィールドにリストされている都市名を読み取ることができます。',
  'social-connection.settings.user-data.facebook.profile-instagram.help': 'instagram_basic権限により、アプリがInstagramアカウントのプロフィールの情報とメディアを読み取ることができます。',
  'social-connection.settings.user-data.github.public-profile.help': '公開情報（ユーザープロファイル情報、リポジトリ情報、Gistなど）への読み取り専用アクセス権を付与します。',
  'social-connection.settings.user-data.github.profile.help': 'ユーザーのプロファイルデータを読み取るためのアクセス権を付与します。',
  'social-connection.settings.user-data.github.email.help': 'ユーザーのメールアドレスへの読み取りアクセス権を付与します。',
  'social-connection.settings.user-data.google.profile.help': 'お客様が公開した個人情報を含む個人情報を表示します。',
  'social-connection.settings.user-data.google.email.help': 'メールアドレスを表示します。',
  'social-connection.settings.user-data.google.openid.help': 'Googleでのお客様の個人情報を関連付けます。',
  'social-connection.settings.user-data.kakao.profile.help': 'Kakaoアカウントのプロフィール情報。',
  'social-connection.settings.user-data.kakao.nickname.help': 'Kakaoアカウントのニックネーム。',
  'social-connection.settings.user-data.kakao.image.help': 'プロファイル画像のURL。',
  'social-connection.settings.user-data.kakao.email.help': 'Kakaoアカウントの代表メールアドレスユーザーのKakaoアカウントではメールが収集されない場合があります。その場合は、「情報収集後にプロビジョニング」オプションを使用するか、サービス内で内部的に収集してください。ユーザーのKakaoアカウントのメールアドレスが認証されていない可能性があります。認証されたメールのみを使用する必要がある場合は、未認証のメールがないユーザーの確認プロセスを続行します。',
  'social-connection.settings.user-data.kakao.name.help': 'Kakaoアカウントの名前。',
  'social-connection.settings.user-data.kakao.gender.help': 'Kakaoアカウントの性別',
  'social-connection.settings.user-data.kakao.age-range.help': '韓国の年齢に基づくKakaoアカウントの年齢範囲。',
  'social-connection.settings.user-data.kakao.birthday.help': 'Kakaoアカウントの誕生日。',
  'social-connection.settings.user-data.kakao.birthyear.help': 'Kakaoアカウントの誕生年。',
  'social-connection.settings.user-data.kakao.phone.help': 'Kakaoアカウントの電話番号。',
  'social-connection.settings.user-data.kakao.id.help': '暗号化ユーザーID値。IDは、同じユーザーがすでに会員データベースに登録されているかどうかを確認する場合にのみ使用できます。',
  'social-connection.settings.user-data.kakao.address.help': 'Kakaoアカウントの配送先情報。',
  'social-connection.settings.user-data.kakao.link.help': 'Kakao StoryのプロフィールURL。',
  'social-connection.settings.user-data.linkedin.public-profile.help': '名前、写真、見出し、公開プロフィールURLなど、認証されたメンバーの基本プロフィールを読み取ります。',
  'social-connection.settings.user-data.linkedin.profile.help': '認証されたメンバーの名前、見出し、写真を取得します。',
  'social-connection.settings.user-data.linkedin.email.help': '認証されたメンバーのプライマリメールアドレスを取得します。',
  'social-connection.settings.user-data.mailru.public-profile.help': '名前、写真、誕生日などのフィールドを含む、認証されたユーザーの基本プロファイルを読み取ります。',
  'social-connection.settings.user-data.microsoft.public-profile.help': 'ユーザーがアプリにサインインすることを許可し、サインインしたユーザーのプロフィールの読み込み権限をアプリに与えます。また、サインインしたユーザーの基本的な会社情報の読み込み権限をアプリに与えます。',
  'social-connection.settings.user-data.microsoft.other-profile.help': 'サインインしたユーザーに代わって、組織内の他のユーザーの基本的なプロファイルプロパティの読み込み権限をアプリに与えます。これには、表示名、名字、メールアドレス、オッペン拡張子、写真などが含まれます。また、サインインしたユーザーの完全プロフィールの読み込み権限をアプリに与えます。',
  'social-connection.settings.user-data.microsoft.profile.help': 'サインインしたユーザーに代わって、組織内の他のユーザーのプロファイルプロパティ、レポート、マネージャーのフルセットの読み込み権限をアプリに与えます。',
  'social-connection.settings.user-data.ok.profile.help': 'ほとんどのメソッドを呼び出すに必要な基本権限。',
  'social-connection.settings.user-data.ok.email.help': 'ユーザーメールアドレスへのアクセス権',
  'social-connection.settings.user-data.ok.long-token.help': 'OAuth認証から長い有効期限のトークンを取得する。',
  'social-connection.settings.user-data.paypal.openid.help': '基本認証。',
  'social-connection.settings.user-data.paypal.profile.help': 'ユーザーのフルネームにアクセスします。',
  'social-connection.settings.user-data.paypal.email.help': 'ユーザーのメールアドレスにアクセスします。',
  'social-connection.settings.user-data.paypal.address.help': 'ユーザーのフルアドレスにアクセスします。',
  'social-connection.settings.user-data.paypal.id.help': 'PayPalアカウントID（支払人ID）とアカウント認証ステータスにアクセスします。',
  'social-connection.settings.user-data.qq.profile.help': 'ログインしているユーザーのニックネーム、アバター、性別を取得します。',
  'social-connection.settings.user-data.reddit.profile.help': 'ユーザーのredditユーザー名と登録日にアクセスします。',
  'social-connection.settings.user-data.twitch.email.help': 'ユーザーのメールアドレスを表示します。',
  'social-connection.settings.user-data.vimeo.public-profile.help': '公開のメンバーデータにアクセスします。',
  'social-connection.settings.user-data.vimeo.profile.help': 'プライベートのメンバーデータにアクセスします。公開以外のScopeでは必須です。',
  'social-connection.settings.user-data.vk.email.help': 'ユーザーのメールにアクセスします。',
  'social-connection.settings.user-data.wechat.profile.help': '基本的なログインScope。ウェブアプリケーションは現在、snsapi_loginだけを入力します。',
  'social-connection.settings.user-data.weibo.email.help': 'ユーザーの連絡先メールアドレス。',
  'social-connection.settings.user-data.yahoo.profile.help': 'プロフィール情報。',
  'social-connection.settings.user-data.yahoo.email.help': 'メールアドレス。',

  'social-connection.settings.permission.baidu.files.help': 'パーソナルクラウドストレージに保存されているユーザーデータを取得します。',
  'social-connection.settings.permission.baidu.send-messages.help': 'ユーザーのBaiduホームページにメッセージリマインダーを送信します。',
  'social-connection.settings.permission.discord.activities:read.help': 'ユーザーの「再生中/再生履歴」リストからデータを取得することをアプリに許可します。Discordの承認が必須です。',
  'social-connection.settings.permission.discord.activities:write.help': 'アプリにユーザーのアクティビティの更新を許可します。Discordの承認が必須です。(GAMESDKアクティビティマネージャーには不要）。',
  'social-connection.settings.permission.discord.applications-builds:read.help': 'ユーザーのアプリケーションのビルドデータの読み取りをアプリに許可します。',
  'social-connection.settings.permission.discord.applications-builds:upload.help': 'ユーザーのアプリケーションのビルドをアップロード/更新することをアプリに許可します。Discordの承認が必須です。',
  'social-connection.settings.permission.discord.applications-commands.help': 'ギルド内でのコマンドの使用をアプリに許可します。',
  'social-connection.settings.permission.discord.applications-commands:update.help': 'このベアラートークンを使用してアプリにコマンドの更新を許可します。クライアント認証情報が付与されるだけです。',
  'social-connection.settings.permission.discord.applications-entitlements.help': 'ユーザーのアプリケーションのエンタイトルメントを読み取ることをアプリに許可します。',
  'social-connection.settings.permission.discord.applications-store:update.help': 'ユーザーのアプリケーションのストアデータ（SKU、ストアの掲載情報、実績など）の読み取りと更新をアプリに許可します。',
  'social-connection.settings.permission.discord.bot.help': 'oauth2ボットの場合、デフォルトでユーザーが選択したギルドにボットが配置されます。',
  'social-connection.settings.permission.discord.gdm:join.help': 'アプリがユーザーをグループdmに参加することを許可します。',
  'social-connection.settings.permission.discord.guilds:join.help': '/guilds/{guild.id}/members/{user.id}を使用してユーザーをギルドに参加することを許可します。',
  'social-connection.settings.permission.discord.messages:read.help': 'local rpc server apiのアクセスは、すべてのクライアントチャンネルからメッセージを読み取ることができます（それ以外の場合は、アプリが作成するチャンネル/ギルドに制限されます）。',
  'social-connection.settings.permission.discord.relationships:read.help': 'ユーザーのフレンドと暗黙の関係をアプリに知らせる - Discordの承認が必要。',
  'social-connection.settings.permission.discord.rpc.help': 'local rpc server apiのアクセスは、ユーザーのローカルDiscordクライアントを制御できます。Discordの承認が必要です。',
  'social-connection.settings.permission.discord.rpc-activities:write.help': 'local rpc server apiのアクセスは、ユーザーのアクティビティを更新できます。Discordの承認が必要です。',
  'social-connection.settings.permission.discord.rpc-notifications:read.help': 'local rpc server apiのアクセスは、ユーザーにプッシュされた通知を受け取ることができます。Discordの承認が必要です。',
  'social-connection.settings.permission.discord.rpc-voice:read.help': 'local rpc server apiのアクセスは、ユーザーの音声設定を読み取り、音声イベントをリッスンできます。Discordの承認が必要です。',
  'social-connection.settings.permission.discord.rpc-voice:write.help': 'local rpc server apiのアクセスは、ユーザーの音声設定を更新できます。Discordの承認が必要です。',
  'social-connection.settings.permission.discord.webhook-incoming.help': 'これにより、認証コードグラントのoauthトークン応答で返されるウェブフックが生成されます。',
  'social-connection.settings.permission.discord.identify:premium.help': 'ユーザーがアクティブなNitroサブスクリプションを保有しているかどうか （premium_typeフィールド） を返します。これにはDiscordの承認が必要です。',
  'social-connection.settings.permission.epicgames.friends.help': '現在のユーザーのアカウントの友達リストへの読み取りアクセス権を許可します。',
  'social-connection.settings.permission.epicgames.presence:write.help': '現在のユーザーのオンラインプレゼンスを設定し、フレンドからオンラインプレゼンスの更新を受信することをアプリケーションに許可します。',
  'social-connection.settings.permission.facebook.messenger-contact.help': 'user_messenger_contact権限により、企業がビジネスのページとのチャットスレッドの承認または開始時に、Messengerを介して個人に連絡することができます。',
  'social-connection.settings.permission.facebook.photos.help': 'user_photos権限により、アプリがユーザーがFacebookにアップロードした写真を読み取ることができます。',
  'social-connection.settings.permission.facebook.posts.help': 'user_posts権限により、アプリがタイムラインでユーザーが投稿した投稿にアプリがアクセスすることができます。',
  'social-connection.settings.permission.facebook.videos.help': 'user_videos権限により、アプリがあるユーザーがアップロードした動画のリストをアプリで読み取ることができます。',
  'social-connection.settings.permission.facebook.friends.help': 'user_friends権限により、アプリがそのアプリを使用しているユーザーの友達のリストを取得できます。',
  'social-connection.settings.permission.facebook.ads:read.help': 'ads_read権限により、アプリがAds Insights APIにアクセスし、この権限を通じて所有している、または他の広告アカウントの所有者からアクセス権を付与された広告アカウントの広告レポート情報を取得することができます。',
  'social-connection.settings.permission.facebook.ads:write.help': 'ads_management権限により、アプリは、所有している、または広告アカウントの所有者からアクセス権を付与された広告アカウントの読み取りと管理の両方をアプリに許可します。',
  'social-connection.settings.permission.facebook.attribution:read.help': 'attribution_read権限により、所有しているまたは他のビジネスラインの所有者またはアクセス権を付与されたビジネスラインのアトリビューションレポートデータを取得するために、Attribution APIへのアクセスがアプリに付与されます。',
  'social-connection.settings.permission.facebook.business:write.help': 'business_management権限により、Business Manager APIを使用したアプリの読み取りと書き込み権が許可されます。',
  'social-connection.settings.permission.facebook.catalog:write.help': 'catalog_management権限により、アプリがユーザーが管理者である企業所有の製品カタログを作成、読み取り、更新、削除することができます。',
  'social-connection.settings.permission.facebook.gaming-user_locale.help': 'gaming_user_locale権限により、ユーザーがFacebookでゲーム（インスタントゲームやクラウドゲームなど）をプレイしているときに、アプリがユーザーの優先言語を取得することができます。',
  'social-connection.settings.permission.facebook.groups:read.help': 'groups_access_member_info権限により、投稿者がアプリへのアクセスを許可している場合、公開されているグループメンバー情報（名前やIDなど）をアプリで読み取ることができます。',
  'social-connection.settings.permission.facebook.instagram:publish.help': 'instagram_content_publish権限により、アプリはビジネスユーザーに代わってオーガニックフィード、写真、動画の投稿を作成できます。',
  'social-connection.settings.permission.facebook.instagram-comments:write.help': 'instagram_manage_comments権限により、ページにリンクされたInstagramアカウントに代わって、アプリがコメントを作成、削除、非表示することができます。',
  'social-connection.settings.permission.facebook.instagram-insights:write.help': 'instagram_manage_insights権限により、アプリはFacebookページにリンクされた Instagram アカウントのインサイトにアクセスすることができます。',
  'social-connection.settings.permission.facebook.leads:read.help': 'leads_retrieval権限により、Ads ManagerまたはMarketing APIで作成された広告に関連付けられているリード広告フォームでキャプチャされたすべての情報をアプリで取得し、読み取ることができます。',
  'social-connection.settings.permission.facebook.pages-events.help': 'page_events権限により、アプリを使用するユーザーが管理するFacebookページに代わってイベントをログに記録し、そのイベントをFacebookに送信して広告のターゲティング、最適化、レポート作成を行う権限が付与されます。',
  'social-connection.settings.permission.facebook.ads-pages:write.help': 'pages_manage_ads権限により、アプリがページに関連付けられた広告を管理できます。',
  'social-connection.settings.permission.facebook.cta:write.help': 'pages_manage_cta権限により、Facebookページのコールトゥアクションのボタンの管理に使用されるエンドポイントでPOSTおよびDELETE関数をアプリが実行することができます。',
  'social-connection.settings.permission.facebook.pages-articles:write.help': 'pages_manage_instant_articles権限により、アプリを使用するユーザーが管理するFacebookページに代わって、アプリがインスタント記事を管理することができます。',
  'social-connection.settings.permission.facebook.pages-engagement:write.help': 'pages_manage_engagement権限により、アプリがページに投稿されたコメントを作成、編集、削除できます。',
  'social-connection.settings.permission.facebook.pages-metadata:write.help': 'pages_manage_metadata権限により、アプリがページ上のアクティビティに関するウェブフックを購読して受信し、ページ上の設定を更新できます。',
  'social-connection.settings.permission.facebook.pages-posts:write.help': 'pages_manage_posts権限により、アプリがページ投稿を作成、編集、削除できます。',
  'social-connection.settings.permission.facebook.pages-messaging.help': 'pages_messaging権限により、アプリがMessengerのページ会話を管理し、アクセスすることができます。',
  'social-connection.settings.permission.facebook.pages-engagement:read.help': 'pages_read_engagement権限により、アプリがページが投稿したコンテンツ（投稿、写真、ビデオ、イベント）の読み取り、フォロワーデータ（名前、PSID）、プロフィール画像の読み取り、ページに関するメタデータやその他のインサイトの読み取りを行うことができます。',
  'social-connection.settings.permission.facebook.pages-content:read.help': 'pages_read_user_content権限により、アプリがユーザーや他のページによる投稿、コメント、評価など、ページ上のユーザー生成コンテンツを読み取り、またはページ投稿に対するユーザーコメントを削除することができます。',
  'social-connection.settings.permission.facebook.pages-list.help': 'pages_show_list権限により、アプリがユーザーが管理するページのリストをアクセスすることができます。',
  'social-connection.settings.permission.facebook.pages-gender.help': 'pages_user_gender権限により、アプリが接続されているページからユーザーの性別にアクセスすることができます。',
  'social-connection.settings.permission.facebook.pages-locale.help': 'Pages_user_gender権限により、アプリが接続されているページからユーザーの性別にアクセスすることができます。',
  'social-connection.settings.permission.facebook.pages-timezone.help': 'pages_user_timezone権限により、アプリが接続されているページを通じて、ユーザーのタイムゾーンへのアクセス権がアプリに付与されます。',
  'social-connection.settings.permission.facebook.groups:write.help': 'publish_to_groups権限により、アプリへのアクセス権が付与されている場合、そのユーザーに代わってアプリがグループにコンテンツを投稿することができます。',
  'social-connection.settings.permission.facebook.video:write.help': 'publish_video権限により、アプリがライブ動画をアプリユーザーのタイムライン、グループ、イベント、またはページに公開することができます。',
  'social-connection.settings.permission.facebook.insights:read.help': 'read_insights権限により、アプリがそのユーザーが所有するページ、アプリ、ウェブドメインのInsightsデータを読み取ることができます。',
  'social-connection.settings.permission.facebook.research-apis.help': 'research_apis権限により、アプリがFacebookオープンリサーチと透明性ツール内の公開Facebookページ、グループ、イベントのデータにアクセスできます。',
  'social-connection.settings.permission.github.user.help': 'プロファイル情報のみに対する読み取り/書き込みアクセス権を付与します。このScopeにはuser: emailとuser: followが含まれることに注意してください。',
  'social-connection.settings.permission.github.users-follow:write.help': '他のユーザーをフォローまたはフォロー解除するためのアクセス権を付与します。',
  'social-connection.settings.permission.github.repo.help': 'プライベートリポジトリを含むリポジトリへのフルアクセス権を付与します。これには、コード、コミット状況、リポジトリや組織のプロジェクト、招待、共同作業者、チームメンバーの追加、デプロイ状況への読み取り/書き込みアクセス権、またはリポジトリや組織のウェブフックなどが含まれます。また、ユーザープロジェクトを管理する機能も付与します。',
  'social-connection.settings.permission.github.repo:status.help': 'パブリックリポジトリとプライベートリポジトリのコミットステータスへの読み取り/書き込みアクセス権を付与します。このScopeは、コードへのアクセスを許可せずに、他のユーザーまたはサービスにプライベートリポジトリのコミットステータスへのアクセス権を付与する場合にのみ必要です。',
  'social-connection.settings.permission.github.repo_deployment.help': 'パブリックリポジトリとプライベートリポジトリのデプロイステータスへのアクセス権を付与します。このScopeは、コードへのアクセス権を付与せずに、他のユーザーまたはサービスにデプロイステータスへのアクセス権を付与する場合にのみ必要です。',
  'social-connection.settings.permission.github.public_repo.help': 'パブリックリポジトリへのアクセスを制限します。これには、コード、コミット状況、リポジトリプロジェクト、共同作業者、公開リポジトリや組織のデプロイ状況などへの読み取り/書き込みアクセス権が含まれます。パブリックリポジトリのスターリングにも必要です。',
  'social-connection.settings.permission.github.repo:invite.help': 'リポジトリで共同作業するための招待を受け入れる/拒否する機能を付与します。このScopeは、他のユーザーやサービスがコードにアクセスすることなく、招待にアクセスすることを許可するためにのみ必要です。',
  'social-connection.settings.permission.github.security_events.help': 'グラント：コードスキャンAPIのセキュリティイベントへの読み取りおよび書き込みアクセス権、シークレットスキャンAPIのセキュリティイベントへの読み取りおよび書き込みアクセス権。このScopeは、コードへのアクセスを許可せずに、他のユーザーまたはサービスにセキュリティイベントへのアクセス権を付与する場合にのみ必要です。',
  'social-connection.settings.permission.github.admin:repo_hook.help': 'パブリックまたはプライベートリポジトリのリポジトリフックに対する読み取り、書き込み、ping、削除のアクセス権を付与します。リポジトリとpublic_repoScopeは、リポジトリフックを含むリポジトリへのフルアクセス権を付与します。Adminを使用する：repo_hookScopeで、リポジトリフックのみにアクセスを制限することができます。',
  'social-connection.settings.permission.github.write:repo_hook.help': 'パブリックまたはプライベートリポジトリのフックに対する読み取り、書き込み、pingのアクセス権を付与します。',
  'social-connection.settings.permission.github.read:repo_hook.help': 'パブリックまたはプライベートリポジトリのフックに対する読み取りおよびpingのアクセス権を付与します。',
  'social-connection.settings.permission.github.admin:org.help': '組織とそのチーム、プロジェクト、メンバーシップを完全に管理します。',
  'social-connection.settings.permission.github.write:org.help': '組織メンバーシップ、組織プロジェクト、およびチームメンバーシップに対する読み取りおよび書き込みアクセス権',
  'social-connection.settings.permission.github.read:org.help': '組織メンバーシップ、組織プロジェクト、およびチームメンバーシップへの読み取り専用アクセス権。',
  'social-connection.settings.permission.github.admin:public_key.help': '公開鍵を完全に管理します。',
  'social-connection.settings.permission.github.write:public_key.help': '公開鍵の詳細を作成、一覧表示、および表示します。',
  'social-connection.settings.permission.github.read:public_key.help': '公開鍵のリストを表示し、詳細を確認します。',
  'social-connection.settings.permission.github.admin:org_hook.help': '組織のフックに対する読み取り、書き込み、ping、削除のアクセス権を付与します。注：OAuthトークンは、OAuthアプリによって作成された組織フックに対してのみ、これらのアクションを実行できます。個人アクセストークンは、ユーザーが作成した組織フックに対してのみこれらのアクションを実行できます。',
  'social-connection.settings.permission.github.gist.help': 'Gistへの書き込みアクセス権を付与します。',
  'social-connection.settings.permission.github.notifications.help': 'グラント：ユーザーの通知に対する読み取りアクセス権、スレッドへの読み取りアクセスとしてマークする、リポジトリへのアクセス監視と監視解除アクセス権、スレッドサブスクリプションへの読み取り、書き込み、削除アクセス権を付与します。',
  'social-connection.settings.permission.github.delete_repo.help': '管理可能なリポジトリを削除するアクセス権を付与します。',
  'social-connection.settings.permission.github.write:discussion.help': 'チームディスカッションの読み取りおよび書き込みアクセス権を許可します。',
  'social-connection.settings.permission.github.read:discussion.help': 'チームディスカッションの読み取りアクセス権を許可します。',
  'social-connection.settings.permission.github.write:packages.help': 'GitHub Packagesでパッケージをアップロードまたは公開するアクセス権を付与します。詳しい情報については、「パッケージの公開」を参照してください。',
  'social-connection.settings.permission.github.read:packages.help': 'GitHub Packagesからパッケージをダウンロードまたはインストールするアクセス権を付与します。詳しい情報については「パッケージのインストール」を参照してください。',
  'social-connection.settings.permission.github.delete:packages.help': 'GitHub Packagesからパッケージを削除するアクセス権を付与します。詳しい情報については、「パッケージの削除と復元」を参照してください。',
  'social-connection.settings.permission.github.admin:gpg_key.help': 'GPGキーを完全に管理します。',
  'social-connection.settings.permission.github.write:gpg_key.help': 'GPGキーの作成、一覧表示、詳細表示を行います。',
  'social-connection.settings.permission.github.read:gpg_key.help': 'GPGキーの詳細を一覧表示して表示します。',
  'social-connection.settings.permission.github.codespace.help': 'コードスペースの作成と管理機能を付与します。コードスペースは、異なるScopeを持つ可能性のあるGITHUB_TOKENを公開することができます。詳しくは「コードスペースのセキュリティ」をご覧ください。',
  'social-connection.settings.permission.github.workflow.help': 'GitHub Actionsワークフローファイルを追加および更新する権限を付与します。同じリポジトリ内の別のブランチに同じファイル（パスと内容の両方が同じファイル）が存在する場合、このScopeなしでワークフローファイルをコミットできます。ワークフローファイルは異なるScopeのセットを持つGITHUB_TOKENを公開できます。',
  'social-connection.settings.permission.google.cloud-platform.help': 'Google Cloud Platformサービス全体のデータを表示して管理します。',
  'social-connection.settings.permission.google.adsense.help': 'AdSenseデータを表示して管理します。',
  'social-connection.settings.permission.google.analytics.help': 'Googleアナリティクスのデータを表示および管理します。',
  'social-connection.settings.permission.google.appengine:admin.help': 'Google App Engineにデプロイされたアプリケーションを表示して管理します。',
  'social-connection.settings.permission.google.mail:send.help': 'Gmailからすべてのメールを読んだり、作成したり、送信したり、完全に削除したりできます。',
  'social-connection.settings.permission.google.bigquery.help': 'Google BigQueryでデータを表示および管理します。',
  'social-connection.settings.permission.google.blogger.help': 'Bloggerアカウントを管理します。',
  'social-connection.settings.permission.google.books.help': 'ブックを管理します。',
  'social-connection.settings.permission.google.calendar:write.help': 'Googleカレンダーを使用してアクセスできるすべてのカレンダーを表示、編集、共有、完全に削除できます。',
  'social-connection.settings.permission.google.ddmconversions.help': 'DoubleClickデジタルマーケティングのコンバージョンを管理します。',
  'social-connection.settings.permission.google.bigtable.help': 'Cloud Bigtableテーブルとクラスターを管理します。',
  'social-connection.settings.permission.google.content.help': 'Googleショッピングの商品リストとアカウントを管理します。',
  'social-connection.settings.permission.google.display-video.help': 'ディスプレイ＆ビデオ360のエンティティとレポートを作成、表示、編集、および完全に削除します。',
  'social-connection.settings.permission.google.doubleclickbidmanager.help': 'DoubleClick Bid Managerでレポートを表示および管理します。',
  'social-connection.settings.permission.google.files:write.help': 'Googleドライブのファイルをすべて表示、編集、作成、削除します。',
  'social-connection.settings.permission.google.firebase.help': 'Firebaseのすべてのデータと設定を表示、管理します。',
  'social-connection.settings.permission.google.fitness.help': 'Google Fitの身体活動データを表示して追加します。',
  'social-connection.settings.permission.google.ediscovery.help': 'eDiscoveryデータを管理します。',
  'social-connection.settings.permission.google.classroom.help': 'Google Classroomのクラスを管理します。',
  'social-connection.settings.permission.google.documents.help': 'Google Docsのドキュメントを表示して管理します。',
  'social-connection.settings.permission.google.androidpublisher.help': 'Google Playデベロッパーアカウントを表示および管理します。',
  'social-connection.settings.permission.google.games.help': 'Google Playゲームのアクティビティを作成、編集、削除します。',
  'social-connection.settings.permission.google.webmasters.help': '検証済みサイトのSearch Consoleデータを表示および管理します。',
  'social-connection.settings.permission.google.presentations.help': 'Google Slidesのプレゼンテーションを表示および管理します。',
  'social-connection.settings.permission.google.spreadsheets.help': 'Google Driveでスプレッドシートを表示、編集、作成、削除します。',
  'social-connection.settings.permission.google.manufacturercenter.help': 'Google Manufacturer Centerの商品リストを管理します。',
  'social-connection.settings.permission.google.contacts:write.help': '連絡先を表示、編集、ダウンロード、および完全に削除します。',
  'social-connection.settings.permission.google.photoslibrary.help': 'Google Photosライブラリを表示および管理します。',
  'social-connection.settings.permission.google.tagmanager.help': 'Google Tag Managerコンテナとそのサブコンポーネント（バージョニングと公開を除く）を管理します。',
  'social-connection.settings.permission.google.tasks.help': 'すべてのタスクを作成、編集、整理、削除します。',
  'social-connection.settings.permission.google.youtube.help': 'YouTubeアカウントを管理します。',
  'social-connection.settings.permission.kakao.friends.help': 'KakaoTalkの友達情報。',
  'social-connection.settings.permission.kakao.plusfriends.help': 'Relationship between a Kakao Talk Channel and a user.',
  'social-connection.settings.permission.kakao.story:read.help': 'KakaoStoryの投稿への読み取りアクセス。',
  'social-connection.settings.permission.kakao.story:publish.help': 'KakaoStoryに投稿を公開します。',
  'social-connection.settings.permission.kakao.talk:message.help': 'KakaoTalkでメッセージを送る。',
  'social-connection.settings.permission.linkedin.social-user:write.help': '認証されたメンバーに代わって投稿、コメント、投稿をいいねします。',
  'social-connection.settings.permission.linkedin.social-org:write.help': '組織に代わって投稿、コメント、投稿をいいねします。',
  'social-connection.settings.permission.linkedin.social-org:read.help': '組織の投稿、コメント、いいね履歴を取得します。',
  'social-connection.settings.permission.linkedin.ads:write.help': '認証されたメンバーの広告アカウントを管理し、読み取ります。',
  'social-connection.settings.permission.linkedin.ads:read.help': '認証されたメンバーの広告アカウントを読み取ります。',
  'social-connection.settings.permission.linkedin.ads-report:read.help': '広告アカウントのレポートを取得します。',
  'social-connection.settings.permission.linkedin.ads-leads:read.help': '認証されたメンバーのLead Gen Formsにアクセスし、リードを取得します。',
  'social-connection.settings.permission.linkedin.connections-1st:view.help': '認証されたメンバーの第1度の関係を取得します。',
  'social-connection.settings.permission.linkedin.audience:write.help': '一致したAudienceを作成および管理します。',
  'social-connection.settings.permission.mailru.photoslibrary.help': 'ユーザーの写真ライブラリを表示および管理します。',
  'social-connection.settings.permission.mailru.guestbook.help': 'ユーザーのゲストブックへのエントリーを管理します。',
  'social-connection.settings.permission.mailru.pages-posts:write.help': 'ユーザーの「新着情報」フィードに投稿します。',
  'social-connection.settings.permission.mailru.messages:write.help': 'ユーザーのプライベートメッセージへのアクセス権。',
  'social-connection.settings.permission.mailru.calendar:read.help': '「マイワールド」でのユーザーイベントへのアクセス権。',
  'social-connection.settings.permission.microsoft.user.help': 'サインインしたユーザーの完全なプロフィールの読み込み権限をアプリに与えます。また、サインインしたユーザーに代わって、プロフィール情報を更新する権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.users.help': 'サインインしたユーザーに代わって、組織内の他のユーザーのプロファイルプロパティ、レポート、マネージャーのフルセットの読み取りと書き込み権限をアプリに与えます。また、サインインしたユーザーに代わって、アプリがユーザーの作成と削除、ユーザーパスワードの再設定を行う権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.users:invite.help': 'サインインしたユーザーに代わって、ゲストユーザーを組織に招待する権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.users:export.help': 'Company Administratorによって実行された場合、組織ユーザーのデータをエクスポートする権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.users:manage.help': 'サインインしているユーザーがアクセスできる、ユーザーのアカウントに関連付けられたIDの読み取り、更新、削除をアプリケーションに許可します。これにより、ユーザーがサインインできるIDが制御されます。',
  'social-connection.settings.permission.microsoft.activities:read.help': 'メール、会議、チャットセッションに費やした時間など、サインインしたユーザーの活動統計の読み込み権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.apps:read.help': 'アプリカタログにあるアプリの読み込み権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.apps:write.help': 'カタログにあるアプリの作成、読み込み、更新、削除権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.logs:read.help': 'サインインしたユーザーに代わって、監査ログの活動を読み取り、照会権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.bookings:read.help': '読み取り専用アプリケーションを対象としています。典型的なターゲットユーザーは、予約業者の顧客です。',
  'social-connection.settings.permission.microsoft.bookings:write.help': 'フルアクセスをアプリに与えます。完全な管理を体験することを意図しています。典型的なターゲットユーザーは、組織の管理者です。',
  'social-connection.settings.permission.microsoft.calendar:read.help': 'ユーザーのカレンダーにあるイベントの読み取り権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.calendar:write.help': 'ユーザーカレンダーのイベントの作成、読み込み、更新、削除権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.call.help': 'サインインしているユーザーでなくとも、1人のユーザーに発信したり、組織のディレクトリにあるユーザーに電話を転送する権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.call-group.help': 'サインインしたユーザーでなくとも、複数のユーザーに発信したり、組織内の会議に参加者を追加する権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.messages:read.help': 'ユーザーに代わってMicrosoft Teamsの1対1またはグループチャットのメッセージを読むことをアプリに許可します。',
  'social-connection.settings.permission.microsoft.messages:write.help': 'ユーザーに代わってMicrosoft Teamsの1対1またはグループチャットメッセージの読み取りと送信をアプリに許可します。',
  'social-connection.settings.permission.microsoft.contacts:read.help': 'アプリによるユーザーの連絡先の読み取り権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.contacts:write.help': 'ユーザーの連絡先の作成、読み取り、更新、削除権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.device:read.help': 'サインインしているユーザーに代わって、ユーザーのデバイスリストの読み取り権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.files:read.help': 'サインインしたユーザーのファイルの読み取り権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.files:write.help': 'サインインしたユーザーのファイルの読み取り、作成、更新、削除権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.mail:read.help': 'ユーザーのメールボックスにあるメールの読み取り権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.mail:write.help': 'ユーザーメールボックス内のメールの作成、読み取り、更新、削除権限をアプリに与えます。メールを送信する権限は含まれません。',
  'social-connection.settings.permission.microsoft.mail:send.help': 'アプリが組織内のユーザーとしてメールを送信する権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.notes:read.help': 'OneNoteのノートブックやセクションのタイトルをアプリの読み取り権限、サインインしたユーザーに代わって新しいページ、ノートブック、セクションの作成権限をアプリに与えます。',
  'social-connection.settings.permission.microsoft.notes:write.help': 'サインインしたユーザーに代わって、アプリがOneNoteノートブックを読み、共有し、修正する権限を許可します。',
  'social-connection.settings.permission.microsoft.presence:read.help': 'サインインしたユーザーに代わって、プレゼンス情報の読み取り権限をアプリに与えます。プレゼンス情報には、アクティビティ、アベイラビリティ、ステータスノート、カレンダーアウトオフオフメッセージ、タイムゾーン、場所が含まれます。',
  'social-connection.settings.permission.microsoft.presence:write.help': 'サインインしたユーザーに代わって、プレゼンス情報の読み取り権限またはアクティビティとアベイラビリティの書き込み権限をアプリに与えます。プレゼンス情報には、アクティビティ、アベイラビリティ、ステータスノート、カレンダーアウトオフオフメッセージ、タイムゾーン、場所が含まれます。',
  'social-connection.settings.permission.microsoft.tasks:read.help': 'ユーザーと共有されたものを含め、サインインしたユーザーのタスクとタスクリストの読み取り権限をアプリに与えます。作成、削除、更新の権限は含まれません。',
  'social-connection.settings.permission.microsoft.tasks:write.help': 'ユーザーと共有されたものを含め、サインインしたユーザーのタスクとタスクリストの作成、読み取り、更新、削除権限をアプリに与えます。',
  'social-connection.settings.permission.ok.photos.help': 'ユーザー写真へのアクセス権。',
  'social-connection.settings.permission.ok.groups.help': 'ユーザーのグループへのアクセス権。',
  'social-connection.settings.permission.ok.videos.help': 'ユーザー動画へのアクセス権。',
  'social-connection.settings.permission.ok.application:invite.help': 'friends.appInvite方法を使って友達をゲームに招待する権限。',
  'social-connection.settings.permission.reddit.user.help': 'プリファレンスや関連するアカウント情報を更新します。メールアドレスやパスワードにアクセスすることはありません。',
  'social-connection.settings.permission.reddit.credits.help': '私のredditゴールドクレジットを使って他のユーザーにゴールドを贈る.',
  'social-connection.settings.permission.reddit.pages-engagement:write.help': '自分のコメントや投稿を編集して削除します。',
  'social-connection.settings.permission.reddit.flair.help': '私のsubredditフレアを選択してください.提出物のリンクフレアを変更する.',
  'social-connection.settings.permission.reddit.votes:read.help': '自分の投票履歴や、保存または非表示にしたコメントや投稿にアクセスします。',
  'social-connection.settings.permission.reddit.live-threads:read.help': 'コントリビュートするライブスレッドの設定とコントリビュータを管理します。',
  'social-connection.settings.permission.reddit.modconfig.help': '構成、サイドバー、モデレートされたsubredditを管理します。',
  'social-connection.settings.permission.reddit.modcontributors.help': '承認済みユーザーリストにユーザーを追加/削除し、モデレートされたsubredditからユーザーを禁止/禁止解除またはミュート/ミュート解除します。',
  'social-connection.settings.permission.reddit.modflair.help': 'モデレートされたsubredditでフレアを管理して割り当てます。',
  'social-connection.settings.permission.reddit.modlog.help': 'モデレートされたsubredditでモデレートログにアクセスします。',
  'social-connection.settings.permission.reddit.modmail.help': 'mod.reddit.com経由でmodmailにアクセスして管理します。',
  'social-connection.settings.permission.reddit.modothers.help': 'モデレートされたsubredditから他のモデレーターを招待または削除します。',
  'social-connection.settings.permission.reddit.modposts.help': 'モデレートされたsubredditでのコンテンツを承認、削除、nsfwをマークして区別します。',
  'social-connection.settings.permission.reddit.modself.help': 'subredditをモデレートするための招待を受け入れます。モデレートされたsubredditのモデレーターまたはコントリビューターとして、自分自身を削除します。',
  'social-connection.settings.permission.reddit.modwiki.help': 'モデレートされたsubredditで編集者とウィキページの可視性を変更します。',
  'social-connection.settings.permission.reddit.mysubreddits.help': '私がモデレートし、貢献し、購読するsubredditのリストにアクセスします。',
  'social-connection.settings.permission.reddit.messages:write.help': '受信トレイにアクセスし、他のユーザーにプライベートメッセージを送信します。',
  'social-connection.settings.permission.reddit.pages-engagement:read.help': 'マイアカウントから投稿やコメントにアクセスします。',
  'social-connection.settings.permission.reddit.report.help': 'ルール違反の内容を報告します。個々の提出物を非表示または表示します。',
  'social-connection.settings.permission.reddit.save.help': 'コメントと提出物を保存および保存解除します。',
  'social-connection.settings.permission.reddit.structuredstyles.help': 'モデレートされたsubredditで構造化スタイルを編集します。',
  'social-connection.settings.permission.reddit.submit.help': 'マイアカウントからリンクとコメントを送信します。',
  'social-connection.settings.permission.reddit.subscribe.help': 'subredditサブスクリプションを管理します。私がフォローしているコンテンツを持つユーザー ‐ 「友達」を管理します。',
  'social-connection.settings.permission.reddit.vote.help': 'コメントと投稿に対する私の投票を送信して変更します。',
  'social-connection.settings.permission.reddit.wiki:edit.help': '私に代わってWikiページを編集します。',
  'social-connection.settings.permission.reddit.wiki:read.help': '私のアカウントからWikiページを読みます。',
  'social-connection.settings.permission.twitch.user.help': 'ユーザーオブジェクトを管理します。',
  'social-connection.settings.permission.twitch.users-follow:read.help': 'ユーザーがフォローしているチャンネルのリストを表示します。',
  'social-connection.settings.permission.twitch.user-subscriptions:read.help': '承認されたユーザーが特定のチャンネルに登録しているかどうかを表示します。',
  'social-connection.settings.permission.twitch.user-block:read.help': 'ユーザーのブロックリストを表示します。',
  'social-connection.settings.permission.twitch.user-block:write.help': 'ユーザーのブロックリストを管理します。',
  'social-connection.settings.permission.twitch.bits:read.help': 'チャネルのBits情報を表示します。',
  'social-connection.settings.permission.twitch.analytics-extensions.help': '認証済みアカウントが所有するTwitch拡張機能の分析データを表示します。',
  'social-connection.settings.permission.twitch.analytics-games.help': '認証済みアカウントが所有するゲームの分析データを表示します。',
  'social-connection.settings.permission.twitch.channel:edit:commercial.help': 'チャンネルでコマーシャルを実行します。',
  'social-connection.settings.permission.twitch.channel:manage:broadcast.help': 'チャンネル設定の更新、ストリームマーカーとストリームタグの管理など、チャンネルのブロードキャスト設定を管理します。',
  'social-connection.settings.permission.twitch.channel:manage:extensions.help': '拡張機能の有効化など、チャンネルの拡張設定を管理します。',
  'social-connection.settings.permission.twitch.channel:manage:polls.help': 'チャンネルの投票を管理します。',
  'social-connection.settings.permission.twitch.channel:manage:predictions.help': 'チャンネルのチャンネルポイント予測を管理します。',
  'social-connection.settings.permission.twitch.channel:manage:redemptions.help': 'チャンネルポイントのカスタムリワードとその引き換えをチャンネルで管理できます。',
  'social-connection.settings.permission.twitch.channel:manage:schedule.help': 'チャンネルの配信スケジュールを管理します。',
  'social-connection.settings.permission.twitch.channel:manage:videos.help': '動画の削除など、チャンネルの動画を管理します。',
  'social-connection.settings.permission.twitch.channel:read:editors.help': 'チャンネルの編集者ロールを持つユーザーのリストを表示します。',
  'social-connection.settings.permission.twitch.channel:read:goals.help': 'チャンネルの作成者目標を表示します。',
  'social-connection.settings.permission.twitch.channel:read:hype_train.help': 'チャンネルのハイプトレイン情報を表示します。',
  'social-connection.settings.permission.twitch.channel:read:polls.help': 'チャンネルのアンケートを表示します。',
  'social-connection.settings.permission.twitch.channel:read:predictions.help': 'チャンネルのチャンネルポイント予測を表示します。',
  'social-connection.settings.permission.twitch.channel:read:redemptions.help': 'チャンネルポイントのカスタムリワードとその引き換えをチャンネルで確認できます。',
  'social-connection.settings.permission.twitch.channel:read:stream_key.help': '承認されたユーザーのストリームキーを表示します。',
  'social-connection.settings.permission.twitch.channel:read:subscriptions.help': 'チャンネルに登録しているすべての登録者のリストを表示し、ユーザーがチャンネルに登録しているかどうかを確認します。',
  'social-connection.settings.permission.twitch.clips:edit.help': 'チャンネルのクリップを管理します。',
  'social-connection.settings.permission.twitch.moderation:read.help': 'モデレーター、禁止、タイムアウト、Automod設定など、チャンネルのモデレートデータを表示します。',
  'social-connection.settings.permission.twitch.moderator:manage:banned_users.help': 'ユーザーを禁止および禁止解除します。',
  'social-connection.settings.permission.twitch.moderator:read:blocked_terms.help': 'ブロードキャスターのブロックされた用語のリストを表示します。',
  'social-connection.settings.permission.twitch.moderator:manage:blocked_terms.help': 'ブロードキャスターのブロックされた用語のリストを管理する',
  'social-connection.settings.permission.twitch.moderator:manage:automod.help': '自分がモデレーターになっているチャンネルでAutoModがレビュー用に保持しているメッセージを管理します。',
  'social-connection.settings.permission.twitch.moderator:read:automod_settings.help': 'ブロードキャスターのAutoMod設定を表示します。',
  'social-connection.settings.permission.twitch.moderator:manage:automod_settings.help': 'ブロードキャスターのAutoMod設定を管理します。',
  'social-connection.settings.permission.twitch.moderator:read:chat_settings.help': 'ブロードキャスターのチャットルーム設定を表示します。',
  'social-connection.settings.permission.twitch.moderator:manage:chat_settings.help': 'ブロードキャスターのチャットルーム設定を管理します。',
  'social-connection.settings.permission.vimeo.promo-codes:vimeo.help': 'Vimeoオンデマンドプロモーションを追加、削除、レビューする',
  'social-connection.settings.permission.vimeo.upload:vimeo.help': '動画をアップロードします。',
  'social-connection.settings.permission.vimeo.interact:vimeo.help': '動画を高く評価したり、メンバーをフォローしたりするなど、Vimeoのリソースとやり取りできます。',
  'social-connection.settings.permission.vimeo.delete:vimeo.help': '動画を含む既存のVimeoリソースを削除します。',
  'social-connection.settings.permission.vimeo.edit:vimeo.help': '動画を含む既存のVimeoリソースを編集します。',
  'social-connection.settings.permission.vimeo.create:vimeo.help': 'ショーケース、グループ、チャンネル、ポートフォリオなど、新しいVimeoリソースを作成します。新しい動画を作成するには、アップロード範囲が必要です。',
  'social-connection.settings.permission.vimeo.purchased:vimeo.help': 'メンバーのVimeoオンデマンド購入履歴にアクセスします。',
  'social-connection.settings.permission.vimeo.files:write.help': 'Vimeo Pro以上のメンバーシップを持つメンバーが所有する動画ファイルにアクセスします。',
  'social-connection.settings.permission.vk.notify.help': 'ユーザーは通知を送信することを許可しています（flash/iframeアプリケーションの場合）。',
  'social-connection.settings.permission.vk.relationships:read.help': '友達へのアクセス権。',
  'social-connection.settings.permission.vk.photos.help': '写真へのアクセス権。',
  'social-connection.settings.permission.vk.audio.help': '録音へのアクセス権。',
  'social-connection.settings.permission.vk.videos.help': 'ビデオレコーディングへのアクセス権。',
  'social-connection.settings.permission.vk.stories.help': '友達へのアクセス権。',
  'social-connection.settings.permission.vk.posts.help': 'Wikiページへのアクセス権。',
  'social-connection.settings.permission.vk.status.help': 'ユーザーステータスへのアクセス権。',
  'social-connection.settings.permission.vk.notes.help': 'ノートへのアクセス権。',
  'social-connection.settings.permission.vk.messages:write.help': 'メッセージを操作する高度な方法へのアクセス（スタンドアロンアプリケーションのみ、[合格モデレーション]（リファレンス/ロードマップ）。',
  'social-connection.settings.permission.vk.wall.help': '一般的または高度なウォール技術へアクセスします。このアクセス権は、既定ではサイトでは使用できません。',
  'social-connection.settings.permission.vk.ads:write.help': '広告 API を操作する高度な方法へのアクセス。インプリシットフローまたは承認コードフロースキームによる承認に使用できます。',
  'social-connection.settings.permission.vk.offline.help': 'いつでもAPIにアクセスできます（このオプションを使用すると、access_tokenと同時に返されるexpires_inパラメータには、0または無限のトークンが含まれる）。Open APIには適用されません。',
  'social-connection.settings.permission.vk.files.help': 'ドキュメントへのアクセス権。',
  'social-connection.settings.permission.vk.groups.help': 'ユーザーグループへのアクセス権',
  'social-connection.settings.permission.vk.notifications.help': 'ユーザーへの応答に関する通知にアクセスします。',
  'social-connection.settings.permission.vk.groups:stats.help': '管理者であるユーザーのグループとアプリケーションの統計にアクセスします。',
  'social-connection.settings.permission.vk.market.help': '商品へのアクセス権。',
  'social-connection.settings.permission.weibo.all.help': '以下のすべてのScope権限をリクエストしてください。',
  'social-connection.settings.permission.weibo.messages:write.help': 'プライベートメッセージ送信インターフェイス。',
  'social-connection.settings.permission.weibo.messages:read.help': 'プライベートメッセージ読み取りインターフェイス。',
  'social-connection.settings.permission.weibo.application:invite.help': 'インターフェースを送信するための招待状。',
  'social-connection.settings.permission.weibo.groups:read.help': '友達グループは、インターフェイスグループを読み取ります。',
  'social-connection.settings.permission.weibo.groups:write.help': '友達グループは、インターフェイスグループを書きます。',
  'social-connection.settings.permission.weibo.status.help': 'Weiboがインターフェイスグループを読み取るように方向付けます。',
  'social-connection.settings.permission.yahoo.contacts:read.help': '連絡先。',
  'social-connection.settings.permission.yahoo.contacts:write.help': '連絡先。',
  'social-connection.settings.permission.yahoo.fantasy-sport:read.help': 'Fantasy Sports。',
  'social-connection.settings.permission.yahoo.fantasy-sport:write.help': 'Fantasy Sports。',
  'social-connection.settings.permission.yahoo.finance:read.help': 'ファイナンス。',
  'social-connection.settings.permission.yahoo.finance:write.help': 'ファイナンス。',
  'social-connection.settings.permission.yahoo.ads:write.help': 'Oath Ad Platforms。',
  'social-connection.settings.permission.yahoo.ads-publishers:read.help': 'パブリッシャー向けのOath Ad Platforms。',
  'social-connection.settings.permission.yahoo.messages:write.help': 'Messenger.',

  'legal-settings.breadcrumb.label': '法的設定',
  'legal-settings.tabs.terms-and-policies': '規約と方針',
  'legal-settings.tabs.age-restrictions': '年齢制限',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=407%3A32764
  'terms-and-policies.settings.title': '規約と方針',
  'terms-and-policies.settings.subtitle': '規制を遵守し、ユーザーとの法的関係を定義するために、規約とポリシーへのリンクを提供します。ユーザーは、ログインウィジェット画面にこれらのリンクを見ることができます。',
  'terms-and-policies.tos-url.input.title': '利用規約のURL（必須）',
  'terms-and-policies.privacy-policy-url.input.title': 'プライバシーポリシーURL',
  'terms-and-policies.cookies-policy-url.input.title': 'クッキーポリシーURL',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=8380%3A132843
  'age-restrictions.settings.title': '年齢制限',
  'age-restrictions.settings.subtitle': 'ログインプロジェクトに年齢制限を設定します。エクソーラはユーザーの生年月日を保存し、登録ユーザーのための追加ステップを回避します。',
  'age-restrictions.settings.notification': '年齢制限を設定した場合、ユーザーはサインアップ時にウィジェット内の入力フィールドから生年月日を提供する必要があります。このフィールドは、<a>ユーザー情報の補足設定</a>で有効にする必要があります。',
  'age-restrictions.settings.all-countries.label': '最低年齢｜全ての国',
  'age-restrictions.settings.specific-countries.label': '特定国の年齢制限',
  'age-restrictions.settings.specific-countries.placeholder': '国を選択する',
  'age-restrictions.settings.country.placeholder': '年齢要件',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=5435-99581
  'widget-customization.breadcrumb.label': 'カスタマイゼーション',
  'widget-customization.tabs.widget': 'ウィジェット',
  'widget-customization.tabs.email': 'メール',
  'widget-customization.tabs.sms': 'SMS',
  'widget-customization.settings.title': 'ウィジェットカスタマイゼーション',
  'widget-customization.settings.subtitle': 'ユーザーのためのサインアップとログインのウィジェットを作成し、カスタマイズすることができます。',
  'widget-customization.settings.bar.label': 'ウィジェット',
  'widget-customization.settings.bar.select-method.passwordless': 'パスワードレスログイン',
  'widget-customization.settings.bar.select-method.classic': 'クラシックログイン',
  'widget-customization.settings.bar.select-method.social': 'ソーシャルログイン',
  'widget-customization.settings.bar.select-mode': 'プレビュー',
  'widget-customization.settings.bar.customize': 'カスタマイズ',
  'widget-customization.settings.preview-code.copy': 'コードをコピーする',
  'widget-customization.settings.language.title': '言語',
  'widget-customization.settings.language.description': 'ウィジェットには、対応する言語のいずれかを選択することができます。',
  'widget-customization.settings.language.notification': 'また、ウィジェット初期化コードの<o>preferredLocale</o>オプションで言語を変更することも可能です。<br></br>言語が選択されていない場合は、ユーザーのIPアドレスに応じた言語が自動的に設定されます。',
  'widget-customization.settings.provided-language.title': '対応する言語',
  'widget-customization.settings.provided-language.description': '<a>言語実装について詳しくはこちら</a>。',
  'widget-customization.settings.placeholder.autodetected': '自動判別',
  'widget-customization.settings.country.title': '国',
  'widget-customization.settings.country.description': '国を選択すると、選択した国でソーシャルネットワークの利用者数を降順に整列したリストが表示されます。',
  'widget-customization.settings.country.notification': '<a>ソーシャルランキングを開き</a>、ソーシャルネットワークのカスタムオーダーを作成します。',
  'widget-customization.settings.country-select.title': '国',
  'widget-customization.settings.oauth.title': 'OAuth 2.0クライアント',
  'widget-customization.settings.oauth.description': 'ウィジェット用に作成したOAuth 2.0クライアントを1つ選択できます。',
  'widget-customization.settings.oauth.dropdown.none': 'なし',
  'widget-customization.settings.provided-oauth.title': '利用可能なOAuth 2.0クライアント',
  'widget-customization.settings.visual.title': '追加のカスタマイズ',
  'widget-customization.settings.visual.description': 'CSSは、ウィジェットエディターでのスタイルと共に適用されます。',
  'widget-customization.settings.visual.custom-styles.title': 'カスタムのCSSスタイル',
  'widget-customization.settings.visual.custom-styles.placeholder': 'CSSをアップロード',
  'widget-customization.settings.language-select.language.ru': 'ロシア語',
  "widget-customization.settings.language-select.language.en": "英語",
  "widget-customization.settings.language-select.language.cn": "中国語（簡体字）",
  "widget-customization.settings.language-select.language.ko": "韓国語",
  "widget-customization.settings.language-select.language.es": "スペイン語",
  "widget-customization.settings.language-select.language.fr": "フランス語",
  "widget-customization.settings.language-select.language.pt": "ポルトガル語",
  "widget-customization.settings.language-select.language.it": "イタリア語",
  "widget-customization.settings.language-select.language.de": "ドイツ語",
  "widget-customization.settings.language-select.language.he": "ヘブライ語",
  "widget-customization.settings.language-select.language.ar": "アラビア語",
  "widget-customization.settings.language-select.language.tw": "中国語（繁体字）",
  "widget-customization.settings.language-select.language.vi": "ベトナム語",
  "widget-customization.settings.language-select.language.cs": "チェコ語",
  "widget-customization.settings.language-select.language.pl": "ポーランド語",
  "widget-customization.settings.language-select.language.bg": "ブルガリア語",
  "widget-customization.settings.language-select.language.ro": "ルーマニア語",
  "widget-customization.settings.language-select.language.tr": "トルコ語",
  "widget-customization.settings.language-select.language.th": "タイ語",
  "widget-customization.settings.language-select.language.ja": "日本語",
  "widget-customization.settings.language-select.language.ph": "タガログ語",
  "widget-customization.settings.language-select.language.ne": "ネパール語",
  "widget-customization.settings.language-select.language.my": "ビルマ語",
  "widget-customization.settings.language-select.language.lo": "ラオス語",
  "widget-customization.settings.language-select.language.km": "クメール語",
  "widget-customization.settings.language-select.language.id": "インドネシア語",
  'widget-customization.old.instruction': '<ul><ol>1. <a1>SCSSのテンプレート</a1>をダウンロード。</ol><ol>2. カスタマイズしてCSSを生成。（詳しくは<a2>ガイド</a2>へ）</ol><ol>3. CSSをアップロード。</ol></ul>',
  'widget-customization.old.upload_css.placeholder': 'CSSをアップロード',

  'email-customization.settings.bar.label': 'メール',
  'email-customization.settings.bar.options.verificationCode': '確認メール（コード付き）',
  'email-customization.settings.bar.options.verificationLinkCode': '確認メール（リンクとコード付き）',
  'email-customization.settings.bar.options.mfaCode': 'MFAコードメール',
  'email-customization.settings.bar.options.mfaSettingsChange': 'MFA設定変更メール',
  'email-customization.settings.bar.options.welcome': 'ウェルカムメール',
  'email-customization.settings.bar.options.passwordChange': 'パスワード変更メール',
  'email-customization.settings.bar.options.blockedAccount': 'アカウントブロックメール',
  'email-customization.settings.bar.options.registrationConfirm': '登録確認メール',
  'email-customization.settings.bar.options.emailChange': 'メールアドレス変更メール',
  'email-customization.settings.bar.options.newsSubscribe': 'ニュース購読メール',
  'email-customization.settings.bar.options.custom': 'カスタムメール',
  'email-customization.title': 'メールのカスタマゼーション',
  'email-customization.subtitle': 'ユーザーに送信するメールをカスタマイズできます。',
  'email-customization.settings.label': 'メール設定',
  'email-customization.settings.send-from.label': '送信者の名前',
  'email-customization.settings.send-from.footer': 'この名前は、受信者があなたからのメールを受信したときに表示されます。',
  'email-customization.settings.send-from.placeholder': 'no-reply@xsolla.com',
  'email-customization.settings.send-from.notification': 'メールをカスタマイズしない場合、エクソーラのデフォルトテンプレートが使用されます。',
  'passkey.settings.title': 'パスキー',
  'passkey.settings.subtitle': "パスキーはユーザーのデバイスに保存され、指紋、顔、またはデバイスのPINでロックを解除します。これは追加のログイン方法であり、すでに使用している方法を置き換えるものではありません。",
  'passkey.settings.usage.title': 'パスキーの使用',
  'passkey.settings.usage.subtitle': '有効にすると、ユーザーはサインインした後にパスキーを作成でき、次回訪問時にそれを使用できるようになります。',
  'passkey.settings.toggle.title': 'パスキーを許可',
  'passkey.settings.toggle.description': '少なくとも別のログイン方法を一つ以上有効なままにしてください。パスキーだけをプロジェクトへの唯一のログイン方法にすることはできません。'
};

module.exports = localizations;
